import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  ChallengeRessourceRessourcesDynamicZoneInput: any;
  DefiReglementDynamicZoneInput: any;
  DefiRessourcesDynamicZoneInput: any;
  FormationRessourcesDynamicZoneInput: any;
  PedagogieRessourcesDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Academie = {
  __typename?: 'Academie';
  name?: Maybe<Scalars['String']>;
  lycees?: Maybe<LyceeRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AcademieLyceesArgs = {
  filters?: Maybe<LyceeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AcademieEntity = {
  __typename?: 'AcademieEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Academie>;
};

export type AcademieEntityResponse = {
  __typename?: 'AcademieEntityResponse';
  data?: Maybe<AcademieEntity>;
};

export type AcademieEntityResponseCollection = {
  __typename?: 'AcademieEntityResponseCollection';
  data: Array<AcademieEntity>;
  meta: ResponseCollectionMeta;
};

export type AcademieFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  lycees?: Maybe<LyceeFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<AcademieFiltersInput>>>;
  or?: Maybe<Array<Maybe<AcademieFiltersInput>>>;
  not?: Maybe<AcademieFiltersInput>;
};

export type AcademieInput = {
  name?: Maybe<Scalars['String']>;
  lycees?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type AcademieName = {
  __typename?: 'AcademieName';
  name: Scalars['String'];
};

export type AddedCommande = {
  __typename?: 'AddedCommande';
  commande: CommandeResult;
  sherlock?: Maybe<Sherlock>;
};

export type AvailableQuiz = {
  __typename?: 'AvailableQuiz';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  quizlet?: Maybe<Scalars['String']>;
  isAnsweredByUser?: Maybe<Scalars['Boolean']>;
  users?: Maybe<Array<Maybe<UserIdType>>>;
};

export type Avatar = {
  __typename?: 'Avatar';
  name?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFileEntityResponse>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AvatarUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AvatarEntity = {
  __typename?: 'AvatarEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Avatar>;
};

export type AvatarEntityResponse = {
  __typename?: 'AvatarEntityResponse';
  data?: Maybe<AvatarEntity>;
};

export type AvatarEntityResponseCollection = {
  __typename?: 'AvatarEntityResponseCollection';
  data: Array<AvatarEntity>;
  meta: ResponseCollectionMeta;
};

export type AvatarFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<AvatarFiltersInput>>>;
  or?: Maybe<Array<Maybe<AvatarFiltersInput>>>;
  not?: Maybe<AvatarFiltersInput>;
};

export type AvatarInput = {
  name?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type AvatarMedia = {
  __typename?: 'AvatarMedia';
  media?: Maybe<Url>;
};

export type AvatarMediaUrl = {
  __typename?: 'avatarMediaUrl';
  url?: Maybe<Scalars['String']>;
};

export type AvatarMediaWinnersUser = {
  __typename?: 'AvatarMediaWinnersUser';
  url?: Maybe<Scalars['String']>;
};

export type AvatarWinnersUser = {
  __typename?: 'AvatarWinnersUser';
  id?: Maybe<Scalars['ID']>;
  media?: Maybe<AvatarMediaWinnersUser>;
};

export type AwardsList = {
  __typename?: 'AwardsList';
  category?: Maybe<Scalars['String']>;
  lots?: Maybe<Scalars['String']>;
  recompenses_winners?: Maybe<Array<Maybe<WinnersUser>>>;
};

export type BooleanFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  or?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  not?: Maybe<BooleanFilterInput>;
  eq?: Maybe<Scalars['Boolean']>;
  eqi?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
  startsWith?: Maybe<Scalars['Boolean']>;
  endsWith?: Maybe<Scalars['Boolean']>;
  contains?: Maybe<Scalars['Boolean']>;
  notContains?: Maybe<Scalars['Boolean']>;
  containsi?: Maybe<Scalars['Boolean']>;
  notContainsi?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Boolean']>;
  gte?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['Boolean']>;
  lte?: Maybe<Scalars['Boolean']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  between?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type Categorieproduit = {
  __typename?: 'Categorieproduit';
  name?: Maybe<Scalars['String']>;
  produits?: Maybe<ProduitRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategorieproduitProduitsArgs = {
  filters?: Maybe<ProduitFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CategorieproduitEntity = {
  __typename?: 'CategorieproduitEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Categorieproduit>;
};

export type CategorieproduitEntityResponse = {
  __typename?: 'CategorieproduitEntityResponse';
  data?: Maybe<CategorieproduitEntity>;
};

export type CategorieproduitEntityResponseCollection = {
  __typename?: 'CategorieproduitEntityResponseCollection';
  data: Array<CategorieproduitEntity>;
  meta: ResponseCollectionMeta;
};

export type CategorieproduitFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  produits?: Maybe<ProduitFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CategorieproduitFiltersInput>>>;
  or?: Maybe<Array<Maybe<CategorieproduitFiltersInput>>>;
  not?: Maybe<CategorieproduitFiltersInput>;
};

export type CategorieproduitInput = {
  name?: Maybe<Scalars['String']>;
  produits?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type CategorieproduitRelationResponseCollection = {
  __typename?: 'CategorieproduitRelationResponseCollection';
  data: Array<CategorieproduitEntity>;
};

export type Challenge = {
  __typename?: 'Challenge';
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_end?: Maybe<Scalars['DateTime']>;
  current?: Maybe<Scalars['Boolean']>;
  cavente?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Float']>;
  qteca?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Float']>;
  qterebond?: Maybe<Scalars['Float']>;
  qtequiz?: Maybe<Scalars['Float']>;
  challengetypes?: Maybe<ChallengetypeRelationResponseCollection>;
  classes?: Maybe<ClasseRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChallengeChallengetypesArgs = {
  filters?: Maybe<ChallengetypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengeClassesArgs = {
  filters?: Maybe<ClasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengeEntity = {
  __typename?: 'ChallengeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Challenge>;
};

export type ChallengeEntityResponse = {
  __typename?: 'ChallengeEntityResponse';
  data?: Maybe<ChallengeEntity>;
};

export type ChallengeEntityResponseCollection = {
  __typename?: 'ChallengeEntityResponseCollection';
  data: Array<ChallengeEntity>;
  meta: ResponseCollectionMeta;
};

export type ChallengeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  desc?: Maybe<StringFilterInput>;
  date_start?: Maybe<DateTimeFilterInput>;
  date_end?: Maybe<DateTimeFilterInput>;
  current?: Maybe<BooleanFilterInput>;
  cavente?: Maybe<FloatFilterInput>;
  nbvente?: Maybe<FloatFilterInput>;
  venterebond?: Maybe<FloatFilterInput>;
  pro?: Maybe<FloatFilterInput>;
  quiz?: Maybe<FloatFilterInput>;
  moyennegenerale?: Maybe<FloatFilterInput>;
  qtevente?: Maybe<FloatFilterInput>;
  qteca?: Maybe<FloatFilterInput>;
  qtepro?: Maybe<FloatFilterInput>;
  qterebond?: Maybe<FloatFilterInput>;
  qtequiz?: Maybe<FloatFilterInput>;
  challengetypes?: Maybe<ChallengetypeFiltersInput>;
  classes?: Maybe<ClasseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ChallengeFiltersInput>>>;
  or?: Maybe<Array<Maybe<ChallengeFiltersInput>>>;
  not?: Maybe<ChallengeFiltersInput>;
};

export type ChallengeInput = {
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  date_start?: Maybe<Scalars['DateTime']>;
  date_end?: Maybe<Scalars['DateTime']>;
  current?: Maybe<Scalars['Boolean']>;
  cavente?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Float']>;
  qteca?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Float']>;
  qterebond?: Maybe<Scalars['Float']>;
  qtequiz?: Maybe<Scalars['Float']>;
  challengetypes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ChallengeRelationResponseCollection = {
  __typename?: 'ChallengeRelationResponseCollection';
  data: Array<ChallengeEntity>;
};

export type ChallengeRessource = {
  __typename?: 'ChallengeRessource';
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  ressource_type?: Maybe<ChallengeRessourceTypeEntityResponse>;
  challengetypes?: Maybe<ChallengetypeRelationResponseCollection>;
  revervedToProf?: Maybe<Scalars['Boolean']>;
  ressources?: Maybe<Array<Maybe<ChallengeRessourceRessourcesDynamicZone>>>;
  niveau?: Maybe<NiveauRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChallengeRessourceChallengetypesArgs = {
  filters?: Maybe<ChallengetypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengeRessourceNiveauArgs = {
  filters?: Maybe<NiveauFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengeRessourceEntity = {
  __typename?: 'ChallengeRessourceEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<ChallengeRessource>;
};

export type ChallengeRessourceEntityResponse = {
  __typename?: 'ChallengeRessourceEntityResponse';
  data?: Maybe<ChallengeRessourceEntity>;
};

export type ChallengeRessourceEntityResponseCollection = {
  __typename?: 'ChallengeRessourceEntityResponseCollection';
  data: Array<ChallengeRessourceEntity>;
  meta: ResponseCollectionMeta;
};

export type ChallengeRessourceFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  desc?: Maybe<StringFilterInput>;
  subtitle?: Maybe<StringFilterInput>;
  info?: Maybe<StringFilterInput>;
  order?: Maybe<IntFilterInput>;
  ressource_type?: Maybe<ChallengeRessourceTypeFiltersInput>;
  challengetypes?: Maybe<ChallengetypeFiltersInput>;
  revervedToProf?: Maybe<BooleanFilterInput>;
  niveau?: Maybe<NiveauFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ChallengeRessourceFiltersInput>>>;
  or?: Maybe<Array<Maybe<ChallengeRessourceFiltersInput>>>;
  not?: Maybe<ChallengeRessourceFiltersInput>;
};

export type ChallengeRessourceInput = {
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  ressource_type?: Maybe<Scalars['ID']>;
  challengetypes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  revervedToProf?: Maybe<Scalars['Boolean']>;
  ressources?: Maybe<
    Array<Scalars['ChallengeRessourceRessourcesDynamicZoneInput']>
  >;
  niveau?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ChallengeRessourceRelationResponseCollection = {
  __typename?: 'ChallengeRessourceRelationResponseCollection';
  data: Array<ChallengeRessourceEntity>;
};

export type ChallengeRessourceRessourcesDynamicZone =
  | ComponentRessourcesRessourceLien
  | ComponentRessourcesRessourceMedia
  | Error;

export type ChallengeRessources = {
  __typename?: 'ChallengeRessources';
  name?: Maybe<Scalars['String']>;
};

export type ChallengeRessourceType = {
  __typename?: 'ChallengeRessourceType';
  name?: Maybe<Scalars['String']>;
  challenge_ressources?: Maybe<ChallengeRessourceRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChallengeRessourceTypeChallenge_RessourcesArgs = {
  filters?: Maybe<ChallengeRessourceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengeRessourceTypeEntity = {
  __typename?: 'ChallengeRessourceTypeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<ChallengeRessourceType>;
};

export type ChallengeRessourceTypeEntityResponse = {
  __typename?: 'ChallengeRessourceTypeEntityResponse';
  data?: Maybe<ChallengeRessourceTypeEntity>;
};

export type ChallengeRessourceTypeEntityResponseCollection = {
  __typename?: 'ChallengeRessourceTypeEntityResponseCollection';
  data: Array<ChallengeRessourceTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type ChallengeRessourceTypeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  challenge_ressources?: Maybe<ChallengeRessourceFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ChallengeRessourceTypeFiltersInput>>>;
  or?: Maybe<Array<Maybe<ChallengeRessourceTypeFiltersInput>>>;
  not?: Maybe<ChallengeRessourceTypeFiltersInput>;
};

export type ChallengeRessourceTypeInput = {
  name?: Maybe<Scalars['String']>;
  challenge_ressources?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ChallengeRessourceTypeWithRelatedChallengeRessources = {
  __typename?: 'ChallengeRessourceTypeWithRelatedChallengeRessources';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  challenge_ressources?: Maybe<Array<Maybe<ChallengeRessources>>>;
};

export type Challengetype = {
  __typename?: 'Challengetype';
  name?: Maybe<Scalars['String']>;
  challenges?: Maybe<ChallengeRelationResponseCollection>;
  challenge_ressources?: Maybe<ChallengeRessourceRelationResponseCollection>;
  pedagogies?: Maybe<PedagogieRelationResponseCollection>;
  produits?: Maybe<ProduitRelationResponseCollection>;
  formations?: Maybe<FormationRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ChallengetypeChallengesArgs = {
  filters?: Maybe<ChallengeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengetypeChallenge_RessourcesArgs = {
  filters?: Maybe<ChallengeRessourceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengetypePedagogiesArgs = {
  filters?: Maybe<PedagogieFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengetypeProduitsArgs = {
  filters?: Maybe<ProduitFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengetypeFormationsArgs = {
  filters?: Maybe<FormationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChallengetypeEntity = {
  __typename?: 'ChallengetypeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Challengetype>;
};

export type ChallengetypeEntityResponse = {
  __typename?: 'ChallengetypeEntityResponse';
  data?: Maybe<ChallengetypeEntity>;
};

export type ChallengetypeEntityResponseCollection = {
  __typename?: 'ChallengetypeEntityResponseCollection';
  data: Array<ChallengetypeEntity>;
  meta: ResponseCollectionMeta;
};

export type ChallengetypeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  challenges?: Maybe<ChallengeFiltersInput>;
  challenge_ressources?: Maybe<ChallengeRessourceFiltersInput>;
  pedagogies?: Maybe<PedagogieFiltersInput>;
  produits?: Maybe<ProduitFiltersInput>;
  formations?: Maybe<FormationFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ChallengetypeFiltersInput>>>;
  or?: Maybe<Array<Maybe<ChallengetypeFiltersInput>>>;
  not?: Maybe<ChallengetypeFiltersInput>;
};

export type ChallengetypeInput = {
  name?: Maybe<Scalars['String']>;
  challenges?: Maybe<Array<Maybe<Scalars['ID']>>>;
  challenge_ressources?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pedagogies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  produits?: Maybe<Array<Maybe<Scalars['ID']>>>;
  formations?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ChallengetypeRelationResponseCollection = {
  __typename?: 'ChallengetypeRelationResponseCollection';
  data: Array<ChallengetypeEntity>;
};

export type Classe = {
  __typename?: 'Classe';
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['DateTime']>;
  fin?: Maybe<Scalars['DateTime']>;
  operationid?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  filliere?: Maybe<FilliereEntityResponse>;
  niveau?: Maybe<NiveauEntityResponse>;
  lycee?: Maybe<LyceeEntityResponse>;
  challenge?: Maybe<ChallengeEntityResponse>;
  quizchances?: Maybe<QuizchanceRelationResponseCollection>;
  noteclasse?: Maybe<NoteclasseEntityResponse>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  commandes?: Maybe<CommandeRelationResponseCollection>;
  studentsNotes?: Maybe<NoteRelationResponseCollection>;
  quiztonotes?: Maybe<QuiztonoteRelationResponseCollection>;
  ong?: Maybe<Enum_Classe_Ong>;
  percentDedicatedToOng?: Maybe<Scalars['Int']>;
  objectif?: Maybe<ComponentObjectifObjectif>;
  bdcRecu?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClasseQuizchancesArgs = {
  filters?: Maybe<QuizchanceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClasseUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClasseCommandesArgs = {
  filters?: Maybe<CommandeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClasseStudentsNotesArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClasseQuiztonotesArgs = {
  filters?: Maybe<QuiztonoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClasseEntity = {
  __typename?: 'ClasseEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Classe>;
};

export type ClasseEntityResponse = {
  __typename?: 'ClasseEntityResponse';
  data?: Maybe<ClasseEntity>;
};

export type ClasseEntityResponseCollection = {
  __typename?: 'ClasseEntityResponseCollection';
  data: Array<ClasseEntity>;
  meta: ResponseCollectionMeta;
};

export type ClasseFiliere = {
  __typename?: 'ClasseFiliere';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ClasseFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  debut?: Maybe<DateTimeFilterInput>;
  fin?: Maybe<DateTimeFilterInput>;
  operationid?: Maybe<StringFilterInput>;
  zohoid?: Maybe<StringFilterInput>;
  filliere?: Maybe<FilliereFiltersInput>;
  niveau?: Maybe<NiveauFiltersInput>;
  lycee?: Maybe<LyceeFiltersInput>;
  challenge?: Maybe<ChallengeFiltersInput>;
  quizchances?: Maybe<QuizchanceFiltersInput>;
  noteclasse?: Maybe<NoteclasseFiltersInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  commandes?: Maybe<CommandeFiltersInput>;
  studentsNotes?: Maybe<NoteFiltersInput>;
  quiztonotes?: Maybe<QuiztonoteFiltersInput>;
  ong?: Maybe<StringFilterInput>;
  percentDedicatedToOng?: Maybe<IntFilterInput>;
  objectif?: Maybe<ComponentObjectifObjectifFiltersInput>;
  bdcRecu?: Maybe<BooleanFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ClasseFiltersInput>>>;
  or?: Maybe<Array<Maybe<ClasseFiltersInput>>>;
  not?: Maybe<ClasseFiltersInput>;
};

export type ClasseInput = {
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['DateTime']>;
  fin?: Maybe<Scalars['DateTime']>;
  operationid?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  filliere?: Maybe<Scalars['ID']>;
  niveau?: Maybe<Scalars['ID']>;
  lycee?: Maybe<Scalars['ID']>;
  challenge?: Maybe<Scalars['ID']>;
  quizchances?: Maybe<Array<Maybe<Scalars['ID']>>>;
  noteclasse?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  commandes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  studentsNotes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quiztonotes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ong?: Maybe<Enum_Classe_Ong>;
  percentDedicatedToOng?: Maybe<Scalars['Int']>;
  objectif?: Maybe<ComponentObjectifObjectifInput>;
  bdcRecu?: Maybe<Scalars['Boolean']>;
};

export type ClasseLycee = {
  __typename?: 'ClasseLycee';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ClasseNiveau = {
  __typename?: 'ClasseNiveau';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ClasseRank = {
  __typename?: 'ClasseRank';
  rank?: Maybe<Scalars['Int']>;
  totalClasses?: Maybe<Scalars['Int']>;
};

export type ClasseRelationResponseCollection = {
  __typename?: 'ClasseRelationResponseCollection';
  data: Array<ClasseEntity>;
};

export type ClassesLyceeWinnersUser = {
  __typename?: 'ClassesLyceeWinnersUser';
  name?: Maybe<Scalars['String']>;
};

export type ClassesWinnersUser = {
  __typename?: 'ClassesWinnersUser';
  lycee?: Maybe<ClassesLyceeWinnersUser>;
};

export type ClasseWithEleves = {
  __typename?: 'ClasseWithEleves';
  name?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  users?: Maybe<Array<Maybe<ElevesWithOrder>>>;
};

export type ClasseWithLycee = {
  __typename?: 'ClasseWithLycee';
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
  operationid?: Maybe<Scalars['String']>;
  lycee?: Maybe<LyceeName>;
};

export type ClasseWithNoteAndStudentsOrders = {
  __typename?: 'ClasseWithNoteAndStudentsOrders';
  ong?: Maybe<Scalars['String']>;
  percentDedicatedToOng?: Maybe<Scalars['Float']>;
  users?: Maybe<Array<Maybe<UserWithNoteAndOrders>>>;
  noteclasse?: Maybe<NotesWithQteca>;
};

export type ClassNote = {
  __typename?: 'ClassNote';
  qteca?: Maybe<Scalars['String']>;
};

export type Client = {
  __typename?: 'Client';
  prenom?: Maybe<Scalars['String']>;
  nom?: Maybe<Scalars['String']>;
  adressefacturation?: Maybe<Scalars['String']>;
  villefacturation?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  livraisonhorslycee?: Maybe<Scalars['Boolean']>;
  adresselivraison?: Maybe<Scalars['String']>;
  villelivraison?: Maybe<Scalars['String']>;
  clientpro?: Maybe<Scalars['Boolean']>;
  nomsociete?: Maybe<Scalars['String']>;
  tva?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['Boolean']>;
  tel?: Maybe<Scalars['String']>;
  cpfacturation?: Maybe<Scalars['String']>;
  cplivraison?: Maybe<Scalars['String']>;
  civilite?: Maybe<Enum_Client_Civilite>;
  civilitelivraison?: Maybe<Enum_Client_Civilitelivraison>;
  nomlivraison?: Maybe<Scalars['String']>;
  prenomlivraison?: Maybe<Scalars['String']>;
  mobilelivraison?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  relaisid?: Maybe<Scalars['String']>;
  nompointrelais?: Maybe<Scalars['String']>;
  isrelais?: Maybe<Scalars['Boolean']>;
  affilie?: Maybe<Scalars['Boolean']>;
  commandes?: Maybe<CommandeRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientCommandesArgs = {
  filters?: Maybe<CommandeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClientEntity = {
  __typename?: 'ClientEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Client>;
};

export type ClientEntityResponse = {
  __typename?: 'ClientEntityResponse';
  data?: Maybe<ClientEntity>;
};

export type ClientEntityResponseCollection = {
  __typename?: 'ClientEntityResponseCollection';
  data: Array<ClientEntity>;
  meta: ResponseCollectionMeta;
};

export type ClientFiltersInput = {
  id?: Maybe<IdFilterInput>;
  prenom?: Maybe<StringFilterInput>;
  nom?: Maybe<StringFilterInput>;
  adressefacturation?: Maybe<StringFilterInput>;
  villefacturation?: Maybe<StringFilterInput>;
  mail?: Maybe<StringFilterInput>;
  livraisonhorslycee?: Maybe<BooleanFilterInput>;
  adresselivraison?: Maybe<StringFilterInput>;
  villelivraison?: Maybe<StringFilterInput>;
  clientpro?: Maybe<BooleanFilterInput>;
  nomsociete?: Maybe<StringFilterInput>;
  tva?: Maybe<StringFilterInput>;
  policy?: Maybe<BooleanFilterInput>;
  tel?: Maybe<StringFilterInput>;
  cpfacturation?: Maybe<StringFilterInput>;
  cplivraison?: Maybe<StringFilterInput>;
  civilite?: Maybe<StringFilterInput>;
  civilitelivraison?: Maybe<StringFilterInput>;
  nomlivraison?: Maybe<StringFilterInput>;
  prenomlivraison?: Maybe<StringFilterInput>;
  mobilelivraison?: Maybe<StringFilterInput>;
  zohoid?: Maybe<StringFilterInput>;
  relaisid?: Maybe<StringFilterInput>;
  nompointrelais?: Maybe<StringFilterInput>;
  isrelais?: Maybe<BooleanFilterInput>;
  affilie?: Maybe<BooleanFilterInput>;
  commandes?: Maybe<CommandeFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ClientFiltersInput>>>;
  or?: Maybe<Array<Maybe<ClientFiltersInput>>>;
  not?: Maybe<ClientFiltersInput>;
};

export type ClientInput = {
  prenom?: Maybe<Scalars['String']>;
  nom?: Maybe<Scalars['String']>;
  adressefacturation?: Maybe<Scalars['String']>;
  villefacturation?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  livraisonhorslycee?: Maybe<Scalars['Boolean']>;
  adresselivraison?: Maybe<Scalars['String']>;
  villelivraison?: Maybe<Scalars['String']>;
  clientpro?: Maybe<Scalars['Boolean']>;
  nomsociete?: Maybe<Scalars['String']>;
  tva?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['Boolean']>;
  tel?: Maybe<Scalars['String']>;
  cpfacturation?: Maybe<Scalars['String']>;
  cplivraison?: Maybe<Scalars['String']>;
  civilite?: Maybe<Enum_Client_Civilite>;
  civilitelivraison?: Maybe<Enum_Client_Civilitelivraison>;
  nomlivraison?: Maybe<Scalars['String']>;
  prenomlivraison?: Maybe<Scalars['String']>;
  mobilelivraison?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  relaisid?: Maybe<Scalars['String']>;
  nompointrelais?: Maybe<Scalars['String']>;
  isrelais?: Maybe<Scalars['Boolean']>;
  affilie?: Maybe<Scalars['Boolean']>;
  commandes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ClientResult = {
  __typename?: 'ClientResult';
  id: Scalars['ID'];
  prenom: Scalars['String'];
  nom: Scalars['String'];
  adressefacturation: Scalars['String'];
  villefacturation: Scalars['String'];
  mail: Scalars['String'];
  policy: Scalars['Boolean'];
  tel: Scalars['String'];
  cpfacturation: Scalars['String'];
  civilite: Enum_Client_Civilite;
  livraisonhorslycee?: Maybe<Scalars['Boolean']>;
  adresselivraison?: Maybe<Scalars['String']>;
  villelivraison?: Maybe<Scalars['String']>;
  clientpro?: Maybe<Scalars['Boolean']>;
  nomsociete?: Maybe<Scalars['String']>;
  cplivraison?: Maybe<Scalars['String']>;
  civilitelivraison?: Maybe<Enum_Client_Civilitelivraison>;
  nomlivraison?: Maybe<Scalars['String']>;
  prenomlivraison?: Maybe<Scalars['String']>;
  mobilelivraison?: Maybe<Scalars['String']>;
  relaisid?: Maybe<Scalars['String']>;
  nompointrelais?: Maybe<Scalars['String']>;
  isrelais?: Maybe<Scalars['Boolean']>;
  affilie?: Maybe<Scalars['Boolean']>;
};

export type Commande = {
  __typename?: 'Commande';
  totalttc?: Maybe<Scalars['Float']>;
  fraislivraison?: Maybe<Scalars['Float']>;
  numerocommande?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  methodepaiement?: Maybe<Enum_Commande_Methodepaiement>;
  payment?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Commande_Status>;
  transactionreference?: Maybe<Scalars['String']>;
  statuspayment?: Maybe<Scalars['String']>;
  commandelines?: Maybe<CommandelineRelationResponseCollection>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
  client?: Maybe<ClientEntityResponse>;
  livraison?: Maybe<Scalars['JSON']>;
  controldate?: Maybe<Scalars['DateTime']>;
  controlled?: Maybe<Scalars['Boolean']>;
  classe?: Maybe<ClasseEntityResponse>;
  customerContributedToTheOng?: Maybe<Scalars['Boolean']>;
  paymentreminder?: Maybe<Scalars['Boolean']>;
  prixTotal?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommandeCommandelinesArgs = {
  filters?: Maybe<CommandelineFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommandeEntity = {
  __typename?: 'CommandeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Commande>;
};

export type CommandeEntityResponse = {
  __typename?: 'CommandeEntityResponse';
  data?: Maybe<CommandeEntity>;
};

export type CommandeEntityResponseCollection = {
  __typename?: 'CommandeEntityResponseCollection';
  data: Array<CommandeEntity>;
  meta: ResponseCollectionMeta;
};

export type CommandeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  totalttc?: Maybe<FloatFilterInput>;
  fraislivraison?: Maybe<FloatFilterInput>;
  numerocommande?: Maybe<StringFilterInput>;
  zohoid?: Maybe<StringFilterInput>;
  methodepaiement?: Maybe<StringFilterInput>;
  payment?: Maybe<BooleanFilterInput>;
  status?: Maybe<StringFilterInput>;
  transactionreference?: Maybe<StringFilterInput>;
  statuspayment?: Maybe<StringFilterInput>;
  commandelines?: Maybe<CommandelineFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  client?: Maybe<ClientFiltersInput>;
  livraison?: Maybe<JsonFilterInput>;
  controldate?: Maybe<DateTimeFilterInput>;
  controlled?: Maybe<BooleanFilterInput>;
  classe?: Maybe<ClasseFiltersInput>;
  customerContributedToTheOng?: Maybe<BooleanFilterInput>;
  paymentreminder?: Maybe<BooleanFilterInput>;
  prixTotal?: Maybe<FloatFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CommandeFiltersInput>>>;
  or?: Maybe<Array<Maybe<CommandeFiltersInput>>>;
  not?: Maybe<CommandeFiltersInput>;
};

export type CommandeInput = {
  totalttc?: Maybe<Scalars['Float']>;
  fraislivraison?: Maybe<Scalars['Float']>;
  numerocommande?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  methodepaiement?: Maybe<Enum_Commande_Methodepaiement>;
  payment?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Commande_Status>;
  transactionreference?: Maybe<Scalars['String']>;
  statuspayment?: Maybe<Scalars['String']>;
  commandelines?: Maybe<Array<Maybe<Scalars['ID']>>>;
  user?: Maybe<Scalars['ID']>;
  client?: Maybe<Scalars['ID']>;
  livraison?: Maybe<Scalars['JSON']>;
  controldate?: Maybe<Scalars['DateTime']>;
  controlled?: Maybe<Scalars['Boolean']>;
  classe?: Maybe<Scalars['ID']>;
  customerContributedToTheOng?: Maybe<Scalars['Boolean']>;
  paymentreminder?: Maybe<Scalars['Boolean']>;
  prixTotal?: Maybe<Scalars['Float']>;
};

export type Commandeline = {
  __typename?: 'Commandeline';
  quantite?: Maybe<Scalars['Int']>;
  zohoid?: Maybe<Scalars['String']>;
  commande?: Maybe<CommandeEntityResponse>;
  produit?: Maybe<ProduitEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommandelineEntity = {
  __typename?: 'CommandelineEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Commandeline>;
};

export type CommandelineEntityResponse = {
  __typename?: 'CommandelineEntityResponse';
  data?: Maybe<CommandelineEntity>;
};

export type CommandelineEntityResponseCollection = {
  __typename?: 'CommandelineEntityResponseCollection';
  data: Array<CommandelineEntity>;
  meta: ResponseCollectionMeta;
};

export type CommandelineFiltersInput = {
  id?: Maybe<IdFilterInput>;
  quantite?: Maybe<IntFilterInput>;
  zohoid?: Maybe<StringFilterInput>;
  commande?: Maybe<CommandeFiltersInput>;
  produit?: Maybe<ProduitFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CommandelineFiltersInput>>>;
  or?: Maybe<Array<Maybe<CommandelineFiltersInput>>>;
  not?: Maybe<CommandelineFiltersInput>;
};

export type CommandelineInput = {
  quantite?: Maybe<Scalars['Int']>;
  zohoid?: Maybe<Scalars['String']>;
  commande?: Maybe<Scalars['ID']>;
  produit?: Maybe<Scalars['ID']>;
};

export type CommandelineRelationResponseCollection = {
  __typename?: 'CommandelineRelationResponseCollection';
  data: Array<CommandelineEntity>;
};

export type CommandeLineResult = {
  __typename?: 'CommandeLineResult';
  id: Scalars['ID'];
  quantite: Scalars['Int'];
  produit: ProduitResult;
};

export type CommandeRelationResponseCollection = {
  __typename?: 'CommandeRelationResponseCollection';
  data: Array<CommandeEntity>;
};

export type CommandeResult = {
  __typename?: 'CommandeResult';
  id: Scalars['ID'];
  createdAt: Scalars['String'];
  fraislivraison: Scalars['Float'];
  prixTotal: Scalars['Float'];
  methodepaiement: Enum_Commande_Methodepaiement;
  transactionreference?: Maybe<Scalars['String']>;
  statuspayment?: Maybe<Scalars['String']>;
  numerocommande: Scalars['String'];
  payment: Scalars['Boolean'];
  customerContributedToTheOng: Scalars['Boolean'];
  totalttc: Scalars['Float'];
  status: Enum_Commande_Status;
  user: User;
  commandelines: Array<Maybe<CommandeLineResult>>;
  client: ClientResult;
};

export type Competence = {
  __typename?: 'Competence';
  name?: Maybe<Scalars['String']>;
  questions?: Maybe<QuestionRelationResponseCollection>;
  quizzes?: Maybe<QuizRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompetenceQuestionsArgs = {
  filters?: Maybe<QuestionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CompetenceQuizzesArgs = {
  filters?: Maybe<QuizFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CompetenceEntity = {
  __typename?: 'CompetenceEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Competence>;
};

export type CompetenceEntityResponse = {
  __typename?: 'CompetenceEntityResponse';
  data?: Maybe<CompetenceEntity>;
};

export type CompetenceEntityResponseCollection = {
  __typename?: 'CompetenceEntityResponseCollection';
  data: Array<CompetenceEntity>;
  meta: ResponseCollectionMeta;
};

export type CompetenceFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  questions?: Maybe<QuestionFiltersInput>;
  quizzes?: Maybe<QuizFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CompetenceFiltersInput>>>;
  or?: Maybe<Array<Maybe<CompetenceFiltersInput>>>;
  not?: Maybe<CompetenceFiltersInput>;
};

export type CompetenceInput = {
  name?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quizzes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type CompetenceRelationResponseCollection = {
  __typename?: 'CompetenceRelationResponseCollection';
  data: Array<CompetenceEntity>;
};

export type ComponentAllergensAllergens = {
  __typename?: 'ComponentAllergensAllergens';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ComponentAllergensAllergensFiltersInput = {
  name?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentAllergensAllergensFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentAllergensAllergensFiltersInput>>>;
  not?: Maybe<ComponentAllergensAllergensFiltersInput>;
};

export type ComponentAllergensAllergensInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ComponentDefiDefiLiens = {
  __typename?: 'ComponentDefiDefiLiens';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ComponentDefiDefiLots = {
  __typename?: 'ComponentDefiDefiLots';
  id: Scalars['ID'];
  category?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ComponentDefiDefiMedia = {
  __typename?: 'ComponentDefiDefiMedia';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFileRelationResponseCollection>;
};

export type ComponentDefiDefiMediaMediaArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentDefiDefiWinners = {
  __typename?: 'ComponentDefiDefiWinners';
  id: Scalars['ID'];
  category?: Maybe<Scalars['String']>;
  lots?: Maybe<Scalars['String']>;
  recompenses_winners?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};

export type ComponentDefiDefiWinnersRecompenses_WinnersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentDefiDefiWinnersFiltersInput = {
  category?: Maybe<StringFilterInput>;
  lots?: Maybe<StringFilterInput>;
  recompenses_winners?: Maybe<UsersPermissionsUserFiltersInput>;
  and?: Maybe<Array<Maybe<ComponentDefiDefiWinnersFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentDefiDefiWinnersFiltersInput>>>;
  not?: Maybe<ComponentDefiDefiWinnersFiltersInput>;
};

export type ComponentDefiDefiWinnersInput = {
  id?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  lots?: Maybe<Scalars['String']>;
  recompenses_winners?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentDefiReglement = {
  __typename?: 'ComponentDefiReglement';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ComponentIngredientsIngredients = {
  __typename?: 'ComponentIngredientsIngredients';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
};

export type ComponentIngredientsIngredientsFiltersInput = {
  name?: Maybe<StringFilterInput>;
  percent?: Maybe<FloatFilterInput>;
  and?: Maybe<Array<Maybe<ComponentIngredientsIngredientsFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentIngredientsIngredientsFiltersInput>>>;
  not?: Maybe<ComponentIngredientsIngredientsFiltersInput>;
};

export type ComponentIngredientsIngredientsInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
};

export type ComponentNotifLinkLink = {
  __typename?: 'ComponentNotifLinkLink';
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
  button: Scalars['Boolean'];
};

export type ComponentNotifLinkLinkFiltersInput = {
  name?: Maybe<StringFilterInput>;
  url?: Maybe<StringFilterInput>;
  button?: Maybe<BooleanFilterInput>;
  and?: Maybe<Array<Maybe<ComponentNotifLinkLinkFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentNotifLinkLinkFiltersInput>>>;
  not?: Maybe<ComponentNotifLinkLinkFiltersInput>;
};

export type ComponentNotifLinkLinkInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  button?: Maybe<Scalars['Boolean']>;
};

export type ComponentObjectifObjectif = {
  __typename?: 'ComponentObjectifObjectif';
  id: Scalars['ID'];
  name: Scalars['String'];
  ca: Scalars['Int'];
};

export type ComponentObjectifObjectifFiltersInput = {
  name?: Maybe<StringFilterInput>;
  ca?: Maybe<IntFilterInput>;
  and?: Maybe<Array<Maybe<ComponentObjectifObjectifFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentObjectifObjectifFiltersInput>>>;
  not?: Maybe<ComponentObjectifObjectifFiltersInput>;
};

export type ComponentObjectifObjectifInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  ca?: Maybe<Scalars['Int']>;
};

export type ComponentProductCharacteristicsProductCharacteristics = {
  __typename?: 'ComponentProductCharacteristicsProductCharacteristics';
  id: Scalars['ID'];
  characteristic?: Maybe<
    Enum_Componentproductcharacteristicsproductcharacteristics_Characteristic
  >;
  value?: Maybe<Scalars['String']>;
};

export type ComponentProductCharacteristicsProductCharacteristicsFiltersInput = {
  characteristic?: Maybe<StringFilterInput>;
  value?: Maybe<StringFilterInput>;
  and?: Maybe<
    Array<
      Maybe<ComponentProductCharacteristicsProductCharacteristicsFiltersInput>
    >
  >;
  or?: Maybe<
    Array<
      Maybe<ComponentProductCharacteristicsProductCharacteristicsFiltersInput>
    >
  >;
  not?: Maybe<
    ComponentProductCharacteristicsProductCharacteristicsFiltersInput
  >;
};

export type ComponentProductCharacteristicsProductCharacteristicsInput = {
  id?: Maybe<Scalars['ID']>;
  characteristic?: Maybe<
    Enum_Componentproductcharacteristicsproductcharacteristics_Characteristic
  >;
  value?: Maybe<Scalars['String']>;
};

export type ComponentRessourcesRessourceLien = {
  __typename?: 'ComponentRessourcesRessourceLien';
  id: Scalars['ID'];
  titre: Scalars['String'];
  lien: Scalars['String'];
  type: ComponentRessourcesRessourceType;
};

export type ComponentRessourcesRessourceMedia = {
  __typename?: 'ComponentRessourcesRessourceMedia';
  id: Scalars['ID'];
  titre: Scalars['String'];
  media: UploadFileRelationResponseCollection;
  type: ComponentRessourcesRessourceType;
};

export type ComponentRessourcesRessourceMediaMediaArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentRessourcesRessourceType = {
  __typename?: 'ComponentRessourcesRessourceType';
  id: Scalars['ID'];
  nom: Enum_Componentressourcesressourcetype_Nom;
};

export type ComponentShoppingMobileShoppingMobile = {
  __typename?: 'ComponentShoppingMobileShoppingMobile';
  id: Scalars['ID'];
  mobile?: Maybe<Enum_Componentshoppingmobileshoppingmobile_Mobile>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentShoppingMobileShoppingMobileFiltersInput = {
  mobile?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentShoppingMobileShoppingMobileFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentShoppingMobileShoppingMobileFiltersInput>>>;
  not?: Maybe<ComponentShoppingMobileShoppingMobileFiltersInput>;
};

export type ComponentShoppingMobileShoppingMobileInput = {
  id?: Maybe<Scalars['ID']>;
  mobile?: Maybe<Enum_Componentshoppingmobileshoppingmobile_Mobile>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentUrlUrl = {
  __typename?: 'ComponentUrlUrl';
  id: Scalars['ID'];
  adresse?: Maybe<Scalars['String']>;
};

export type Config = {
  __typename?: 'Config';
  value?: Maybe<Scalars['String']>;
  name?: Maybe<Enum_Config_Name>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConfigEntity = {
  __typename?: 'ConfigEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Config>;
};

export type ConfigEntityResponse = {
  __typename?: 'ConfigEntityResponse';
  data?: Maybe<ConfigEntity>;
};

export type ConfigEntityResponseCollection = {
  __typename?: 'ConfigEntityResponseCollection';
  data: Array<ConfigEntity>;
  meta: ResponseCollectionMeta;
};

export type ConfigFiltersInput = {
  id?: Maybe<IdFilterInput>;
  value?: Maybe<StringFilterInput>;
  name?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ConfigFiltersInput>>>;
  or?: Maybe<Array<Maybe<ConfigFiltersInput>>>;
  not?: Maybe<ConfigFiltersInput>;
};

export type ConfigInput = {
  value?: Maybe<Scalars['String']>;
  name?: Maybe<Enum_Config_Name>;
};

export type Corbeille = {
  __typename?: 'Corbeille';
  model?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  restaure?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CorbeilleEntity = {
  __typename?: 'CorbeilleEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Corbeille>;
};

export type CorbeilleEntityResponse = {
  __typename?: 'CorbeilleEntityResponse';
  data?: Maybe<CorbeilleEntity>;
};

export type CorbeilleEntityResponseCollection = {
  __typename?: 'CorbeilleEntityResponseCollection';
  data: Array<CorbeilleEntity>;
  meta: ResponseCollectionMeta;
};

export type CorbeilleFiltersInput = {
  id?: Maybe<IdFilterInput>;
  model?: Maybe<StringFilterInput>;
  data?: Maybe<JsonFilterInput>;
  restaure?: Maybe<BooleanFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CorbeilleFiltersInput>>>;
  or?: Maybe<Array<Maybe<CorbeilleFiltersInput>>>;
  not?: Maybe<CorbeilleFiltersInput>;
};

export type CorbeilleInput = {
  model?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  restaure?: Maybe<Scalars['Boolean']>;
};

export type CurrentClasseInfosType = {
  __typename?: 'CurrentClasseInfosType';
  name?: Maybe<Scalars['String']>;
  filiere?: Maybe<Scalars['String']>;
  niveau?: Maybe<Scalars['String']>;
  nbEleves?: Maybe<Scalars['Float']>;
  nbProfs?: Maybe<Scalars['Float']>;
  lycee?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
  objectif?: Maybe<TypeObjective>;
  noteclasse?: Maybe<ClassNote>;
};

export type DateTimeFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  or?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  not?: Maybe<DateTimeFilterInput>;
  eq?: Maybe<Scalars['DateTime']>;
  eqi?: Maybe<Scalars['DateTime']>;
  ne?: Maybe<Scalars['DateTime']>;
  startsWith?: Maybe<Scalars['DateTime']>;
  endsWith?: Maybe<Scalars['DateTime']>;
  contains?: Maybe<Scalars['DateTime']>;
  notContains?: Maybe<Scalars['DateTime']>;
  containsi?: Maybe<Scalars['DateTime']>;
  notContainsi?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  between?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

export type Defi = {
  __typename?: 'Defi';
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['DateTime']>;
  fin?: Maybe<Scalars['DateTime']>;
  reglement?: Maybe<Array<Maybe<DefiReglementDynamicZone>>>;
  winners?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  recompenses?: Maybe<Array<Maybe<ComponentDefiDefiWinners>>>;
  ressources?: Maybe<Array<Maybe<DefiRessourcesDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DefiWinnersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DefiRecompensesArgs = {
  filters?: Maybe<ComponentDefiDefiWinnersFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DefiEntity = {
  __typename?: 'DefiEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Defi>;
};

export type DefiEntityResponse = {
  __typename?: 'DefiEntityResponse';
  data?: Maybe<DefiEntity>;
};

export type DefiEntityResponseCollection = {
  __typename?: 'DefiEntityResponseCollection';
  data: Array<DefiEntity>;
  meta: ResponseCollectionMeta;
};

export type DefiFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  debut?: Maybe<DateTimeFilterInput>;
  fin?: Maybe<DateTimeFilterInput>;
  winners?: Maybe<UsersPermissionsUserFiltersInput>;
  recompenses?: Maybe<ComponentDefiDefiWinnersFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<DefiFiltersInput>>>;
  or?: Maybe<Array<Maybe<DefiFiltersInput>>>;
  not?: Maybe<DefiFiltersInput>;
};

export type DefiInput = {
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['DateTime']>;
  fin?: Maybe<Scalars['DateTime']>;
  reglement?: Maybe<Array<Scalars['DefiReglementDynamicZoneInput']>>;
  winners?: Maybe<Array<Maybe<Scalars['ID']>>>;
  recompenses?: Maybe<Array<Maybe<ComponentDefiDefiWinnersInput>>>;
  ressources?: Maybe<Array<Scalars['DefiRessourcesDynamicZoneInput']>>;
};

export type DefiReglementDynamicZone = ComponentDefiReglement | Error;

export type DefiRelationResponseCollection = {
  __typename?: 'DefiRelationResponseCollection';
  data: Array<DefiEntity>;
};

export type DefiRessourcesDynamicZone =
  | ComponentDefiDefiLiens
  | ComponentDefiDefiMedia
  | Error;

export type DefisList = {
  __typename?: 'DefisList';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
};

export type DeleteUser = {
  __typename?: 'deleteUser';
  name?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
};

export type Eleve = {
  __typename?: 'Eleve';
  id?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  avatar?: Maybe<AvatarMedia>;
  ong?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  classe?: Maybe<ClasseWithLycee>;
  note?: Maybe<Note>;
};

export type EleveCommandes = {
  __typename?: 'EleveCommandes';
  numerocommande?: Maybe<Scalars['String']>;
  totalttc?: Maybe<Scalars['Float']>;
  prixTotal?: Maybe<Scalars['Float']>;
  methodepaiement?: Maybe<Scalars['String']>;
  payment?: Maybe<Scalars['Boolean']>;
  fraislivraison?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  controlled?: Maybe<Scalars['Boolean']>;
  customerContributedToTheOng?: Maybe<Scalars['Boolean']>;
  client?: Maybe<OrderClient>;
};

export type ElevesWithOrder = {
  __typename?: 'ElevesWithOrder';
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  commandes?: Maybe<Array<Maybe<EleveCommandes>>>;
};

export enum Enum_Classe_Ong {
  AucuneOng = 'Aucune_ONG',
  PlaneteUrgence = 'Planete_urgence',
  UnEnfantParLaMain = 'Un_enfant_par_la_main',
  SocieteProtectriceDesAnimaux = 'Societe_protectrice_des_animaux'
}

export enum Enum_Client_Civilite {
  Madame = 'madame',
  Monsieur = 'monsieur'
}

export enum Enum_Client_Civilitelivraison {
  Madame = 'madame',
  Monsieur = 'monsieur'
}

export enum Enum_Commande_Methodepaiement {
  Cheque = 'cheque',
  Especes = 'especes',
  Cb = 'cb',
  MandatAdministratif = 'mandat_administratif',
  Virement = 'virement'
}

export enum Enum_Commande_Status {
  Paye = 'PAYE',
  APayer = 'A_PAYER',
  Annule = 'ANNULE',
  AValider = 'A_VALIDER',
  AFinaliser = 'A_FINALISER',
  NonPaye = 'NON_PAYE'
}

export enum Enum_Componentproductcharacteristicsproductcharacteristics_Characteristic {
  Taille = 'taille',
  Epaisseur = 'epaisseur',
  NombreDeProduitsParBoite = 'nombreDeProduitsParBoite',
  Composition = 'composition',
  Origine = 'origine',
  Pvht = 'pvht',
  PvAuxCentGrammes = 'pvAuxCentGrammes',
  TitreAlcoometrique = 'titreAlcoometrique',
  Ddm = 'ddm',
  Label = 'label',
  Fournisseur = 'fournisseur',
  Packaging = 'packaging',
  Tva = 'tva'
}

export enum Enum_Componentressourcesressourcetype_Nom {
  Video = 'video',
  Audio = 'audio',
  Lien = 'lien',
  Padlet = 'padlet',
  Quizlet = 'quizlet',
  Texte = 'texte',
  Tableur = 'tableur',
  Image = 'image',
  Genially = 'genially'
}

export enum Enum_Componentshoppingmobileshoppingmobile_Mobile {
  Securite = 'securite',
  Orgueil = 'orgueil',
  Nouveaute = 'nouveaute',
  Confort = 'confort',
  Argent = 'argent',
  Sympathie = 'sympathie',
  Ecologie = 'ecologie'
}

export enum Enum_Config_Name {
  AppVersion = 'APP_VERSION'
}

export enum Enum_Faq_Tag {
  Android = 'android',
  Ios = 'ios'
}

export enum Enum_Mailtpl_Action {
  ToAdminClasseCreated = 'TO_ADMIN_CLASSE_CREATED',
  ToAdminProfCreatedByProf = 'TO_ADMIN_PROF_CREATED_BY_PROF',
  ToAdminSuppressionEleve = 'TO_ADMIN_SUPPRESSION_ELEVE',
  ToAdminInscriptionProf = 'TO_ADMIN_INSCRIPTION_PROF',
  ToAdminFinCreationClasse = 'TO_ADMIN_FIN_CREATION_CLASSE',
  ToElevesProfOuvertureQuizHebdo = 'TO_ELEVES_PROF_OUVERTURE_QUIZ_HEBDO',
  ToElevesProfDemarrageOperation = 'TO_ELEVES_PROF_DEMARRAGE_OPERATION',
  ToElevesProfPremiereVenteClasse = 'TO_ELEVES_PROF_PREMIERE_VENTE_CLASSE',
  ToElevesProfJ7Operation = 'TO_ELEVES_PROF_J7_OPERATION',
  ToElevesProfFinOperation = 'TO_ELEVES_PROF_FIN_OPERATION',
  ToEleves_0VenteRelance = 'TO_ELEVES_0VENTE_RELANCE',
  ToElevePremiereVente = 'TO_ELEVE_PREMIERE_VENTE',
  ToElevesRelanceQuiz = 'TO_ELEVES_RELANCE_QUIZ',
  ToProfMonInscription = 'TO_PROF_MON_INSCRIPTION',
  ToProfRelanceQuiz = 'TO_PROF_RELANCE_QUIZ',
  ToProfCommande_0Euro = 'TO_PROF_COMMANDE_0_EURO',
  ToUserForgotPassword = 'TO_USER_FORGOT_PASSWORD',
  ToClientAFinaliserPanierEboutique = 'TO_CLIENT_A_FINALISER_PANIER_EBOUTIQUE'
}

export enum Enum_Page_Action {
  HomePage = 'HOME_PAGE',
  InstallApp = 'INSTALL_APP',
  PedagogiesPage = 'PEDAGOGIES_PAGE',
  QuizPage = 'QUIZ_PAGE',
  RessourcesPage = 'RESSOURCES_PAGE',
  PublicShopHome = 'PUBLIC_SHOP_HOME',
  ClasseSettingsPage = 'CLASSE_SETTINGS_PAGE'
}

export enum Enum_Quiztonote_Noteauto {
  Note = 'note',
  QuizTermine = 'Quiz_termine'
}

export enum Enum_Userspermissionsuser_Ong {
  PlaneteUrgence = 'Planete_urgence',
  UnEnfantParLaMain = 'Un_enfant_par_la_main',
  SocieteProtectriceDesAnimaux = 'Societe_protectrice_des_animaux'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type Faq = {
  __typename?: 'Faq';
  name?: Maybe<Scalars['String']>;
  medias?: Maybe<UploadFileRelationResponseCollection>;
  tag?: Maybe<Enum_Faq_Tag>;
  desc?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FaqMediasArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FaqEntity = {
  __typename?: 'FaqEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Faq>;
};

export type FaqEntityResponse = {
  __typename?: 'FaqEntityResponse';
  data?: Maybe<FaqEntity>;
};

export type FaqEntityResponseCollection = {
  __typename?: 'FaqEntityResponseCollection';
  data: Array<FaqEntity>;
  meta: ResponseCollectionMeta;
};

export type FaqFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  tag?: Maybe<StringFilterInput>;
  desc?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FaqFiltersInput>>>;
  or?: Maybe<Array<Maybe<FaqFiltersInput>>>;
  not?: Maybe<FaqFiltersInput>;
};

export type FaqInput = {
  name?: Maybe<Scalars['String']>;
  medias?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tag?: Maybe<Enum_Faq_Tag>;
  desc?: Maybe<Scalars['String']>;
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type Filliere = {
  __typename?: 'Filliere';
  name?: Maybe<Scalars['String']>;
  quizzes?: Maybe<QuizRelationResponseCollection>;
  classes?: Maybe<ClasseRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FilliereQuizzesArgs = {
  filters?: Maybe<QuizFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FilliereClassesArgs = {
  filters?: Maybe<ClasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FilliereEntity = {
  __typename?: 'FilliereEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Filliere>;
};

export type FilliereEntityResponse = {
  __typename?: 'FilliereEntityResponse';
  data?: Maybe<FilliereEntity>;
};

export type FilliereEntityResponseCollection = {
  __typename?: 'FilliereEntityResponseCollection';
  data: Array<FilliereEntity>;
  meta: ResponseCollectionMeta;
};

export type FilliereFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  quizzes?: Maybe<QuizFiltersInput>;
  classes?: Maybe<ClasseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FilliereFiltersInput>>>;
  or?: Maybe<Array<Maybe<FilliereFiltersInput>>>;
  not?: Maybe<FilliereFiltersInput>;
};

export type FilliereInput = {
  name?: Maybe<Scalars['String']>;
  quizzes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type FilliereRelationResponseCollection = {
  __typename?: 'FilliereRelationResponseCollection';
  data: Array<FilliereEntity>;
};

export type FilliereResult = {
  __typename?: 'FilliereResult';
  name: Scalars['String'];
};

export type FloatFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Float']>>>;
  or?: Maybe<Array<Maybe<Scalars['Float']>>>;
  not?: Maybe<FloatFilterInput>;
  eq?: Maybe<Scalars['Float']>;
  eqi?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  startsWith?: Maybe<Scalars['Float']>;
  endsWith?: Maybe<Scalars['Float']>;
  contains?: Maybe<Scalars['Float']>;
  notContains?: Maybe<Scalars['Float']>;
  containsi?: Maybe<Scalars['Float']>;
  notContainsi?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Float']>>>;
  between?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type Formation = {
  __typename?: 'Formation';
  name?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  challengetypes?: Maybe<ChallengetypeRelationResponseCollection>;
  reservedToProf?: Maybe<Scalars['Boolean']>;
  formation_type?: Maybe<FormationTypeEntityResponse>;
  order?: Maybe<Scalars['Int']>;
  niveau?: Maybe<NiveauRelationResponseCollection>;
  ressources?: Maybe<Array<Maybe<FormationRessourcesDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormationChallengetypesArgs = {
  filters?: Maybe<ChallengetypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FormationNiveauArgs = {
  filters?: Maybe<NiveauFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FormationEntity = {
  __typename?: 'FormationEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Formation>;
};

export type FormationEntityResponse = {
  __typename?: 'FormationEntityResponse';
  data?: Maybe<FormationEntity>;
};

export type FormationEntityResponseCollection = {
  __typename?: 'FormationEntityResponseCollection';
  data: Array<FormationEntity>;
  meta: ResponseCollectionMeta;
};

export type FormationFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  subtitle?: Maybe<StringFilterInput>;
  info?: Maybe<StringFilterInput>;
  desc?: Maybe<StringFilterInput>;
  challengetypes?: Maybe<ChallengetypeFiltersInput>;
  reservedToProf?: Maybe<BooleanFilterInput>;
  formation_type?: Maybe<FormationTypeFiltersInput>;
  order?: Maybe<IntFilterInput>;
  niveau?: Maybe<NiveauFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FormationFiltersInput>>>;
  or?: Maybe<Array<Maybe<FormationFiltersInput>>>;
  not?: Maybe<FormationFiltersInput>;
};

export type FormationInput = {
  name?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  challengetypes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reservedToProf?: Maybe<Scalars['Boolean']>;
  formation_type?: Maybe<Scalars['ID']>;
  order?: Maybe<Scalars['Int']>;
  niveau?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ressources?: Maybe<Array<Scalars['FormationRessourcesDynamicZoneInput']>>;
};

export type FormationLink = {
  __typename?: 'FormationLink';
  titre?: Maybe<Scalars['String']>;
  type?: Maybe<FormationRessourceType>;
  lien?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<FormationMedia>>>;
};

export type FormationMedia = {
  __typename?: 'FormationMedia';
  url?: Maybe<Scalars['String']>;
};

export type FormationRelationResponseCollection = {
  __typename?: 'FormationRelationResponseCollection';
  data: Array<FormationEntity>;
};

export type FormationRessource = {
  __typename?: 'FormationRessource';
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  ressources?: Maybe<Array<Maybe<FormationLink>>>;
};

export type FormationRessources = {
  __typename?: 'FormationRessources';
  name?: Maybe<Scalars['String']>;
};

export type FormationRessourcesDynamicZone =
  | ComponentRessourcesRessourceLien
  | ComponentRessourcesRessourceMedia
  | Error;

export type FormationRessourceType = {
  __typename?: 'FormationRessourceType';
  nom?: Maybe<Scalars['String']>;
};

export type FormationType = {
  __typename?: 'FormationType';
  name?: Maybe<Scalars['String']>;
  formations?: Maybe<FormationRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormationTypeFormationsArgs = {
  filters?: Maybe<FormationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FormationTypeEntity = {
  __typename?: 'FormationTypeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<FormationType>;
};

export type FormationTypeEntityResponse = {
  __typename?: 'FormationTypeEntityResponse';
  data?: Maybe<FormationTypeEntity>;
};

export type FormationTypeEntityResponseCollection = {
  __typename?: 'FormationTypeEntityResponseCollection';
  data: Array<FormationTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type FormationTypeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  formations?: Maybe<FormationFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FormationTypeFiltersInput>>>;
  or?: Maybe<Array<Maybe<FormationTypeFiltersInput>>>;
  not?: Maybe<FormationTypeFiltersInput>;
};

export type FormationTypeInput = {
  name?: Maybe<Scalars['String']>;
  formations?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type FormationTypeWithRelatedFormations = {
  __typename?: 'FormationTypeWithRelatedFormations';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  formations?: Maybe<Array<Maybe<FormationRessources>>>;
};

export type FraisPortInput = {
  applicable?: Maybe<Scalars['Boolean']>;
  montant?: Maybe<Scalars['Float']>;
};

export type GenericMorph =
  | ComponentAllergensAllergens
  | ComponentDefiDefiLiens
  | ComponentDefiDefiLots
  | ComponentDefiDefiMedia
  | ComponentDefiDefiWinners
  | ComponentDefiReglement
  | ComponentIngredientsIngredients
  | ComponentNotifLinkLink
  | ComponentObjectifObjectif
  | ComponentProductCharacteristicsProductCharacteristics
  | ComponentRessourcesRessourceLien
  | ComponentRessourcesRessourceMedia
  | ComponentRessourcesRessourceType
  | ComponentShoppingMobileShoppingMobile
  | ComponentUrlUrl
  | UploadFile
  | UploadFolder
  | I18NLocale
  | UsersPermissionsPermission
  | UsersPermissionsRole
  | UsersPermissionsUser
  | Academie
  | Avatar
  | Categorieproduit
  | Challenge
  | ChallengeRessource
  | ChallengeRessourceType
  | Challengetype
  | Classe
  | Client
  | Commande
  | Commandeline
  | Competence
  | Config
  | Corbeille
  | Defi
  | Faq
  | Filliere
  | Formation
  | FormationType
  | Lycee
  | Mailtpl
  | Niveau
  | Note
  | Noteclasse
  | Notification
  | Page
  | Pedagogie
  | PedagogieType
  | Produit
  | Question
  | Questiontouser
  | Quiz
  | Quizchance
  | Quiztonote;

export type GetMyNoteInClasse = {
  __typename?: 'GetMyNoteInClasse';
  note?: Maybe<NoteEntity>;
  quizToNotes?: Maybe<Array<Maybe<QuiztonoteEntity>>>;
};

export type GetMyOrdersInClasse = {
  __typename?: 'GetMyOrdersInClasse';
  commandes?: Maybe<Array<Maybe<CommandeEntity>>>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
};

export type GetProfDashboard = {
  __typename?: 'getProfDashboard';
  classe?: Maybe<ProfDashboardClasse>;
};

export type GetUserAccount = {
  __typename?: 'GetUserAccount';
  id?: Maybe<Scalars['ID']>;
  ville?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  mdp?: Maybe<Scalars['String']>;
  shop?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<UserAvatar>;
  options?: Maybe<Options>;
  note?: Maybe<UserNote>;
  classe?: Maybe<UserAccountClasse>;
};

export type GetUserOnHome = {
  __typename?: 'getUserOnHome';
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isPairTeacher?: Maybe<Scalars['Boolean']>;
  tel?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ong?: Maybe<Scalars['String']>;
  options?: Maybe<Options>;
  classe?: Maybe<UserClasseType>;
  avatar?: Maybe<UserAvatar>;
};

export type GetUserSoftSkills = {
  __typename?: 'getUserSoftSkills';
  note?: Maybe<UserNote>;
  commandes?: Maybe<Scalars['Float']>;
  unpayedOrders?: Maybe<Scalars['Float']>;
  classe?: Maybe<UserClasseWithAllInfos>;
};

export type HomeDefis = {
  __typename?: 'HomeDefis';
  defisList?: Maybe<Array<Maybe<DefisList>>>;
  lastDefi?: Maybe<LastDefi>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<I18NLocale>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  code?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  or?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  not?: Maybe<I18NLocaleFiltersInput>;
};

export type IdFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['ID']>>>;
  or?: Maybe<Array<Maybe<Scalars['ID']>>>;
  not?: Maybe<IdFilterInput>;
  eq?: Maybe<Scalars['ID']>;
  eqi?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  startsWith?: Maybe<Scalars['ID']>;
  endsWith?: Maybe<Scalars['ID']>;
  contains?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
  containsi?: Maybe<Scalars['ID']>;
  notContainsi?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  gte?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  lte?: Maybe<Scalars['ID']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['ID']>>>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type IntFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Int']>>>;
  or?: Maybe<Array<Maybe<Scalars['Int']>>>;
  not?: Maybe<IntFilterInput>;
  eq?: Maybe<Scalars['Int']>;
  eqi?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  startsWith?: Maybe<Scalars['Int']>;
  endsWith?: Maybe<Scalars['Int']>;
  contains?: Maybe<Scalars['Int']>;
  notContains?: Maybe<Scalars['Int']>;
  containsi?: Maybe<Scalars['Int']>;
  notContainsi?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type JsonFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  or?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  not?: Maybe<JsonFilterInput>;
  eq?: Maybe<Scalars['JSON']>;
  eqi?: Maybe<Scalars['JSON']>;
  ne?: Maybe<Scalars['JSON']>;
  startsWith?: Maybe<Scalars['JSON']>;
  endsWith?: Maybe<Scalars['JSON']>;
  contains?: Maybe<Scalars['JSON']>;
  notContains?: Maybe<Scalars['JSON']>;
  containsi?: Maybe<Scalars['JSON']>;
  notContainsi?: Maybe<Scalars['JSON']>;
  gt?: Maybe<Scalars['JSON']>;
  gte?: Maybe<Scalars['JSON']>;
  lt?: Maybe<Scalars['JSON']>;
  lte?: Maybe<Scalars['JSON']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  between?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type LastDefi = {
  __typename?: 'LastDefi';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
  recompenses?: Maybe<Array<Maybe<AwardsList>>>;
};

export type Lycee = {
  __typename?: 'Lycee';
  name?: Maybe<Scalars['String']>;
  adresse?: Maybe<Scalars['String']>;
  codepostal?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  academie?: Maybe<AcademieEntityResponse>;
  classes?: Maybe<ClasseRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LyceeClassesArgs = {
  filters?: Maybe<ClasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type LyceeEntity = {
  __typename?: 'LyceeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Lycee>;
};

export type LyceeEntityResponse = {
  __typename?: 'LyceeEntityResponse';
  data?: Maybe<LyceeEntity>;
};

export type LyceeEntityResponseCollection = {
  __typename?: 'LyceeEntityResponseCollection';
  data: Array<LyceeEntity>;
  meta: ResponseCollectionMeta;
};

export type LyceeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  adresse?: Maybe<StringFilterInput>;
  codepostal?: Maybe<StringFilterInput>;
  ville?: Maybe<StringFilterInput>;
  tel?: Maybe<StringFilterInput>;
  academie?: Maybe<AcademieFiltersInput>;
  classes?: Maybe<ClasseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<LyceeFiltersInput>>>;
  or?: Maybe<Array<Maybe<LyceeFiltersInput>>>;
  not?: Maybe<LyceeFiltersInput>;
};

export type LyceeInput = {
  name?: Maybe<Scalars['String']>;
  adresse?: Maybe<Scalars['String']>;
  codepostal?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  academie?: Maybe<Scalars['ID']>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type LyceeName = {
  __typename?: 'LyceeName';
  name?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
};

export type LyceeRelationResponseCollection = {
  __typename?: 'LyceeRelationResponseCollection';
  data: Array<LyceeEntity>;
};

export type LyceeResult = {
  __typename?: 'LyceeResult';
  name: Scalars['String'];
  academie: AcademieName;
};

export type Mailtpl = {
  __typename?: 'Mailtpl';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  action?: Maybe<Enum_Mailtpl_Action>;
  text?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MailtplEntity = {
  __typename?: 'MailtplEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Mailtpl>;
};

export type MailtplEntityResponse = {
  __typename?: 'MailtplEntityResponse';
  data?: Maybe<MailtplEntity>;
};

export type MailtplEntityResponseCollection = {
  __typename?: 'MailtplEntityResponseCollection';
  data: Array<MailtplEntity>;
  meta: ResponseCollectionMeta;
};

export type MailtplFiltersInput = {
  id?: Maybe<IdFilterInput>;
  from?: Maybe<StringFilterInput>;
  to?: Maybe<StringFilterInput>;
  subject?: Maybe<StringFilterInput>;
  action?: Maybe<StringFilterInput>;
  text?: Maybe<StringFilterInput>;
  name?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<MailtplFiltersInput>>>;
  or?: Maybe<Array<Maybe<MailtplFiltersInput>>>;
  not?: Maybe<MailtplFiltersInput>;
};

export type MailtplInput = {
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  action?: Maybe<Enum_Mailtpl_Action>;
  text?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type MediaAvatar = {
  __typename?: 'MediaAvatar';
  media?: Maybe<UrlAvatar>;
};

export type MediaUrl = {
  __typename?: 'MediaUrl';
  url: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  createAcademie?: Maybe<AcademieEntityResponse>;
  updateAcademie?: Maybe<AcademieEntityResponse>;
  deleteAcademie?: Maybe<AcademieEntityResponse>;
  createAvatar?: Maybe<AvatarEntityResponse>;
  updateAvatar?: Maybe<AvatarEntityResponse>;
  deleteAvatar?: Maybe<AvatarEntityResponse>;
  createCategorieproduit?: Maybe<CategorieproduitEntityResponse>;
  updateCategorieproduit?: Maybe<CategorieproduitEntityResponse>;
  deleteCategorieproduit?: Maybe<CategorieproduitEntityResponse>;
  createChallenge?: Maybe<ChallengeEntityResponse>;
  updateChallenge?: Maybe<ChallengeEntityResponse>;
  deleteChallenge?: Maybe<ChallengeEntityResponse>;
  createChallengeRessource?: Maybe<ChallengeRessourceEntityResponse>;
  updateChallengeRessource?: Maybe<ChallengeRessourceEntityResponse>;
  deleteChallengeRessource?: Maybe<ChallengeRessourceEntityResponse>;
  createChallengeRessourceType?: Maybe<ChallengeRessourceTypeEntityResponse>;
  updateChallengeRessourceType?: Maybe<ChallengeRessourceTypeEntityResponse>;
  deleteChallengeRessourceType?: Maybe<ChallengeRessourceTypeEntityResponse>;
  createChallengetype?: Maybe<ChallengetypeEntityResponse>;
  updateChallengetype?: Maybe<ChallengetypeEntityResponse>;
  deleteChallengetype?: Maybe<ChallengetypeEntityResponse>;
  createClasse?: Maybe<ClasseEntityResponse>;
  updateClasse?: Maybe<ClasseEntityResponse>;
  deleteClasse?: Maybe<ClasseEntityResponse>;
  createClient?: Maybe<ClientEntityResponse>;
  updateClient?: Maybe<ClientEntityResponse>;
  deleteClient?: Maybe<ClientEntityResponse>;
  createCommande?: Maybe<CommandeEntityResponse>;
  updateCommande?: Maybe<CommandeEntityResponse>;
  deleteCommande?: Maybe<CommandeEntityResponse>;
  createCommandeline?: Maybe<CommandelineEntityResponse>;
  updateCommandeline?: Maybe<CommandelineEntityResponse>;
  deleteCommandeline?: Maybe<CommandelineEntityResponse>;
  createCompetence?: Maybe<CompetenceEntityResponse>;
  updateCompetence?: Maybe<CompetenceEntityResponse>;
  deleteCompetence?: Maybe<CompetenceEntityResponse>;
  createConfig?: Maybe<ConfigEntityResponse>;
  updateConfig?: Maybe<ConfigEntityResponse>;
  deleteConfig?: Maybe<ConfigEntityResponse>;
  createCorbeille?: Maybe<CorbeilleEntityResponse>;
  updateCorbeille?: Maybe<CorbeilleEntityResponse>;
  deleteCorbeille?: Maybe<CorbeilleEntityResponse>;
  createDefi?: Maybe<DefiEntityResponse>;
  updateDefi?: Maybe<DefiEntityResponse>;
  deleteDefi?: Maybe<DefiEntityResponse>;
  createFaq?: Maybe<FaqEntityResponse>;
  updateFaq?: Maybe<FaqEntityResponse>;
  deleteFaq?: Maybe<FaqEntityResponse>;
  createFilliere?: Maybe<FilliereEntityResponse>;
  updateFilliere?: Maybe<FilliereEntityResponse>;
  deleteFilliere?: Maybe<FilliereEntityResponse>;
  createFormation?: Maybe<FormationEntityResponse>;
  updateFormation?: Maybe<FormationEntityResponse>;
  deleteFormation?: Maybe<FormationEntityResponse>;
  createFormationType?: Maybe<FormationTypeEntityResponse>;
  updateFormationType?: Maybe<FormationTypeEntityResponse>;
  deleteFormationType?: Maybe<FormationTypeEntityResponse>;
  createLycee?: Maybe<LyceeEntityResponse>;
  updateLycee?: Maybe<LyceeEntityResponse>;
  deleteLycee?: Maybe<LyceeEntityResponse>;
  createMailtpl?: Maybe<MailtplEntityResponse>;
  updateMailtpl?: Maybe<MailtplEntityResponse>;
  deleteMailtpl?: Maybe<MailtplEntityResponse>;
  createNiveau?: Maybe<NiveauEntityResponse>;
  updateNiveau?: Maybe<NiveauEntityResponse>;
  deleteNiveau?: Maybe<NiveauEntityResponse>;
  createNote?: Maybe<NoteEntityResponse>;
  updateNote?: Maybe<NoteEntityResponse>;
  deleteNote?: Maybe<NoteEntityResponse>;
  createNoteclasse?: Maybe<NoteclasseEntityResponse>;
  updateNoteclasse?: Maybe<NoteclasseEntityResponse>;
  deleteNoteclasse?: Maybe<NoteclasseEntityResponse>;
  createNotification?: Maybe<NotificationEntityResponse>;
  updateNotification?: Maybe<NotificationEntityResponse>;
  deleteNotification?: Maybe<NotificationEntityResponse>;
  createPage?: Maybe<PageEntityResponse>;
  updatePage?: Maybe<PageEntityResponse>;
  deletePage?: Maybe<PageEntityResponse>;
  createPedagogie?: Maybe<PedagogieEntityResponse>;
  updatePedagogie?: Maybe<PedagogieEntityResponse>;
  deletePedagogie?: Maybe<PedagogieEntityResponse>;
  createPedagogieType?: Maybe<PedagogieTypeEntityResponse>;
  updatePedagogieType?: Maybe<PedagogieTypeEntityResponse>;
  deletePedagogieType?: Maybe<PedagogieTypeEntityResponse>;
  createProduit?: Maybe<ProduitEntityResponse>;
  updateProduit?: Maybe<ProduitEntityResponse>;
  deleteProduit?: Maybe<ProduitEntityResponse>;
  createQuestion?: Maybe<QuestionEntityResponse>;
  updateQuestion?: Maybe<QuestionEntityResponse>;
  deleteQuestion?: Maybe<QuestionEntityResponse>;
  createQuestiontouser?: Maybe<QuestiontouserEntityResponse>;
  updateQuestiontouser?: Maybe<QuestiontouserEntityResponse>;
  deleteQuestiontouser?: Maybe<QuestiontouserEntityResponse>;
  createQuiz?: Maybe<QuizEntityResponse>;
  updateQuiz?: Maybe<QuizEntityResponse>;
  deleteQuiz?: Maybe<QuizEntityResponse>;
  createQuizchance?: Maybe<QuizchanceEntityResponse>;
  updateQuizchance?: Maybe<QuizchanceEntityResponse>;
  deleteQuizchance?: Maybe<QuizchanceEntityResponse>;
  createQuiztonote?: Maybe<QuiztonoteEntityResponse>;
  updateQuiztonote?: Maybe<QuiztonoteEntityResponse>;
  deleteQuiztonote?: Maybe<QuiztonoteEntityResponse>;
  upload: UploadFileEntityResponse;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  updateFileInfo: UploadFileEntityResponse;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  addCommandesAndNote?: Maybe<Commande>;
  updateControlStatus?: Maybe<Commande>;
  updatePaymentReminder?: Maybe<Commande>;
  updateAllNote?: Maybe<Array<Maybe<Note>>>;
  updateMyNote?: Maybe<Note>;
  updateNoteClasse?: Maybe<Scalars['Boolean']>;
  createQuizNote?: Maybe<Quiztonote>;
  createOrder?: Maybe<AddedCommande>;
  updateOptions?: Maybe<UsersPermissionsUser>;
  deleteUser?: Maybe<DeleteUser>;
  updateClassObjective?: Maybe<CurrentClasseInfosType>;
};

export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};

export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID'];
  data: UploadFileInput;
};

export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};

export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};

export type MutationUpdateUploadFolderArgs = {
  id: Scalars['ID'];
  data: UploadFolderInput;
};

export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};

export type MutationCreateAcademieArgs = {
  data: AcademieInput;
};

export type MutationUpdateAcademieArgs = {
  id: Scalars['ID'];
  data: AcademieInput;
};

export type MutationDeleteAcademieArgs = {
  id: Scalars['ID'];
};

export type MutationCreateAvatarArgs = {
  data: AvatarInput;
};

export type MutationUpdateAvatarArgs = {
  id: Scalars['ID'];
  data: AvatarInput;
};

export type MutationDeleteAvatarArgs = {
  id: Scalars['ID'];
};

export type MutationCreateCategorieproduitArgs = {
  data: CategorieproduitInput;
};

export type MutationUpdateCategorieproduitArgs = {
  id: Scalars['ID'];
  data: CategorieproduitInput;
};

export type MutationDeleteCategorieproduitArgs = {
  id: Scalars['ID'];
};

export type MutationCreateChallengeArgs = {
  data: ChallengeInput;
};

export type MutationUpdateChallengeArgs = {
  id: Scalars['ID'];
  data: ChallengeInput;
};

export type MutationDeleteChallengeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateChallengeRessourceArgs = {
  data: ChallengeRessourceInput;
};

export type MutationUpdateChallengeRessourceArgs = {
  id: Scalars['ID'];
  data: ChallengeRessourceInput;
};

export type MutationDeleteChallengeRessourceArgs = {
  id: Scalars['ID'];
};

export type MutationCreateChallengeRessourceTypeArgs = {
  data: ChallengeRessourceTypeInput;
};

export type MutationUpdateChallengeRessourceTypeArgs = {
  id: Scalars['ID'];
  data: ChallengeRessourceTypeInput;
};

export type MutationDeleteChallengeRessourceTypeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateChallengetypeArgs = {
  data: ChallengetypeInput;
};

export type MutationUpdateChallengetypeArgs = {
  id: Scalars['ID'];
  data: ChallengetypeInput;
};

export type MutationDeleteChallengetypeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateClasseArgs = {
  data: ClasseInput;
};

export type MutationUpdateClasseArgs = {
  id: Scalars['ID'];
  data: ClasseInput;
};

export type MutationDeleteClasseArgs = {
  id: Scalars['ID'];
};

export type MutationCreateClientArgs = {
  data: ClientInput;
};

export type MutationUpdateClientArgs = {
  id: Scalars['ID'];
  data: ClientInput;
};

export type MutationDeleteClientArgs = {
  id: Scalars['ID'];
};

export type MutationCreateCommandeArgs = {
  data: CommandeInput;
};

export type MutationUpdateCommandeArgs = {
  id: Scalars['ID'];
  data: CommandeInput;
};

export type MutationDeleteCommandeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateCommandelineArgs = {
  data: CommandelineInput;
};

export type MutationUpdateCommandelineArgs = {
  id: Scalars['ID'];
  data: CommandelineInput;
};

export type MutationDeleteCommandelineArgs = {
  id: Scalars['ID'];
};

export type MutationCreateCompetenceArgs = {
  data: CompetenceInput;
};

export type MutationUpdateCompetenceArgs = {
  id: Scalars['ID'];
  data: CompetenceInput;
};

export type MutationDeleteCompetenceArgs = {
  id: Scalars['ID'];
};

export type MutationCreateConfigArgs = {
  data: ConfigInput;
};

export type MutationUpdateConfigArgs = {
  id: Scalars['ID'];
  data: ConfigInput;
};

export type MutationDeleteConfigArgs = {
  id: Scalars['ID'];
};

export type MutationCreateCorbeilleArgs = {
  data: CorbeilleInput;
};

export type MutationUpdateCorbeilleArgs = {
  id: Scalars['ID'];
  data: CorbeilleInput;
};

export type MutationDeleteCorbeilleArgs = {
  id: Scalars['ID'];
};

export type MutationCreateDefiArgs = {
  data: DefiInput;
};

export type MutationUpdateDefiArgs = {
  id: Scalars['ID'];
  data: DefiInput;
};

export type MutationDeleteDefiArgs = {
  id: Scalars['ID'];
};

export type MutationCreateFaqArgs = {
  data: FaqInput;
};

export type MutationUpdateFaqArgs = {
  id: Scalars['ID'];
  data: FaqInput;
};

export type MutationDeleteFaqArgs = {
  id: Scalars['ID'];
};

export type MutationCreateFilliereArgs = {
  data: FilliereInput;
};

export type MutationUpdateFilliereArgs = {
  id: Scalars['ID'];
  data: FilliereInput;
};

export type MutationDeleteFilliereArgs = {
  id: Scalars['ID'];
};

export type MutationCreateFormationArgs = {
  data: FormationInput;
};

export type MutationUpdateFormationArgs = {
  id: Scalars['ID'];
  data: FormationInput;
};

export type MutationDeleteFormationArgs = {
  id: Scalars['ID'];
};

export type MutationCreateFormationTypeArgs = {
  data: FormationTypeInput;
};

export type MutationUpdateFormationTypeArgs = {
  id: Scalars['ID'];
  data: FormationTypeInput;
};

export type MutationDeleteFormationTypeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateLyceeArgs = {
  data: LyceeInput;
};

export type MutationUpdateLyceeArgs = {
  id: Scalars['ID'];
  data: LyceeInput;
};

export type MutationDeleteLyceeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateMailtplArgs = {
  data: MailtplInput;
};

export type MutationUpdateMailtplArgs = {
  id: Scalars['ID'];
  data: MailtplInput;
};

export type MutationDeleteMailtplArgs = {
  id: Scalars['ID'];
};

export type MutationCreateNiveauArgs = {
  data: NiveauInput;
};

export type MutationUpdateNiveauArgs = {
  id: Scalars['ID'];
  data: NiveauInput;
};

export type MutationDeleteNiveauArgs = {
  id: Scalars['ID'];
};

export type MutationCreateNoteArgs = {
  data: NoteInput;
};

export type MutationUpdateNoteArgs = {
  id: Scalars['ID'];
  data: NoteInput;
};

export type MutationDeleteNoteArgs = {
  id: Scalars['ID'];
};

export type MutationCreateNoteclasseArgs = {
  data: NoteclasseInput;
};

export type MutationUpdateNoteclasseArgs = {
  id: Scalars['ID'];
  data: NoteclasseInput;
};

export type MutationDeleteNoteclasseArgs = {
  id: Scalars['ID'];
};

export type MutationCreateNotificationArgs = {
  data: NotificationInput;
};

export type MutationUpdateNotificationArgs = {
  id: Scalars['ID'];
  data: NotificationInput;
};

export type MutationDeleteNotificationArgs = {
  id: Scalars['ID'];
};

export type MutationCreatePageArgs = {
  data: PageInput;
};

export type MutationUpdatePageArgs = {
  id: Scalars['ID'];
  data: PageInput;
};

export type MutationDeletePageArgs = {
  id: Scalars['ID'];
};

export type MutationCreatePedagogieArgs = {
  data: PedagogieInput;
};

export type MutationUpdatePedagogieArgs = {
  id: Scalars['ID'];
  data: PedagogieInput;
};

export type MutationDeletePedagogieArgs = {
  id: Scalars['ID'];
};

export type MutationCreatePedagogieTypeArgs = {
  data: PedagogieTypeInput;
};

export type MutationUpdatePedagogieTypeArgs = {
  id: Scalars['ID'];
  data: PedagogieTypeInput;
};

export type MutationDeletePedagogieTypeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateProduitArgs = {
  data: ProduitInput;
};

export type MutationUpdateProduitArgs = {
  id: Scalars['ID'];
  data: ProduitInput;
};

export type MutationDeleteProduitArgs = {
  id: Scalars['ID'];
};

export type MutationCreateQuestionArgs = {
  data: QuestionInput;
};

export type MutationUpdateQuestionArgs = {
  id: Scalars['ID'];
  data: QuestionInput;
};

export type MutationDeleteQuestionArgs = {
  id: Scalars['ID'];
};

export type MutationCreateQuestiontouserArgs = {
  data: QuestiontouserInput;
};

export type MutationUpdateQuestiontouserArgs = {
  id: Scalars['ID'];
  data: QuestiontouserInput;
};

export type MutationDeleteQuestiontouserArgs = {
  id: Scalars['ID'];
};

export type MutationCreateQuizArgs = {
  data: QuizInput;
};

export type MutationUpdateQuizArgs = {
  id: Scalars['ID'];
  data: QuizInput;
};

export type MutationDeleteQuizArgs = {
  id: Scalars['ID'];
};

export type MutationCreateQuizchanceArgs = {
  data: QuizchanceInput;
};

export type MutationUpdateQuizchanceArgs = {
  id: Scalars['ID'];
  data: QuizchanceInput;
};

export type MutationDeleteQuizchanceArgs = {
  id: Scalars['ID'];
};

export type MutationCreateQuiztonoteArgs = {
  data: QuiztonoteInput;
};

export type MutationUpdateQuiztonoteArgs = {
  id: Scalars['ID'];
  data: QuiztonoteInput;
};

export type MutationDeleteQuiztonoteArgs = {
  id: Scalars['ID'];
};

export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  info?: Maybe<FileInfoInput>;
  file: Scalars['Upload'];
};

export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};

export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: Maybe<FileInfoInput>;
};

export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};

export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};

export type MutationUpdateUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsRoleInput;
};

export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};

export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};

export type MutationUpdateUsersPermissionsUserArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsUserInput;
};

export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};

export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};

export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};

export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};

export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};

export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type MutationAddCommandesAndNoteArgs = {
  order?: Maybe<Order>;
};

export type MutationUpdateControlStatusArgs = {
  id?: Maybe<Scalars['Int']>;
  controlled?: Maybe<Scalars['Boolean']>;
};

export type MutationUpdatePaymentReminderArgs = {
  id?: Maybe<Scalars['Int']>;
  paymentreminder?: Maybe<Scalars['Boolean']>;
};

export type MutationCreateQuizNoteArgs = {
  quiz: Scalars['ID'];
  reponses: Array<Maybe<QuizRep>>;
};

export type MutationCreateOrderArgs = {
  order: Order;
  shopId: Scalars['String'];
  classeId: Scalars['ID'];
};

export type MutationUpdateOptionsArgs = {
  key?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
};

export type MutationDeleteUserArgs = {
  userId: Scalars['ID'];
};

export type MutationUpdateClassObjectiveArgs = {
  name?: Maybe<Scalars['String']>;
  ca?: Maybe<Scalars['Int']>;
};

export type Niveau = {
  __typename?: 'Niveau';
  name?: Maybe<Scalars['String']>;
  quizzes?: Maybe<QuizRelationResponseCollection>;
  classes?: Maybe<ClasseRelationResponseCollection>;
  formation?: Maybe<FormationRelationResponseCollection>;
  challenge_ressource?: Maybe<ChallengeRessourceRelationResponseCollection>;
  pedagogie?: Maybe<PedagogieRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NiveauQuizzesArgs = {
  filters?: Maybe<QuizFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NiveauClassesArgs = {
  filters?: Maybe<ClasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NiveauFormationArgs = {
  filters?: Maybe<FormationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NiveauChallenge_RessourceArgs = {
  filters?: Maybe<ChallengeRessourceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NiveauPedagogieArgs = {
  filters?: Maybe<PedagogieFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NiveauEntity = {
  __typename?: 'NiveauEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Niveau>;
};

export type NiveauEntityResponse = {
  __typename?: 'NiveauEntityResponse';
  data?: Maybe<NiveauEntity>;
};

export type NiveauEntityResponseCollection = {
  __typename?: 'NiveauEntityResponseCollection';
  data: Array<NiveauEntity>;
  meta: ResponseCollectionMeta;
};

export type NiveauFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  quizzes?: Maybe<QuizFiltersInput>;
  classes?: Maybe<ClasseFiltersInput>;
  formation?: Maybe<FormationFiltersInput>;
  challenge_ressource?: Maybe<ChallengeRessourceFiltersInput>;
  pedagogie?: Maybe<PedagogieFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<NiveauFiltersInput>>>;
  or?: Maybe<Array<Maybe<NiveauFiltersInput>>>;
  not?: Maybe<NiveauFiltersInput>;
};

export type NiveauInput = {
  name?: Maybe<Scalars['String']>;
  quizzes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  formation?: Maybe<Array<Maybe<Scalars['ID']>>>;
  challenge_ressource?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pedagogie?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type NiveauRelationResponseCollection = {
  __typename?: 'NiveauRelationResponseCollection';
  data: Array<NiveauEntity>;
};

export type NiveauResult = {
  __typename?: 'NiveauResult';
  name: Scalars['String'];
};

export type Note = {
  __typename?: 'Note';
  cavente?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Int']>;
  qteca?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Int']>;
  qterebond?: Maybe<Scalars['Int']>;
  qtequiz?: Maybe<Scalars['Int']>;
  classe?: Maybe<ClasseEntityResponse>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Noteclasse = {
  __typename?: 'Noteclasse';
  cavente?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Int']>;
  qteca?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Int']>;
  qterebond?: Maybe<Scalars['Int']>;
  qtequiz?: Maybe<Scalars['Int']>;
  classe?: Maybe<ClasseEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NoteclasseEntity = {
  __typename?: 'NoteclasseEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Noteclasse>;
};

export type NoteclasseEntityResponse = {
  __typename?: 'NoteclasseEntityResponse';
  data?: Maybe<NoteclasseEntity>;
};

export type NoteclasseEntityResponseCollection = {
  __typename?: 'NoteclasseEntityResponseCollection';
  data: Array<NoteclasseEntity>;
  meta: ResponseCollectionMeta;
};

export type NoteclasseFiltersInput = {
  id?: Maybe<IdFilterInput>;
  cavente?: Maybe<FloatFilterInput>;
  nbvente?: Maybe<FloatFilterInput>;
  venterebond?: Maybe<FloatFilterInput>;
  pro?: Maybe<FloatFilterInput>;
  quiz?: Maybe<FloatFilterInput>;
  moyennegenerale?: Maybe<FloatFilterInput>;
  qtevente?: Maybe<IntFilterInput>;
  qteca?: Maybe<FloatFilterInput>;
  qtepro?: Maybe<IntFilterInput>;
  qterebond?: Maybe<IntFilterInput>;
  qtequiz?: Maybe<IntFilterInput>;
  classe?: Maybe<ClasseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<NoteclasseFiltersInput>>>;
  or?: Maybe<Array<Maybe<NoteclasseFiltersInput>>>;
  not?: Maybe<NoteclasseFiltersInput>;
};

export type NoteclasseInput = {
  cavente?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Int']>;
  qteca?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Int']>;
  qterebond?: Maybe<Scalars['Int']>;
  qtequiz?: Maybe<Scalars['Int']>;
  classe?: Maybe<Scalars['ID']>;
};

export type NoteEntity = {
  __typename?: 'NoteEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Note>;
};

export type NoteEntityResponse = {
  __typename?: 'NoteEntityResponse';
  data?: Maybe<NoteEntity>;
};

export type NoteEntityResponseCollection = {
  __typename?: 'NoteEntityResponseCollection';
  data: Array<NoteEntity>;
  meta: ResponseCollectionMeta;
};

export type NoteFiltersInput = {
  id?: Maybe<IdFilterInput>;
  cavente?: Maybe<FloatFilterInput>;
  nbvente?: Maybe<FloatFilterInput>;
  venterebond?: Maybe<FloatFilterInput>;
  pro?: Maybe<FloatFilterInput>;
  quiz?: Maybe<FloatFilterInput>;
  moyennegenerale?: Maybe<FloatFilterInput>;
  qtevente?: Maybe<IntFilterInput>;
  qteca?: Maybe<FloatFilterInput>;
  qtepro?: Maybe<IntFilterInput>;
  qterebond?: Maybe<IntFilterInput>;
  qtequiz?: Maybe<IntFilterInput>;
  classe?: Maybe<ClasseFiltersInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<NoteFiltersInput>>>;
  or?: Maybe<Array<Maybe<NoteFiltersInput>>>;
  not?: Maybe<NoteFiltersInput>;
};

export type NoteInput = {
  cavente?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Int']>;
  qteca?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Int']>;
  qterebond?: Maybe<Scalars['Int']>;
  qtequiz?: Maybe<Scalars['Int']>;
  classe?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
};

export type NoteRelationResponseCollection = {
  __typename?: 'NoteRelationResponseCollection';
  data: Array<NoteEntity>;
};

export type NotesWithQteca = {
  __typename?: 'NotesWithQteca';
  qteca?: Maybe<Scalars['Float']>;
};

export type Notification = {
  __typename?: 'Notification';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  link?: Maybe<ComponentNotifLinkLink>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Notification>;
};

export type NotificationEntityResponse = {
  __typename?: 'NotificationEntityResponse';
  data?: Maybe<NotificationEntity>;
};

export type NotificationEntityResponseCollection = {
  __typename?: 'NotificationEntityResponseCollection';
  data: Array<NotificationEntity>;
  meta: ResponseCollectionMeta;
};

export type NotificationFiltersInput = {
  id?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  hidden?: Maybe<BooleanFilterInput>;
  link?: Maybe<ComponentNotifLinkLinkFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<NotificationFiltersInput>>>;
  or?: Maybe<Array<Maybe<NotificationFiltersInput>>>;
  not?: Maybe<NotificationFiltersInput>;
};

export type NotificationInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  link?: Maybe<ComponentNotifLinkLinkInput>;
};

export type Options = {
  __typename?: 'options';
  classeId?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Order = {
  client?: Maybe<ClientInput>;
  panier?: Maybe<PanierInput>;
  methodepaiement?: Maybe<Enum_Commande_Methodepaiement>;
};

export type OrderClient = {
  __typename?: 'OrderClient';
  prenom?: Maybe<Scalars['String']>;
  nom?: Maybe<Scalars['String']>;
};

export type OrdersWithStatusAndContribution = {
  __typename?: 'OrdersWithStatusAndContribution';
  status?: Maybe<Scalars['String']>;
  customerContributedToTheOng?: Maybe<Scalars['Boolean']>;
};

export type Page = {
  __typename?: 'Page';
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFileEntityResponse>;
  action?: Maybe<Enum_Page_Action>;
  annonce?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PageEntity = {
  __typename?: 'PageEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Page>;
};

export type PageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<PageEntity>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<PageEntity>;
  meta: ResponseCollectionMeta;
};

export type PageFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  desc?: Maybe<StringFilterInput>;
  action?: Maybe<StringFilterInput>;
  annonce?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<PageFiltersInput>>>;
  or?: Maybe<Array<Maybe<PageFiltersInput>>>;
  not?: Maybe<PageFiltersInput>;
};

export type PageInput = {
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['ID']>;
  action?: Maybe<Enum_Page_Action>;
  annonce?: Maybe<Scalars['String']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  total: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  pageCount: Scalars['Int'];
};

export type PaginationArg = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type PanierInput = {
  totalPanier?: Maybe<Scalars['Float']>;
  customerContributedToTheOng?: Maybe<Scalars['Boolean']>;
  fraisPort?: Maybe<FraisPortInput>;
  commandeLines?: Maybe<Array<Maybe<CommandelineInput>>>;
};

export type Pedagogie = {
  __typename?: 'Pedagogie';
  name?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  challengetypes?: Maybe<ChallengetypeRelationResponseCollection>;
  pedagogie_type?: Maybe<PedagogieTypeEntityResponse>;
  revervedToProf?: Maybe<Scalars['Boolean']>;
  niveau?: Maybe<NiveauRelationResponseCollection>;
  ressources?: Maybe<Array<Maybe<PedagogieRessourcesDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PedagogieChallengetypesArgs = {
  filters?: Maybe<ChallengetypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PedagogieNiveauArgs = {
  filters?: Maybe<NiveauFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PedagogieEntity = {
  __typename?: 'PedagogieEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Pedagogie>;
};

export type PedagogieEntityResponse = {
  __typename?: 'PedagogieEntityResponse';
  data?: Maybe<PedagogieEntity>;
};

export type PedagogieEntityResponseCollection = {
  __typename?: 'PedagogieEntityResponseCollection';
  data: Array<PedagogieEntity>;
  meta: ResponseCollectionMeta;
};

export type PedagogieFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  subtitle?: Maybe<StringFilterInput>;
  info?: Maybe<StringFilterInput>;
  desc?: Maybe<StringFilterInput>;
  order?: Maybe<IntFilterInput>;
  challengetypes?: Maybe<ChallengetypeFiltersInput>;
  pedagogie_type?: Maybe<PedagogieTypeFiltersInput>;
  revervedToProf?: Maybe<BooleanFilterInput>;
  niveau?: Maybe<NiveauFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<PedagogieFiltersInput>>>;
  or?: Maybe<Array<Maybe<PedagogieFiltersInput>>>;
  not?: Maybe<PedagogieFiltersInput>;
};

export type PedagogieInput = {
  name?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  challengetypes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pedagogie_type?: Maybe<Scalars['ID']>;
  revervedToProf?: Maybe<Scalars['Boolean']>;
  niveau?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ressources?: Maybe<Array<Scalars['PedagogieRessourcesDynamicZoneInput']>>;
};

export type PedagogieLink = {
  __typename?: 'PedagogieLink';
  titre?: Maybe<Scalars['String']>;
  type?: Maybe<PedagogieRessourceType>;
  lien?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<PedagogieMedia>>>;
};

export type PedagogieMedia = {
  __typename?: 'PedagogieMedia';
  url?: Maybe<Scalars['String']>;
};

export type PedagogieRelationResponseCollection = {
  __typename?: 'PedagogieRelationResponseCollection';
  data: Array<PedagogieEntity>;
};

export type PedagogieRessource = {
  __typename?: 'PedagogieRessource';
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  ressources?: Maybe<Array<Maybe<PedagogieLink>>>;
};

export type PedagogieRessources = {
  __typename?: 'PedagogieRessources';
  name?: Maybe<Scalars['String']>;
};

export type PedagogieRessourcesDynamicZone =
  | ComponentRessourcesRessourceLien
  | ComponentRessourcesRessourceMedia
  | Error;

export type PedagogieRessourceType = {
  __typename?: 'PedagogieRessourceType';
  nom?: Maybe<Scalars['String']>;
};

export type PedagogieType = {
  __typename?: 'PedagogieType';
  name?: Maybe<Scalars['String']>;
  pedagogies?: Maybe<PedagogieRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PedagogieTypePedagogiesArgs = {
  filters?: Maybe<PedagogieFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PedagogieTypeEntity = {
  __typename?: 'PedagogieTypeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<PedagogieType>;
};

export type PedagogieTypeEntityResponse = {
  __typename?: 'PedagogieTypeEntityResponse';
  data?: Maybe<PedagogieTypeEntity>;
};

export type PedagogieTypeEntityResponseCollection = {
  __typename?: 'PedagogieTypeEntityResponseCollection';
  data: Array<PedagogieTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type PedagogieTypeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  pedagogies?: Maybe<PedagogieFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<PedagogieTypeFiltersInput>>>;
  or?: Maybe<Array<Maybe<PedagogieTypeFiltersInput>>>;
  not?: Maybe<PedagogieTypeFiltersInput>;
};

export type PedagogieTypeInput = {
  name?: Maybe<Scalars['String']>;
  pedagogies?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type PedagogieTypeWithRelatedPedagogies = {
  __typename?: 'PedagogieTypeWithRelatedPedagogies';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  pedagogies?: Maybe<Array<Maybe<PedagogieRessources>>>;
};

export type Produit = {
  __typename?: 'Produit';
  name?: Maybe<Scalars['String']>;
  netWeight?: Maybe<Scalars['Int']>;
  ttcPrice?: Maybe<Scalars['Float']>;
  catchPhrase?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFileRelationResponseCollection>;
  venterebond?: Maybe<Scalars['Boolean']>;
  ref?: Maybe<Scalars['Int']>;
  categorieproduits?: Maybe<CategorieproduitRelationResponseCollection>;
  challengetypes?: Maybe<ChallengetypeRelationResponseCollection>;
  commandelines?: Maybe<CommandelineRelationResponseCollection>;
  isOut?: Maybe<Scalars['Boolean']>;
  shoppingMobile?: Maybe<Array<Maybe<ComponentShoppingMobileShoppingMobile>>>;
  ingredients?: Maybe<Array<Maybe<ComponentIngredientsIngredients>>>;
  allergens?: Maybe<Array<Maybe<ComponentAllergensAllergens>>>;
  characteristics?: Maybe<
    Array<Maybe<ComponentProductCharacteristicsProductCharacteristics>>
  >;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProduitMediaArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitCategorieproduitsArgs = {
  filters?: Maybe<CategorieproduitFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitChallengetypesArgs = {
  filters?: Maybe<ChallengetypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitCommandelinesArgs = {
  filters?: Maybe<CommandelineFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitShoppingMobileArgs = {
  filters?: Maybe<ComponentShoppingMobileShoppingMobileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitIngredientsArgs = {
  filters?: Maybe<ComponentIngredientsIngredientsFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitAllergensArgs = {
  filters?: Maybe<ComponentAllergensAllergensFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitCharacteristicsArgs = {
  filters?: Maybe<
    ComponentProductCharacteristicsProductCharacteristicsFiltersInput
  >;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProduitEntity = {
  __typename?: 'ProduitEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Produit>;
};

export type ProduitEntityResponse = {
  __typename?: 'ProduitEntityResponse';
  data?: Maybe<ProduitEntity>;
};

export type ProduitEntityResponseCollection = {
  __typename?: 'ProduitEntityResponseCollection';
  data: Array<ProduitEntity>;
  meta: ResponseCollectionMeta;
};

export type ProduitFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  netWeight?: Maybe<IntFilterInput>;
  ttcPrice?: Maybe<FloatFilterInput>;
  catchPhrase?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  venterebond?: Maybe<BooleanFilterInput>;
  ref?: Maybe<IntFilterInput>;
  categorieproduits?: Maybe<CategorieproduitFiltersInput>;
  challengetypes?: Maybe<ChallengetypeFiltersInput>;
  commandelines?: Maybe<CommandelineFiltersInput>;
  isOut?: Maybe<BooleanFilterInput>;
  shoppingMobile?: Maybe<ComponentShoppingMobileShoppingMobileFiltersInput>;
  ingredients?: Maybe<ComponentIngredientsIngredientsFiltersInput>;
  allergens?: Maybe<ComponentAllergensAllergensFiltersInput>;
  characteristics?: Maybe<
    ComponentProductCharacteristicsProductCharacteristicsFiltersInput
  >;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ProduitFiltersInput>>>;
  or?: Maybe<Array<Maybe<ProduitFiltersInput>>>;
  not?: Maybe<ProduitFiltersInput>;
};

export type ProduitInput = {
  name?: Maybe<Scalars['String']>;
  netWeight?: Maybe<Scalars['Int']>;
  ttcPrice?: Maybe<Scalars['Float']>;
  catchPhrase?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<Scalars['ID']>>>;
  venterebond?: Maybe<Scalars['Boolean']>;
  ref?: Maybe<Scalars['Int']>;
  categorieproduits?: Maybe<Array<Maybe<Scalars['ID']>>>;
  challengetypes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  commandelines?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isOut?: Maybe<Scalars['Boolean']>;
  shoppingMobile?: Maybe<
    Array<Maybe<ComponentShoppingMobileShoppingMobileInput>>
  >;
  ingredients?: Maybe<Array<Maybe<ComponentIngredientsIngredientsInput>>>;
  allergens?: Maybe<Array<Maybe<ComponentAllergensAllergensInput>>>;
  characteristics?: Maybe<
    Array<Maybe<ComponentProductCharacteristicsProductCharacteristicsInput>>
  >;
};

export type ProduitRelationResponseCollection = {
  __typename?: 'ProduitRelationResponseCollection';
  data: Array<ProduitEntity>;
};

export type ProduitResult = {
  __typename?: 'ProduitResult';
  id: Scalars['ID'];
  name: Scalars['String'];
  ttcPrice: Scalars['Float'];
  ref: Scalars['Int'];
  venterebond: Scalars['Boolean'];
  media?: Maybe<Array<Maybe<MediaUrl>>>;
};

export type ProfDashboardClasse = {
  __typename?: 'ProfDashboardClasse';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  operationid?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
  filiere?: Maybe<ClasseFiliere>;
  lycee?: Maybe<ClasseLycee>;
  niveau?: Maybe<ClasseNiveau>;
  users?: Maybe<Array<Maybe<ProfDashboardUser>>>;
};

export type ProfDashboardUser = {
  __typename?: 'ProfDashboardUser';
  id?: Maybe<Scalars['ID']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  mdp?: Maybe<Scalars['String']>;
  shop?: Maybe<Scalars['String']>;
  role?: Maybe<UserRole>;
  avatar?: Maybe<UserAvatar>;
  note?: Maybe<UserNote>;
  quiztonotes?: Maybe<Array<Maybe<UserQuizToNote>>>;
  commandes?: Maybe<Array<Maybe<Commande>>>;
};

export type Query = {
  __typename?: 'Query';
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  academie?: Maybe<AcademieEntityResponse>;
  academies?: Maybe<AcademieEntityResponseCollection>;
  avatar?: Maybe<AvatarEntityResponse>;
  avatars?: Maybe<AvatarEntityResponseCollection>;
  categorieproduit?: Maybe<CategorieproduitEntityResponse>;
  categorieproduits?: Maybe<CategorieproduitEntityResponseCollection>;
  challenge?: Maybe<ChallengeEntityResponse>;
  challenges?: Maybe<ChallengeEntityResponseCollection>;
  challengeRessource?: Maybe<ChallengeRessourceEntityResponse>;
  challengeRessources?: Maybe<ChallengeRessourceEntityResponseCollection>;
  challengeRessourceType?: Maybe<ChallengeRessourceTypeEntityResponse>;
  challengeRessourceTypes?: Maybe<
    ChallengeRessourceTypeEntityResponseCollection
  >;
  challengetype?: Maybe<ChallengetypeEntityResponse>;
  challengetypes?: Maybe<ChallengetypeEntityResponseCollection>;
  classe?: Maybe<ClasseEntityResponse>;
  classes?: Maybe<ClasseEntityResponseCollection>;
  client?: Maybe<ClientEntityResponse>;
  clients?: Maybe<ClientEntityResponseCollection>;
  commande?: Maybe<CommandeEntityResponse>;
  commandes?: Maybe<CommandeEntityResponseCollection>;
  commandeline?: Maybe<CommandelineEntityResponse>;
  commandelines?: Maybe<CommandelineEntityResponseCollection>;
  competence?: Maybe<CompetenceEntityResponse>;
  competences?: Maybe<CompetenceEntityResponseCollection>;
  config?: Maybe<ConfigEntityResponse>;
  configs?: Maybe<ConfigEntityResponseCollection>;
  corbeille?: Maybe<CorbeilleEntityResponse>;
  corbeilles?: Maybe<CorbeilleEntityResponseCollection>;
  defi?: Maybe<DefiEntityResponse>;
  defis?: Maybe<DefiEntityResponseCollection>;
  faq?: Maybe<FaqEntityResponse>;
  faqs?: Maybe<FaqEntityResponseCollection>;
  filliere?: Maybe<FilliereEntityResponse>;
  fillieres?: Maybe<FilliereEntityResponseCollection>;
  formation?: Maybe<FormationEntityResponse>;
  formations?: Maybe<FormationEntityResponseCollection>;
  formationType?: Maybe<FormationTypeEntityResponse>;
  formationTypes?: Maybe<FormationTypeEntityResponseCollection>;
  lycee?: Maybe<LyceeEntityResponse>;
  lycees?: Maybe<LyceeEntityResponseCollection>;
  mailtpl?: Maybe<MailtplEntityResponse>;
  mailtpls?: Maybe<MailtplEntityResponseCollection>;
  niveau?: Maybe<NiveauEntityResponse>;
  niveaux?: Maybe<NiveauEntityResponseCollection>;
  note?: Maybe<NoteEntityResponse>;
  notes?: Maybe<NoteEntityResponseCollection>;
  noteclasse?: Maybe<NoteclasseEntityResponse>;
  noteclasses?: Maybe<NoteclasseEntityResponseCollection>;
  notification?: Maybe<NotificationEntityResponse>;
  notifications?: Maybe<NotificationEntityResponseCollection>;
  page?: Maybe<PageEntityResponse>;
  pages?: Maybe<PageEntityResponseCollection>;
  pedagogie?: Maybe<PedagogieEntityResponse>;
  pedagogies?: Maybe<PedagogieEntityResponseCollection>;
  pedagogieType?: Maybe<PedagogieTypeEntityResponse>;
  pedagogieTypes?: Maybe<PedagogieTypeEntityResponseCollection>;
  produit?: Maybe<ProduitEntityResponse>;
  produits?: Maybe<ProduitEntityResponseCollection>;
  question?: Maybe<QuestionEntityResponse>;
  questions?: Maybe<QuestionEntityResponseCollection>;
  questiontouser?: Maybe<QuestiontouserEntityResponse>;
  questiontousers?: Maybe<QuestiontouserEntityResponseCollection>;
  quiz?: Maybe<QuizEntityResponse>;
  quizzes?: Maybe<QuizEntityResponseCollection>;
  quizchance?: Maybe<QuizchanceEntityResponse>;
  quizchances?: Maybe<QuizchanceEntityResponseCollection>;
  quiztonote?: Maybe<QuiztonoteEntityResponse>;
  quiztonotes?: Maybe<QuiztonoteEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  pointRelais?: Maybe<Array<Maybe<Relais>>>;
  getUnpayedCo?: Maybe<UnpayedCa>;
  getUnpayedCoByEleve?: Maybe<Array<Maybe<UnPayedCaEleve>>>;
  getMyOrdersInClasse?: Maybe<GetMyOrdersInClasse>;
  getDefiById?: Maybe<Defi>;
  getHomeDefis?: Maybe<HomeDefis>;
  getMyPositions?: Maybe<UserRank>;
  getClassement?: Maybe<Array<Maybe<Rank>>>;
  getMyNoteInClasse?: Maybe<GetMyNoteInClasse>;
  getClassePosition?: Maybe<ClasseRank>;
  availableQuiz?: Maybe<Array<Maybe<AvailableQuiz>>>;
  findOneAvailableQuiz?: Maybe<Quiz>;
  shop?: Maybe<Shop>;
  eleve?: Maybe<Eleve>;
  findMyCommande?: Maybe<AddedCommande>;
  getUserOnHome?: Maybe<GetUserOnHome>;
  getUserClasse?: Maybe<UserClasseType>;
  getUserSoftSkills?: Maybe<GetUserSoftSkills>;
  getProfDashboard?: Maybe<GetProfDashboard>;
  getUserAccount?: Maybe<GetUserAccount>;
  findElevesWithOrders?: Maybe<ClasseWithEleves>;
  getCurrentClasseInfos?: Maybe<CurrentClasseInfosType>;
  getClasseWithNoteAndEleves?: Maybe<ClasseWithNoteAndStudentsOrders>;
  findRessourceByTypeId?: Maybe<Array<Maybe<Ressource>>>;
  findFormationByTypeId?: Maybe<Array<Maybe<FormationRessource>>>;
  findPedagogieByTypeId?: Maybe<Array<Maybe<PedagogieRessource>>>;
  findFormationTypeWithRelatedFormations?: Maybe<
    Array<Maybe<FormationTypeWithRelatedFormations>>
  >;
  findPedagogieTypeWithRelatedPedagogies?: Maybe<
    Array<Maybe<PedagogieTypeWithRelatedPedagogies>>
  >;
  findChallengeRessourceTypeWithRelatedChallengeRessources?: Maybe<
    Array<Maybe<ChallengeRessourceTypeWithRelatedChallengeRessources>>
  >;
};

export type QueryUploadFileArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryUploadFilesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryUploadFolderArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryUploadFoldersArgs = {
  filters?: Maybe<UploadFolderFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryI18NLocaleArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryI18NLocalesArgs = {
  filters?: Maybe<I18NLocaleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryUsersPermissionsRoleArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryUsersPermissionsRolesArgs = {
  filters?: Maybe<UsersPermissionsRoleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryUsersPermissionsUserArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryUsersPermissionsUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryAcademieArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryAcademiesArgs = {
  filters?: Maybe<AcademieFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryAvatarArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryAvatarsArgs = {
  filters?: Maybe<AvatarFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryCategorieproduitArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryCategorieproduitsArgs = {
  filters?: Maybe<CategorieproduitFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryChallengeArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryChallengesArgs = {
  filters?: Maybe<ChallengeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryChallengeRessourceArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryChallengeRessourcesArgs = {
  filters?: Maybe<ChallengeRessourceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryChallengeRessourceTypeArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryChallengeRessourceTypesArgs = {
  filters?: Maybe<ChallengeRessourceTypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryChallengetypeArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryChallengetypesArgs = {
  filters?: Maybe<ChallengetypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryClasseArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryClassesArgs = {
  filters?: Maybe<ClasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryClientArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryClientsArgs = {
  filters?: Maybe<ClientFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryCommandeArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryCommandesArgs = {
  filters?: Maybe<CommandeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryCommandelineArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryCommandelinesArgs = {
  filters?: Maybe<CommandelineFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryCompetenceArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryCompetencesArgs = {
  filters?: Maybe<CompetenceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryConfigArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryConfigsArgs = {
  filters?: Maybe<ConfigFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryCorbeilleArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryCorbeillesArgs = {
  filters?: Maybe<CorbeilleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryDefiArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryDefisArgs = {
  filters?: Maybe<DefiFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryFaqArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryFaqsArgs = {
  filters?: Maybe<FaqFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryFilliereArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryFillieresArgs = {
  filters?: Maybe<FilliereFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryFormationArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryFormationsArgs = {
  filters?: Maybe<FormationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryFormationTypeArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryFormationTypesArgs = {
  filters?: Maybe<FormationTypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryLyceeArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryLyceesArgs = {
  filters?: Maybe<LyceeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryMailtplArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryMailtplsArgs = {
  filters?: Maybe<MailtplFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryNiveauArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryNiveauxArgs = {
  filters?: Maybe<NiveauFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryNoteArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryNotesArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryNoteclasseArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryNoteclassesArgs = {
  filters?: Maybe<NoteclasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryNotificationArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryNotificationsArgs = {
  filters?: Maybe<NotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryPageArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryPagesArgs = {
  filters?: Maybe<PageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryPedagogieArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryPedagogiesArgs = {
  filters?: Maybe<PedagogieFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryPedagogieTypeArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryPedagogieTypesArgs = {
  filters?: Maybe<PedagogieTypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryProduitArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryProduitsArgs = {
  filters?: Maybe<ProduitFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryQuestionArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryQuestionsArgs = {
  filters?: Maybe<QuestionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryQuestiontouserArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryQuestiontousersArgs = {
  filters?: Maybe<QuestiontouserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryQuizArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryQuizzesArgs = {
  filters?: Maybe<QuizFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryQuizchanceArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryQuizchancesArgs = {
  filters?: Maybe<QuizchanceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryQuiztonoteArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryQuiztonotesArgs = {
  filters?: Maybe<QuiztonoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryPointRelaisArgs = {
  address?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
  city?: Maybe<Scalars['String']>;
};

export type QueryGetMyOrdersInClasseArgs = {
  userId: Scalars['ID'];
};

export type QueryGetDefiByIdArgs = {
  id: Scalars['ID'];
};

export type QueryGetClassementArgs = {
  tableau?: Maybe<Scalars['String']>;
};

export type QueryGetMyNoteInClasseArgs = {
  userId: Scalars['ID'];
};

export type QueryGetClassePositionArgs = {
  classe?: Maybe<Scalars['ID']>;
};

export type QueryAvailableQuizArgs = {
  all?: Maybe<Scalars['Boolean']>;
};

export type QueryFindOneAvailableQuizArgs = {
  id: Scalars['ID'];
};

export type QueryShopArgs = {
  id?: Maybe<Scalars['ID']>;
  classeId?: Maybe<Scalars['ID']>;
  categorieproduits?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryEleveArgs = {
  id: Scalars['ID'];
  classeId: Scalars['ID'];
};

export type QueryFindMyCommandeArgs = {
  id: Scalars['ID'];
  numerocommande: Scalars['String'];
  classeId: Scalars['ID'];
};

export type QueryGetUserAccountArgs = {
  userId: Scalars['ID'];
};

export type QueryFindRessourceByTypeIdArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryFindFormationByTypeIdArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryFindPedagogieByTypeIdArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type Question = {
  __typename?: 'Question';
  name?: Maybe<Scalars['String']>;
  reponse1?: Maybe<Scalars['String']>;
  reponse2?: Maybe<Scalars['String']>;
  reponse3?: Maybe<Scalars['String']>;
  corrige?: Maybe<Scalars['String']>;
  point?: Maybe<Scalars['Int']>;
  correct?: Maybe<Scalars['Int']>;
  competence?: Maybe<CompetenceEntityResponse>;
  questiontousers?: Maybe<QuestiontouserRelationResponseCollection>;
  quizzes?: Maybe<QuizRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QuestionQuestiontousersArgs = {
  filters?: Maybe<QuestiontouserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuestionQuizzesArgs = {
  filters?: Maybe<QuizFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuestionEntity = {
  __typename?: 'QuestionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Question>;
};

export type QuestionEntityResponse = {
  __typename?: 'QuestionEntityResponse';
  data?: Maybe<QuestionEntity>;
};

export type QuestionEntityResponseCollection = {
  __typename?: 'QuestionEntityResponseCollection';
  data: Array<QuestionEntity>;
  meta: ResponseCollectionMeta;
};

export type QuestionFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  reponse1?: Maybe<StringFilterInput>;
  reponse2?: Maybe<StringFilterInput>;
  reponse3?: Maybe<StringFilterInput>;
  corrige?: Maybe<StringFilterInput>;
  point?: Maybe<IntFilterInput>;
  correct?: Maybe<IntFilterInput>;
  competence?: Maybe<CompetenceFiltersInput>;
  questiontousers?: Maybe<QuestiontouserFiltersInput>;
  quizzes?: Maybe<QuizFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<QuestionFiltersInput>>>;
  or?: Maybe<Array<Maybe<QuestionFiltersInput>>>;
  not?: Maybe<QuestionFiltersInput>;
};

export type QuestionInput = {
  name?: Maybe<Scalars['String']>;
  reponse1?: Maybe<Scalars['String']>;
  reponse2?: Maybe<Scalars['String']>;
  reponse3?: Maybe<Scalars['String']>;
  corrige?: Maybe<Scalars['String']>;
  point?: Maybe<Scalars['Int']>;
  correct?: Maybe<Scalars['Int']>;
  competence?: Maybe<Scalars['ID']>;
  questiontousers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quizzes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type QuestionRelationResponseCollection = {
  __typename?: 'QuestionRelationResponseCollection';
  data: Array<QuestionEntity>;
};

export type Questiontouser = {
  __typename?: 'Questiontouser';
  correct?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
  question?: Maybe<QuestionEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QuestiontouserEntity = {
  __typename?: 'QuestiontouserEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Questiontouser>;
};

export type QuestiontouserEntityResponse = {
  __typename?: 'QuestiontouserEntityResponse';
  data?: Maybe<QuestiontouserEntity>;
};

export type QuestiontouserEntityResponseCollection = {
  __typename?: 'QuestiontouserEntityResponseCollection';
  data: Array<QuestiontouserEntity>;
  meta: ResponseCollectionMeta;
};

export type QuestiontouserFiltersInput = {
  id?: Maybe<IdFilterInput>;
  correct?: Maybe<BooleanFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  question?: Maybe<QuestionFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<QuestiontouserFiltersInput>>>;
  or?: Maybe<Array<Maybe<QuestiontouserFiltersInput>>>;
  not?: Maybe<QuestiontouserFiltersInput>;
};

export type QuestiontouserInput = {
  correct?: Maybe<Scalars['Boolean']>;
  user?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['ID']>;
};

export type QuestiontouserRelationResponseCollection = {
  __typename?: 'QuestiontouserRelationResponseCollection';
  data: Array<QuestiontouserEntity>;
};

export type Quiz = {
  __typename?: 'Quiz';
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  corrige?: Maybe<Scalars['String']>;
  publier?: Maybe<Scalars['Boolean']>;
  debut?: Maybe<Scalars['DateTime']>;
  fin?: Maybe<Scalars['DateTime']>;
  quizlet?: Maybe<Scalars['String']>;
  questions?: Maybe<QuestionRelationResponseCollection>;
  competences?: Maybe<CompetenceRelationResponseCollection>;
  fillieres?: Maybe<FilliereRelationResponseCollection>;
  niveaus?: Maybe<NiveauRelationResponseCollection>;
  quiztonotes?: Maybe<QuiztonoteRelationResponseCollection>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  quizchances?: Maybe<QuizchanceRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QuizQuestionsArgs = {
  filters?: Maybe<QuestionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizCompetencesArgs = {
  filters?: Maybe<CompetenceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizFillieresArgs = {
  filters?: Maybe<FilliereFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizNiveausArgs = {
  filters?: Maybe<NiveauFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizQuiztonotesArgs = {
  filters?: Maybe<QuiztonoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizQuizchancesArgs = {
  filters?: Maybe<QuizchanceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Quizchance = {
  __typename?: 'Quizchance';
  fin?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  quiz?: Maybe<QuizEntityResponse>;
  classes?: Maybe<ClasseRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QuizchanceUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizchanceClassesArgs = {
  filters?: Maybe<ClasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QuizchanceEntity = {
  __typename?: 'QuizchanceEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Quizchance>;
};

export type QuizchanceEntityResponse = {
  __typename?: 'QuizchanceEntityResponse';
  data?: Maybe<QuizchanceEntity>;
};

export type QuizchanceEntityResponseCollection = {
  __typename?: 'QuizchanceEntityResponseCollection';
  data: Array<QuizchanceEntity>;
  meta: ResponseCollectionMeta;
};

export type QuizchanceFiltersInput = {
  id?: Maybe<IdFilterInput>;
  fin?: Maybe<DateTimeFilterInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  quiz?: Maybe<QuizFiltersInput>;
  classes?: Maybe<ClasseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<QuizchanceFiltersInput>>>;
  or?: Maybe<Array<Maybe<QuizchanceFiltersInput>>>;
  not?: Maybe<QuizchanceFiltersInput>;
};

export type QuizchanceInput = {
  fin?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quiz?: Maybe<Scalars['ID']>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type QuizchanceRelationResponseCollection = {
  __typename?: 'QuizchanceRelationResponseCollection';
  data: Array<QuizchanceEntity>;
};

export type QuizEntity = {
  __typename?: 'QuizEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Quiz>;
};

export type QuizEntityResponse = {
  __typename?: 'QuizEntityResponse';
  data?: Maybe<QuizEntity>;
};

export type QuizEntityResponseCollection = {
  __typename?: 'QuizEntityResponseCollection';
  data: Array<QuizEntity>;
  meta: ResponseCollectionMeta;
};

export type QuizFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  desc?: Maybe<StringFilterInput>;
  corrige?: Maybe<StringFilterInput>;
  publier?: Maybe<BooleanFilterInput>;
  debut?: Maybe<DateTimeFilterInput>;
  fin?: Maybe<DateTimeFilterInput>;
  quizlet?: Maybe<StringFilterInput>;
  questions?: Maybe<QuestionFiltersInput>;
  competences?: Maybe<CompetenceFiltersInput>;
  fillieres?: Maybe<FilliereFiltersInput>;
  niveaus?: Maybe<NiveauFiltersInput>;
  quiztonotes?: Maybe<QuiztonoteFiltersInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  quizchances?: Maybe<QuizchanceFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<QuizFiltersInput>>>;
  or?: Maybe<Array<Maybe<QuizFiltersInput>>>;
  not?: Maybe<QuizFiltersInput>;
};

export type QuizInput = {
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  corrige?: Maybe<Scalars['String']>;
  publier?: Maybe<Scalars['Boolean']>;
  debut?: Maybe<Scalars['DateTime']>;
  fin?: Maybe<Scalars['DateTime']>;
  quizlet?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  competences?: Maybe<Array<Maybe<Scalars['ID']>>>;
  fillieres?: Maybe<Array<Maybe<Scalars['ID']>>>;
  niveaus?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quiztonotes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quizchances?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type QuizRelationResponseCollection = {
  __typename?: 'QuizRelationResponseCollection';
  data: Array<QuizEntity>;
};

export type QuizRep = {
  question?: Maybe<QuizRepQuestion>;
  reponse?: Maybe<QuizRepReponse>;
};

export type QuizRepQuestion = {
  question?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type QuizRepReponse = {
  reponseName?: Maybe<Scalars['String']>;
  reponseNumber?: Maybe<Scalars['Float']>;
};

export type Quiztonote = {
  __typename?: 'Quiztonote';
  note?: Maybe<Scalars['Int']>;
  crondate?: Maybe<Scalars['DateTime']>;
  noteauto?: Maybe<Enum_Quiztonote_Noteauto>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
  quiz?: Maybe<QuizEntityResponse>;
  responses?: Maybe<Scalars['JSON']>;
  classe?: Maybe<ClasseEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type QuiztonoteEntity = {
  __typename?: 'QuiztonoteEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Quiztonote>;
};

export type QuiztonoteEntityResponse = {
  __typename?: 'QuiztonoteEntityResponse';
  data?: Maybe<QuiztonoteEntity>;
};

export type QuiztonoteEntityResponseCollection = {
  __typename?: 'QuiztonoteEntityResponseCollection';
  data: Array<QuiztonoteEntity>;
  meta: ResponseCollectionMeta;
};

export type QuiztonoteFiltersInput = {
  id?: Maybe<IdFilterInput>;
  note?: Maybe<IntFilterInput>;
  crondate?: Maybe<DateTimeFilterInput>;
  noteauto?: Maybe<StringFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  quiz?: Maybe<QuizFiltersInput>;
  responses?: Maybe<JsonFilterInput>;
  classe?: Maybe<ClasseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<QuiztonoteFiltersInput>>>;
  or?: Maybe<Array<Maybe<QuiztonoteFiltersInput>>>;
  not?: Maybe<QuiztonoteFiltersInput>;
};

export type QuiztonoteInput = {
  note?: Maybe<Scalars['Int']>;
  crondate?: Maybe<Scalars['DateTime']>;
  noteauto?: Maybe<Enum_Quiztonote_Noteauto>;
  user?: Maybe<Scalars['ID']>;
  quiz?: Maybe<Scalars['ID']>;
  responses?: Maybe<Scalars['JSON']>;
  classe?: Maybe<Scalars['ID']>;
};

export type QuiztonoteRelationResponseCollection = {
  __typename?: 'QuiztonoteRelationResponseCollection';
  data: Array<QuiztonoteEntity>;
};

export type Rank = {
  __typename?: 'Rank';
  rank?: Maybe<Scalars['Int']>;
  moyennegenerale?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  avatar?: Maybe<MediaAvatar>;
  id?: Maybe<Scalars['String']>;
  elId?: Maybe<Scalars['String']>;
};

export type Relais = {
  __typename?: 'Relais';
  accesPersonneMobiliteReduite?: Maybe<Scalars['Boolean']>;
  actif?: Maybe<Scalars['Boolean']>;
  adresse1?: Maybe<Scalars['String']>;
  adresse2?: Maybe<Scalars['String']>;
  adresse3?: Maybe<Scalars['String']>;
  codePays?: Maybe<Scalars['String']>;
  codePostal?: Maybe<Scalars['Int']>;
  coordGeolocalisationLatitude?: Maybe<Scalars['String']>;
  coordGeolocalisationLongitude?: Maybe<Scalars['String']>;
  distanceEnMetre?: Maybe<Scalars['Int']>;
  identifiant?: Maybe<Scalars['String']>;
  indiceDeLocalisation?: Maybe<Scalars['String']>;
  listeHoraireOuverture?: Maybe<Scalars['String']>;
  localite?: Maybe<Scalars['String']>;
  nom?: Maybe<Scalars['String']>;
  poidsMaxi?: Maybe<Scalars['Int']>;
  typeDePoint?: Maybe<Scalars['String']>;
  urlGoogleMaps?: Maybe<Scalars['String']>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type Ressource = {
  __typename?: 'Ressource';
  name?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  ressources?: Maybe<Array<Maybe<RessourceLink>>>;
};

export type RessourceLink = {
  __typename?: 'RessourceLink';
  titre?: Maybe<Scalars['String']>;
  type?: Maybe<RessourceType>;
  lien?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<RessourceMedia>>>;
};

export type RessourceMedia = {
  __typename?: 'RessourceMedia';
  url?: Maybe<Scalars['String']>;
};

export type RessourceType = {
  __typename?: 'RessourceType';
  nom?: Maybe<Scalars['String']>;
};

export type Sherlock = {
  __typename?: 'Sherlock';
  data: Scalars['String'];
  redirectionUrl: Scalars['String'];
  interfaceVersion: Scalars['String'];
  seal: Scalars['String'];
  automaticResponseUrl: Scalars['String'];
};

export type Shop = {
  __typename?: 'Shop';
  produits?: Maybe<Array<Maybe<ProduitEntity>>>;
  eleve?: Maybe<Eleve>;
};

export type StringFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['String']>>>;
  or?: Maybe<Array<Maybe<Scalars['String']>>>;
  not?: Maybe<StringFilterInput>;
  eq?: Maybe<Scalars['String']>;
  eqi?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  containsi?: Maybe<Scalars['String']>;
  notContainsi?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TypeObjective = {
  __typename?: 'TypeObjective';
  name?: Maybe<Scalars['String']>;
  ca?: Maybe<Scalars['String']>;
};

export type UnpayedCa = {
  __typename?: 'UnpayedCa';
  classe?: Maybe<Scalars['Float']>;
  eleve?: Maybe<Scalars['Float']>;
};

export type UnPayedCaEleve = {
  __typename?: 'UnPayedCaEleve';
  id?: Maybe<Scalars['Int']>;
  unpayedCA?: Maybe<Scalars['Float']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UploadFile>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  alternativeText?: Maybe<StringFilterInput>;
  caption?: Maybe<StringFilterInput>;
  width?: Maybe<IntFilterInput>;
  height?: Maybe<IntFilterInput>;
  formats?: Maybe<JsonFilterInput>;
  hash?: Maybe<StringFilterInput>;
  ext?: Maybe<StringFilterInput>;
  mime?: Maybe<StringFilterInput>;
  size?: Maybe<FloatFilterInput>;
  url?: Maybe<StringFilterInput>;
  previewUrl?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  provider_metadata?: Maybe<JsonFilterInput>;
  folder?: Maybe<UploadFolderFiltersInput>;
  folderPath?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  or?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  not?: Maybe<UploadFileFiltersInput>;
};

export type UploadFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  folder?: Maybe<Scalars['ID']>;
  folderPath?: Maybe<Scalars['String']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  name: Scalars['String'];
  pathId: Scalars['Int'];
  parent?: Maybe<UploadFolderEntityResponse>;
  children?: Maybe<UploadFolderRelationResponseCollection>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  path: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UploadFolderChildrenArgs = {
  filters?: Maybe<UploadFolderFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UploadFolderFilesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UploadFolder>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  pathId?: Maybe<IntFilterInput>;
  parent?: Maybe<UploadFolderFiltersInput>;
  children?: Maybe<UploadFolderFiltersInput>;
  files?: Maybe<UploadFileFiltersInput>;
  path?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UploadFolderFiltersInput>>>;
  or?: Maybe<Array<Maybe<UploadFolderFiltersInput>>>;
  not?: Maybe<UploadFolderFiltersInput>;
};

export type UploadFolderInput = {
  name?: Maybe<Scalars['String']>;
  pathId?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['ID']>;
  children?: Maybe<Array<Maybe<Scalars['ID']>>>;
  files?: Maybe<Array<Maybe<Scalars['ID']>>>;
  path?: Maybe<Scalars['String']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type Url = {
  __typename?: 'Url';
  url?: Maybe<Scalars['String']>;
};

export type UrlAvatar = {
  __typename?: 'UrlAvatar';
  url?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  classe?: Maybe<UserClasse>;
};

export type UserAccountClasse = {
  __typename?: 'UserAccountClasse';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  operationid?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
  filiere?: Maybe<ClasseFiliere>;
  lycee?: Maybe<ClasseLycee>;
  niveau?: Maybe<ClasseNiveau>;
};

export type UserAvatar = {
  __typename?: 'userAvatar';
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<AvatarMediaUrl>;
};

export type UserClasse = {
  __typename?: 'UserClasse';
  debut: Scalars['String'];
  fin: Scalars['String'];
  operationid: Scalars['String'];
  filliere: FilliereResult;
  lycee: LyceeResult;
  niveau: NiveauResult;
};

export type UserClasseNoteclasse = {
  __typename?: 'UserClasseNoteclasse';
  cavente?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Float']>;
  qteca?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Float']>;
  qterebond?: Maybe<Scalars['Float']>;
  qtequiz?: Maybe<Scalars['Float']>;
};

export type UserClasseType = {
  __typename?: 'userClasseType';
  name?: Maybe<Scalars['String']>;
  debut?: Maybe<Scalars['String']>;
  fin?: Maybe<Scalars['String']>;
  operationid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lycee?: Maybe<Scalars['String']>;
};

export type UserClasseUsers = {
  __typename?: 'UserClasseUsers';
  role?: Maybe<UserRole>;
  commandes?: Maybe<Array<Maybe<UserCommandeStatus>>>;
};

export type UserClasseWithAllInfos = {
  __typename?: 'UserClasseWithAllInfos';
  commandes?: Maybe<Scalars['Float']>;
  unpayedOrders?: Maybe<Scalars['Float']>;
  users?: Maybe<Array<Maybe<UserClasseUsers>>>;
  noteclasse?: Maybe<UserClasseNoteclasse>;
};

export type UserCommandeStatus = {
  __typename?: 'UserCommandeStatus';
  status?: Maybe<Scalars['String']>;
};

export type UserIdType = {
  __typename?: 'UserIdType';
  id: Scalars['ID'];
};

export type UserNote = {
  __typename?: 'UserNote';
  qteca?: Maybe<Scalars['Float']>;
  qtevente?: Maybe<Scalars['Float']>;
  qtepro?: Maybe<Scalars['Float']>;
  qtequiz?: Maybe<Scalars['Float']>;
  qterebond?: Maybe<Scalars['Float']>;
  moyennegenerale?: Maybe<Scalars['Float']>;
  quiz?: Maybe<Scalars['Float']>;
  pro?: Maybe<Scalars['Float']>;
  venterebond?: Maybe<Scalars['Float']>;
  nbvente?: Maybe<Scalars['Float']>;
  cavente?: Maybe<Scalars['Float']>;
};

export type UserQuizToNote = {
  __typename?: 'UserQuizToNote';
  note?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  quiz?: Maybe<UserQuizToNoteQuiz>;
};

export type UserQuizToNoteQuiz = {
  __typename?: 'UserQuizToNoteQuiz';
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type UserRank = {
  __typename?: 'userRank';
  classeRank?: Maybe<Scalars['Int']>;
  academieRank?: Maybe<Scalars['Int']>;
  niveauRank?: Maybe<Scalars['Int']>;
  nationalRank?: Maybe<Scalars['Int']>;
  moyennegenerale?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  avatar?: Maybe<MediaAvatar>;
  id?: Maybe<Scalars['String']>;
  elId?: Maybe<Scalars['String']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UsersPermissionsPermission>;
};

export type UsersPermissionsPermissionFiltersInput = {
  id?: Maybe<IdFilterInput>;
  action?: Maybe<StringFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  not?: Maybe<UsersPermissionsPermissionFiltersInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsRolePermissionsArgs = {
  filters?: Maybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  permissions?: Maybe<UsersPermissionsPermissionFiltersInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  not?: Maybe<UsersPermissionsRoleFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  commandes?: Maybe<CommandeRelationResponseCollection>;
  notes?: Maybe<NoteRelationResponseCollection>;
  questiontousers?: Maybe<QuestiontouserRelationResponseCollection>;
  quizchances?: Maybe<QuizchanceRelationResponseCollection>;
  quiztonotes?: Maybe<QuiztonoteRelationResponseCollection>;
  quizzes?: Maybe<QuizRelationResponseCollection>;
  classes?: Maybe<ClasseRelationResponseCollection>;
  avatar?: Maybe<AvatarEntityResponse>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  shop?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  appversion?: Maybe<Scalars['String']>;
  mdp?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JSON']>;
  isPairTeacher?: Maybe<Scalars['Boolean']>;
  ong?: Maybe<Enum_Userspermissionsuser_Ong>;
  defis?: Maybe<DefiRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUserCommandesArgs = {
  filters?: Maybe<CommandeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserNotesArgs = {
  filters?: Maybe<NoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserQuestiontousersArgs = {
  filters?: Maybe<QuestiontouserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserQuizchancesArgs = {
  filters?: Maybe<QuizchanceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserQuiztonotesArgs = {
  filters?: Maybe<QuiztonoteFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserQuizzesArgs = {
  filters?: Maybe<QuizFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserClassesArgs = {
  filters?: Maybe<ClasseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserDefisArgs = {
  filters?: Maybe<DefiFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  id?: Maybe<IdFilterInput>;
  username?: Maybe<StringFilterInput>;
  email?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  password?: Maybe<StringFilterInput>;
  resetPasswordToken?: Maybe<StringFilterInput>;
  confirmationToken?: Maybe<StringFilterInput>;
  confirmed?: Maybe<BooleanFilterInput>;
  blocked?: Maybe<BooleanFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  commandes?: Maybe<CommandeFiltersInput>;
  notes?: Maybe<NoteFiltersInput>;
  questiontousers?: Maybe<QuestiontouserFiltersInput>;
  quizchances?: Maybe<QuizchanceFiltersInput>;
  quiztonotes?: Maybe<QuiztonoteFiltersInput>;
  quizzes?: Maybe<QuizFiltersInput>;
  classes?: Maybe<ClasseFiltersInput>;
  avatar?: Maybe<AvatarFiltersInput>;
  firstname?: Maybe<StringFilterInput>;
  lastname?: Maybe<StringFilterInput>;
  ville?: Maybe<StringFilterInput>;
  shop?: Maybe<StringFilterInput>;
  tel?: Maybe<StringFilterInput>;
  zohoid?: Maybe<StringFilterInput>;
  appversion?: Maybe<StringFilterInput>;
  mdp?: Maybe<StringFilterInput>;
  options?: Maybe<JsonFilterInput>;
  isPairTeacher?: Maybe<BooleanFilterInput>;
  ong?: Maybe<StringFilterInput>;
  defis?: Maybe<DefiFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  not?: Maybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  commandes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  questiontousers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quizchances?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quiztonotes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  quizzes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  avatar?: Maybe<Scalars['ID']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  shop?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  zohoid?: Maybe<Scalars['String']>;
  appversion?: Maybe<Scalars['String']>;
  mdp?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JSON']>;
  isPairTeacher?: Maybe<Scalars['Boolean']>;
  ong?: Maybe<Enum_Userspermissionsuser_Ong>;
  defis?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type UserWithNoteAndOrders = {
  __typename?: 'UserWithNoteAndOrders';
  commandes?: Maybe<Array<Maybe<OrdersWithStatusAndContribution>>>;
  note?: Maybe<NotesWithQteca>;
};

export type WinnersUser = {
  __typename?: 'WinnersUser';
  id?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
  avatar?: Maybe<AvatarWinnersUser>;
  classes?: Maybe<Array<Maybe<ClassesWinnersUser>>>;
};

export type AcademieInfoFragment = { __typename?: 'AcademieEntity' } & {
  attributes?: Maybe<{ __typename?: 'Academie' } & Pick<Academie, 'name'>>;
};

export type ClasseInfoFragment = { __typename?: 'Classe' } & Pick<
  Classe,
  'debut' | 'fin' | 'name' | 'operationid'
> & {
    filliere?: Maybe<
      { __typename?: 'FilliereEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'FilliereEntity' } & Pick<FilliereEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Filliere' } & Pick<Filliere, 'name'>
              >;
            }
        >;
      }
    >;
    lycee?: Maybe<
      { __typename?: 'LyceeEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'LyceeEntity' } & Pick<LyceeEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Lycee' } & Pick<Lycee, 'name'>
              >;
            }
        >;
      }
    >;
    niveau?: Maybe<
      { __typename?: 'NiveauEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'NiveauEntity' } & Pick<NiveauEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Niveau' } & Pick<Niveau, 'name'>
              >;
            }
        >;
      }
    >;
  };

export type QuantiteClasseFragment = { __typename?: 'Noteclasse' } & Pick<
  Noteclasse,
  'qtevente' | 'qtepro' | 'qtequiz' | 'qterebond' | 'qteca'
>;

export type MainFragment = { __typename?: 'Client' } & Pick<
  Client,
  | 'civilite'
  | 'nom'
  | 'prenom'
  | 'adressefacturation'
  | 'cpfacturation'
  | 'villefacturation'
  | 'tel'
  | 'mail'
  | 'livraisonhorslycee'
  | 'civilitelivraison'
  | 'prenomlivraison'
  | 'nomlivraison'
  | 'adresselivraison'
  | 'cplivraison'
  | 'villelivraison'
  | 'mobilelivraison'
  | 'clientpro'
  | 'nomsociete'
  | 'policy'
  | 'affilie'
  | 'nompointrelais'
>;

export type ClientResultFragment = { __typename?: 'ClientResult' } & Pick<
  ClientResult,
  | 'id'
  | 'civilite'
  | 'nom'
  | 'prenom'
  | 'adressefacturation'
  | 'cpfacturation'
  | 'villefacturation'
  | 'tel'
  | 'mail'
  | 'livraisonhorslycee'
  | 'civilitelivraison'
  | 'prenomlivraison'
  | 'nomlivraison'
  | 'adresselivraison'
  | 'cplivraison'
  | 'villelivraison'
  | 'mobilelivraison'
  | 'clientpro'
  | 'nomsociete'
  | 'policy'
  | 'affilie'
  | 'nompointrelais'
>;

export type MainCommandeFragment = { __typename?: 'Commande' } & Pick<
  Commande,
  | 'createdAt'
  | 'fraislivraison'
  | 'methodepaiement'
  | 'numerocommande'
  | 'payment'
  | 'totalttc'
  | 'status'
  | 'prixTotal'
  | 'customerContributedToTheOng'
>;

export type DetailsCommandeFragment = { __typename?: 'Commande' } & Pick<
  Commande,
  | 'createdAt'
  | 'fraislivraison'
  | 'methodepaiement'
  | 'numerocommande'
  | 'customerContributedToTheOng'
  | 'payment'
  | 'totalttc'
  | 'status'
  | 'controlled'
  | 'livraison'
  | 'paymentreminder'
  | 'prixTotal'
> & {
    user?: Maybe<
      { __typename?: 'UsersPermissionsUserEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'UsersPermissionsUserEntity' } & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsUser' } & Pick<
                UsersPermissionsUser,
                'firstname' | 'lastname'
              >
            >;
          }
        >;
      }
    >;
    client?: Maybe<
      { __typename?: 'ClientEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'ClientEntity' } & Pick<ClientEntity, 'id'> & {
              attributes?: Maybe<{ __typename?: 'Client' } & MainFragment>;
            }
        >;
      }
    >;
    commandelines?: Maybe<
      { __typename?: 'CommandelineRelationResponseCollection' } & {
        data: Array<
          { __typename?: 'CommandelineEntity' } & Pick<
            CommandelineEntity,
            'id'
          > & {
              attributes?: Maybe<
                { __typename?: 'Commandeline' } & MainCommandelineFragment
              >;
            }
        >;
      }
    >;
  };

export type MainCommandelineFragment = { __typename?: 'Commandeline' } & Pick<
  Commandeline,
  'quantite'
> & {
    produit?: Maybe<
      { __typename?: 'ProduitEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'ProduitEntity' } & Pick<ProduitEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Produit' } & Pick<
                  Produit,
                  'name' | 'ttcPrice' | 'ref' | 'venterebond'
                > & {
                    media?: Maybe<
                      {
                        __typename?: 'UploadFileRelationResponseCollection';
                      } & {
                        data: Array<
                          { __typename?: 'UploadFileEntity' } & {
                            attributes?: Maybe<
                              { __typename?: 'UploadFile' } & Pick<
                                UploadFile,
                                'url'
                              >
                            >;
                          }
                        >;
                      }
                    >;
                  }
              >;
            }
        >;
      }
    >;
  };

export type FilliereInfoFragment = { __typename?: 'Filliere' } & Pick<
  Filliere,
  'name'
>;

export type NiveauInfoFragment = { __typename?: 'Niveau' } & Pick<
  Niveau,
  'name'
>;

export type QuantiteFragment = { __typename?: 'Note' } & Pick<
  Note,
  'qtevente' | 'qtepro' | 'qtequiz' | 'qterebond' | 'qteca'
>;

export type MoyenneFragment = { __typename?: 'Note' } & Pick<
  Note,
  'cavente' | 'nbvente' | 'venterebond' | 'pro' | 'moyennegenerale' | 'quiz'
>;

export type UserLeaderBoardFragment = { __typename?: 'Note' } & {
  user?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & Pick<
          UsersPermissionsUserEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsUser' } & Pick<
                UsersPermissionsUser,
                'firstname' | 'lastname' | 'ville'
              > & {
                  avatar?: Maybe<
                    { __typename?: 'AvatarEntityResponse' } & {
                      data?: Maybe<
                        { __typename?: 'AvatarEntity' } & Pick<
                          AvatarEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'Avatar' } & {
                                media?: Maybe<
                                  {
                                    __typename?: 'UploadFileEntityResponse';
                                  } & {
                                    data?: Maybe<
                                      {
                                        __typename?: 'UploadFileEntity';
                                      } & Pick<UploadFileEntity, 'id'> & {
                                          attributes?: Maybe<
                                            {
                                              __typename?: 'UploadFile';
                                            } & Pick<UploadFile, 'url'>
                                          >;
                                        }
                                    >;
                                  }
                                >;
                              }
                            >;
                          }
                      >;
                    }
                  >;
                  notes?: Maybe<
                    { __typename?: 'NoteRelationResponseCollection' } & {
                      data: Array<
                        { __typename?: 'NoteEntity' } & Pick<
                          NoteEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'Note' } & Pick<
                                Note,
                                'moyennegenerale'
                              >
                            >;
                          }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type EleveDashBoardProfFragment = {
  __typename?: 'UsersPermissionsUser';
} & Pick<
  UsersPermissionsUser,
  'username' | 'email' | 'firstname' | 'lastname' | 'ville' | 'mdp' | 'shop'
> & {
    role?: Maybe<
      { __typename?: 'UsersPermissionsRoleEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'UsersPermissionsRoleEntity' } & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsRole' } & Pick<
                UsersPermissionsRole,
                'name'
              >
            >;
          }
        >;
      }
    >;
    quiztonotes?: Maybe<
      { __typename?: 'QuiztonoteRelationResponseCollection' } & {
        data: Array<
          { __typename?: 'QuiztonoteEntity' } & {
            attributes?: Maybe<
              { __typename?: 'Quiztonote' } & Pick<
                Quiztonote,
                'note' | 'createdAt'
              > & {
                  quiz?: Maybe<
                    { __typename?: 'QuizEntityResponse' } & {
                      data?: Maybe<
                        { __typename?: 'QuizEntity' } & Pick<QuizEntity, 'id'>
                      >;
                    }
                  >;
                }
            >;
          }
        >;
      }
    >;
    avatar?: Maybe<
      { __typename?: 'AvatarEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'AvatarEntity' } & Pick<AvatarEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Avatar' } & {
                  media?: Maybe<
                    { __typename?: 'UploadFileEntityResponse' } & {
                      data?: Maybe<
                        { __typename?: 'UploadFileEntity' } & Pick<
                          UploadFileEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'UploadFile' } & Pick<
                                UploadFile,
                                'url'
                              >
                            >;
                          }
                      >;
                    }
                  >;
                }
              >;
            }
        >;
      }
    >;
    notes?: Maybe<
      { __typename?: 'NoteRelationResponseCollection' } & {
        data: Array<
          { __typename?: 'NoteEntity' } & Pick<NoteEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Note' } & Pick<
                  Note,
                  'createdAt' | 'updatedAt' | 'nbvente'
                >
              >;
            }
        >;
      }
    >;
  };

export type RankFragment = { __typename?: 'Rank' } & Pick<
  Rank,
  | 'rank'
  | 'moyennegenerale'
  | 'username'
  | 'firstname'
  | 'lastname'
  | 'ville'
  | 'elId'
> & {
    avatar?: Maybe<
      { __typename?: 'MediaAvatar' } & {
        media?: Maybe<{ __typename?: 'UrlAvatar' } & Pick<UrlAvatar, 'url'>>;
      }
    >;
  };

export type ChallengeNoteFragment = { __typename?: 'Note' } & Pick<
  Note,
  'cavente' | 'quiz' | 'nbvente' | 'venterebond' | 'pro' | 'moyennegenerale'
>;

export type NoteDesQuizFragment = { __typename?: 'Quiztonote' } & Pick<
  Quiztonote,
  'note'
> & {
    quiz?: Maybe<
      { __typename?: 'QuizEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'QuizEntity' } & Pick<QuizEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Quiz' } & Pick<Quiz, 'name' | 'debut' | 'fin'>
              >;
            }
        >;
      }
    >;
  };

export type GetPedagogieByChallengeTypeFragment = {
  __typename?: 'Challenge';
} & {
  challengetypes?: Maybe<
    { __typename?: 'ChallengetypeRelationResponseCollection' } & {
      data: Array<
        { __typename?: 'ChallengetypeEntity' } & Pick<
          ChallengetypeEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'Challengetype' } & {
                pedagogies?: Maybe<
                  { __typename?: 'PedagogieRelationResponseCollection' } & {
                    data: Array<
                      { __typename?: 'PedagogieEntity' } & Pick<
                        PedagogieEntity,
                        'id'
                      > & {
                          attributes?: Maybe<
                            { __typename?: 'Pedagogie' } & Pick<
                              Pedagogie,
                              'name' | 'subtitle' | 'info' | 'desc' | 'order'
                            > & {
                                pedagogie_type?: Maybe<
                                  {
                                    __typename?: 'PedagogieTypeEntityResponse';
                                  } & {
                                    data?: Maybe<
                                      {
                                        __typename?: 'PedagogieTypeEntity';
                                      } & Pick<PedagogieTypeEntity, 'id'>
                                    >;
                                  }
                                >;
                              }
                          >;
                        }
                    >;
                  }
                >;
              }
            >;
          }
      >;
    }
  >;
};

export type MainProductsFragment = { __typename?: 'Produit' } & Pick<
  Produit,
  | 'name'
  | 'netWeight'
  | 'ttcPrice'
  | 'description'
  | 'catchPhrase'
  | 'venterebond'
  | 'ref'
  | 'isOut'
> & {
    categorieproduits?: Maybe<
      { __typename?: 'CategorieproduitRelationResponseCollection' } & {
        data: Array<
          { __typename?: 'CategorieproduitEntity' } & Pick<
            CategorieproduitEntity,
            'id'
          > & {
              attributes?: Maybe<
                { __typename?: 'Categorieproduit' } & Pick<
                  Categorieproduit,
                  'name'
                >
              >;
            }
        >;
      }
    >;
    ingredients?: Maybe<
      Array<
        Maybe<
          { __typename?: 'ComponentIngredientsIngredients' } & Pick<
            ComponentIngredientsIngredients,
            'id' | 'name' | 'percent'
          >
        >
      >
    >;
    allergens?: Maybe<
      Array<
        Maybe<
          { __typename?: 'ComponentAllergensAllergens' } & Pick<
            ComponentAllergensAllergens,
            'id' | 'name'
          >
        >
      >
    >;
    shoppingMobile?: Maybe<
      Array<
        Maybe<
          { __typename?: 'ComponentShoppingMobileShoppingMobile' } & Pick<
            ComponentShoppingMobileShoppingMobile,
            'id' | 'mobile' | 'description'
          >
        >
      >
    >;
    characteristics?: Maybe<
      Array<
        Maybe<
          {
            __typename?: 'ComponentProductCharacteristicsProductCharacteristics';
          } & Pick<
            ComponentProductCharacteristicsProductCharacteristics,
            'id' | 'characteristic' | 'value'
          >
        >
      >
    >;
    media?: Maybe<
      { __typename?: 'UploadFileRelationResponseCollection' } & {
        data: Array<
          { __typename?: 'UploadFileEntity' } & Pick<UploadFileEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'UploadFile' } & Pick<UploadFile, 'url' | 'name'>
              >;
            }
        >;
      }
    >;
  };

export type RelaisMainInfoFragment = { __typename?: 'Relais' } & Pick<
  Relais,
  | 'adresse1'
  | 'adresse2'
  | 'adresse3'
  | 'codePostal'
  | 'localite'
  | 'identifiant'
  | 'nom'
  | 'coordGeolocalisationLatitude'
  | 'coordGeolocalisationLongitude'
>;

export type AccountFragment = { __typename?: 'UsersPermissionsUser' } & Pick<
  UsersPermissionsUser,
  | 'username'
  | 'firstname'
  | 'lastname'
  | 'email'
  | 'tel'
  | 'mdp'
  | 'shop'
  | 'confirmed'
  | 'options'
> & {
    notes?: Maybe<
      { __typename?: 'NoteRelationResponseCollection' } & {
        data: Array<
          { __typename?: 'NoteEntity' } & Pick<NoteEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Note' } & Pick<
                  Note,
                  'createdAt' | 'updatedAt' | 'nbvente'
                >
              >;
            }
        >;
      }
    >;
  };

export type AvatarFragment = { __typename?: 'UsersPermissionsUser' } & {
  avatar?: Maybe<
    { __typename?: 'AvatarEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'AvatarEntity' } & Pick<AvatarEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Avatar' } & Pick<Avatar, 'name'> & {
                  media?: Maybe<
                    { __typename?: 'UploadFileEntityResponse' } & {
                      data?: Maybe<
                        { __typename?: 'UploadFileEntity' } & Pick<
                          UploadFileEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'UploadFile' } & Pick<
                                UploadFile,
                                'url'
                              >
                            >;
                          }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type ClasseFragment = { __typename?: 'Classe' } & Pick<
  Classe,
  'debut' | 'fin' | 'name' | 'operationid'
> & {
    filliere?: Maybe<
      { __typename?: 'FilliereEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'FilliereEntity' } & Pick<FilliereEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Filliere' } & Pick<Filliere, 'name'>
              >;
            }
        >;
      }
    >;
    lycee?: Maybe<
      { __typename?: 'LyceeEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'LyceeEntity' } & Pick<LyceeEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Lycee' } & Pick<Lycee, 'name'> & {
                    academie?: Maybe<
                      { __typename?: 'AcademieEntityResponse' } & {
                        data?: Maybe<
                          { __typename?: 'AcademieEntity' } & Pick<
                            AcademieEntity,
                            'id'
                          > & {
                              attributes?: Maybe<
                                { __typename?: 'Academie' } & Pick<
                                  Academie,
                                  'name'
                                >
                              >;
                            }
                        >;
                      }
                    >;
                  }
              >;
            }
        >;
      }
    >;
    niveau?: Maybe<
      { __typename?: 'NiveauEntityResponse' } & {
        data?: Maybe<
          { __typename?: 'NiveauEntity' } & Pick<NiveauEntity, 'id'> & {
              attributes?: Maybe<
                { __typename?: 'Niveau' } & Pick<Niveau, 'name'>
              >;
            }
        >;
      }
    >;
  };

export type CommandesFragment = { __typename?: 'UsersPermissionsUser' } & {
  commandes?: Maybe<
    { __typename?: 'CommandeRelationResponseCollection' } & {
      data: Array<
        { __typename?: 'CommandeEntity' } & {
          attributes?: Maybe<
            { __typename?: 'Commande' } & DetailsCommandeFragment
          >;
        }
      >;
    }
  >;
};

export type PublicInfoFragment = { __typename?: 'UsersPermissionsUser' } & Pick<
  UsersPermissionsUser,
  'firstname' | 'lastname' | 'email'
>;

export type UpdateClasseObjectiveMutationVariables = Exact<{
  name: Scalars['String'];
  ca: Scalars['Int'];
}>;

export type UpdateClasseObjectiveMutation = { __typename?: 'Mutation' } & {
  updateClassObjective?: Maybe<
    { __typename?: 'CurrentClasseInfosType' } & {
      objectif?: Maybe<
        { __typename?: 'TypeObjective' } & Pick<TypeObjective, 'name' | 'ca'>
      >;
    }
  >;
};

export type UpdateClasseOngMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ClasseInput;
}>;

export type UpdateClasseOngMutation = { __typename?: 'Mutation' } & {
  updateClasse?: Maybe<
    { __typename?: 'ClasseEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'ClasseEntity' } & Pick<ClasseEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Classe' } & Pick<
                Classe,
                'ong' | 'percentDedicatedToOng'
              >
            >;
          }
      >;
    }
  >;
};

export type AddCommandesAndNoteMutationVariables = Exact<{
  order?: Maybe<Order>;
}>;

export type AddCommandesAndNoteMutation = { __typename?: 'Mutation' } & {
  addCommandesAndNote?: Maybe<
    { __typename?: 'Commande' } & {
      user?: Maybe<
        { __typename?: 'UsersPermissionsUserEntityResponse' } & {
          data?: Maybe<
            { __typename?: 'UsersPermissionsUserEntity' } & {
              attributes?: Maybe<
                { __typename?: 'UsersPermissionsUser' } & {
                  classes?: Maybe<
                    { __typename?: 'ClasseRelationResponseCollection' } & {
                      data: Array<
                        { __typename?: 'ClasseEntity' } & Pick<
                          ClasseEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'Classe' } & ClasseFragment
                            >;
                          }
                      >;
                    }
                  >;
                } & PublicInfoFragment
              >;
            }
          >;
        }
      >;
      commandelines?: Maybe<
        { __typename?: 'CommandelineRelationResponseCollection' } & {
          data: Array<
            { __typename?: 'CommandelineEntity' } & {
              attributes?: Maybe<
                { __typename?: 'Commandeline' } & MainCommandelineFragment
              >;
            }
          >;
        }
      >;
      client?: Maybe<
        { __typename?: 'ClientEntityResponse' } & {
          data?: Maybe<
            { __typename?: 'ClientEntity' } & {
              attributes?: Maybe<{ __typename?: 'Client' } & MainFragment>;
            }
          >;
        }
      >;
    } & MainCommandeFragment
  >;
};

export type UpdateToControlledMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
  controlled?: Maybe<Scalars['Boolean']>;
}>;

export type UpdateToControlledMutation = { __typename?: 'Mutation' } & {
  updateControlStatus?: Maybe<
    { __typename?: 'Commande' } & Pick<Commande, 'controlled'>
  >;
};

export type UpdatePaymentReminderMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
  paymentreminder?: Maybe<Scalars['Boolean']>;
}>;

export type UpdatePaymentReminderMutation = { __typename?: 'Mutation' } & {
  updatePaymentReminder?: Maybe<
    { __typename?: 'Commande' } & Pick<Commande, 'paymentreminder'>
  >;
};

export type UpdateStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status?: Maybe<Enum_Commande_Status>;
}>;

export type UpdateStatusMutation = { __typename?: 'Mutation' } & {
  updateCommande?: Maybe<
    { __typename?: 'CommandeEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'CommandeEntity' } & {
          attributes?: Maybe<
            { __typename?: 'Commande' } & Pick<Commande, 'status'>
          >;
        }
      >;
    }
  >;
};

export type UpdateAllNoteMutationVariables = Exact<{ [key: string]: never }>;

export type UpdateAllNoteMutation = { __typename?: 'Mutation' } & {
  updateAllNote?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Note' } & {
          user?: Maybe<
            { __typename?: 'UsersPermissionsUserEntityResponse' } & {
              data?: Maybe<
                { __typename?: 'UsersPermissionsUserEntity' } & Pick<
                  UsersPermissionsUserEntity,
                  'id'
                > & {
                    attributes?: Maybe<
                      { __typename?: 'UsersPermissionsUser' } & Pick<
                        UsersPermissionsUser,
                        'firstname' | 'lastname'
                      >
                    >;
                  }
              >;
            }
          >;
        } & QuantiteFragment &
          MoyenneFragment
      >
    >
  >;
};

export type UpdateNoteClasseMutationVariables = Exact<{ [key: string]: never }>;

export type UpdateNoteClasseMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'updateNoteClasse'
>;

export type UpdateMyNoteMutationVariables = Exact<{ [key: string]: never }>;

export type UpdateMyNoteMutation = { __typename?: 'Mutation' } & {
  updateMyNote?: Maybe<
    { __typename?: 'Note' } & {
      user?: Maybe<
        { __typename?: 'UsersPermissionsUserEntityResponse' } & {
          data?: Maybe<
            { __typename?: 'UsersPermissionsUserEntity' } & {
              attributes?: Maybe<
                { __typename?: 'UsersPermissionsUser' } & {
                  notes?: Maybe<
                    { __typename?: 'NoteRelationResponseCollection' } & {
                      data: Array<
                        { __typename?: 'NoteEntity' } & {
                          attributes?: Maybe<
                            { __typename?: 'Note' } & Pick<
                              Note,
                              | 'cavente'
                              | 'nbvente'
                              | 'venterebond'
                              | 'moyennegenerale'
                              | 'qtevente'
                              | 'qteca'
                              | 'qtepro'
                              | 'qterebond'
                              | 'qtequiz'
                            >
                          >;
                        }
                      >;
                    }
                  >;
                }
              >;
            }
          >;
        }
      >;
    }
  >;
};

export type UpdateUserOptionsMutationVariables = Exact<{
  key?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
}>;

export type UpdateUserOptionsMutation = { __typename?: 'Mutation' } & {
  updateOptions?: Maybe<
    { __typename?: 'UsersPermissionsUser' } & Pick<
      UsersPermissionsUser,
      'firstname' | 'lastname' | 'options'
    >
  >;
};

export type AddPublicOrderMutationVariables = Exact<{
  shopId: Scalars['String'];
  order: Order;
  classeId: Scalars['ID'];
}>;

export type AddPublicOrderMutation = { __typename?: 'Mutation' } & {
  createOrder?: Maybe<
    { __typename?: 'AddedCommande' } & {
      commande: { __typename?: 'CommandeResult' } & Pick<
        CommandeResult,
        | 'id'
        | 'createdAt'
        | 'fraislivraison'
        | 'methodepaiement'
        | 'numerocommande'
        | 'payment'
        | 'totalttc'
        | 'prixTotal'
        | 'customerContributedToTheOng'
        | 'status'
      > & {
          user: { __typename?: 'User' } & Pick<
            User,
            'firstname' | 'lastname' | 'email'
          > & {
              classe?: Maybe<
                { __typename?: 'UserClasse' } & Pick<
                  UserClasse,
                  'debut' | 'fin' | 'operationid'
                > & {
                    filliere: { __typename?: 'FilliereResult' } & Pick<
                      FilliereResult,
                      'name'
                    >;
                    lycee: { __typename?: 'LyceeResult' } & Pick<
                      LyceeResult,
                      'name'
                    > & {
                        academie: { __typename?: 'AcademieName' } & Pick<
                          AcademieName,
                          'name'
                        >;
                      };
                    niveau: { __typename?: 'NiveauResult' } & Pick<
                      NiveauResult,
                      'name'
                    >;
                  }
              >;
            };
          commandelines: Array<
            Maybe<
              { __typename?: 'CommandeLineResult' } & Pick<
                CommandeLineResult,
                'id' | 'quantite'
              > & {
                  produit: { __typename?: 'ProduitResult' } & Pick<
                    ProduitResult,
                    'id' | 'name' | 'ttcPrice' | 'ref' | 'venterebond'
                  > & {
                      media?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'MediaUrl' } & Pick<MediaUrl, 'url'>
                          >
                        >
                      >;
                    };
                }
            >
          >;
          client: { __typename?: 'ClientResult' } & ClientResultFragment;
        };
      sherlock?: Maybe<
        { __typename?: 'Sherlock' } & Pick<
          Sherlock,
          | 'interfaceVersion'
          | 'data'
          | 'redirectionUrl'
          | 'seal'
          | 'automaticResponseUrl'
        >
      >;
    }
  >;
};

export type SendQuizNoteMutationVariables = Exact<{
  quizId: Scalars['ID'];
  quizRep: Array<QuizRep> | QuizRep;
}>;

export type SendQuizNoteMutation = { __typename?: 'Mutation' } & {
  createQuizNote?: Maybe<
    { __typename?: 'Quiztonote' } & Pick<Quiztonote, 'note'> & {
        quiz?: Maybe<
          { __typename?: 'QuizEntityResponse' } & {
            data?: Maybe<
              { __typename?: 'QuizEntity' } & {
                attributes?: Maybe<
                  { __typename?: 'Quiz' } & Pick<Quiz, 'name'>
                >;
              }
            >;
          }
        >;
      }
  >;
};

export type OnLoginMutationVariables = Exact<{
  identifier: Scalars['String'];
  password: Scalars['String'];
}>;

export type OnLoginMutation = { __typename?: 'Mutation' } & {
  login: { __typename?: 'UsersPermissionsLoginPayload' } & Pick<
    UsersPermissionsLoginPayload,
    'jwt'
  > & {
      user: { __typename?: 'UsersPermissionsMe' } & Pick<
        UsersPermissionsMe,
        'id' | 'username'
      >;
    };
};

export type ChangePasswordMutationVariables = Exact<{
  pass?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
}>;

export type ChangePasswordMutation = { __typename?: 'Mutation' } & {
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
  } & {
    data?: Maybe<
      { __typename?: 'UsersPermissionsUserEntity' } & Pick<
        UsersPermissionsUserEntity,
        'id'
      >
    >;
  };
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type DeleteUserMutation = { __typename?: 'Mutation' } & {
  deleteUser?: Maybe<
    { __typename?: 'deleteUser' } & Pick<
      DeleteUser,
      'name' | 'deleted' | 'reason'
    >
  >;
};

export type AddUserMutationVariables = Exact<{
  lastname: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  role?: Maybe<Scalars['ID']>;
}>;

export type AddUserMutation = { __typename?: 'Mutation' } & {
  createUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
  } & {
    data?: Maybe<
      { __typename?: 'UsersPermissionsUserEntity' } & {
        attributes?: Maybe<
          { __typename?: 'UsersPermissionsUser' } & Pick<
            UsersPermissionsUser,
            'firstname' | 'lastname' | 'username' | 'mdp' | 'email'
          > & {
              classes?: Maybe<
                { __typename?: 'ClasseRelationResponseCollection' } & {
                  data: Array<
                    { __typename?: 'ClasseEntity' } & Pick<
                      ClasseEntity,
                      'id'
                    > & {
                        attributes?: Maybe<
                          { __typename?: 'Classe' } & Pick<Classe, 'name'>
                        >;
                      }
                  >;
                }
              >;
            }
        >;
      }
    >;
  };
};

export type AddProfMutationVariables = Exact<{
  username: Scalars['String'];
  lastname: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  classes?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  role?: Maybe<Scalars['ID']>;
  isPairTeacher?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
}>;

export type AddProfMutation = { __typename?: 'Mutation' } & {
  createUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
  } & {
    data?: Maybe<
      { __typename?: 'UsersPermissionsUserEntity' } & Pick<
        UsersPermissionsUserEntity,
        'id'
      > & {
          attributes?: Maybe<
            { __typename?: 'UsersPermissionsUser' } & Pick<
              UsersPermissionsUser,
              'email' | 'firstname' | 'lastname' | 'mdp' | 'username'
            >
          >;
        }
    >;
  };
};

export type OnUserAvatarMutationVariables = Exact<{
  avatar: Scalars['ID'];
  user: Scalars['ID'];
}>;

export type OnUserAvatarMutation = { __typename?: 'Mutation' } & {
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
  } & {
    data?: Maybe<
      { __typename?: 'UsersPermissionsUserEntity' } & Pick<
        UsersPermissionsUserEntity,
        'id'
      > & {
          attributes?: Maybe<
            { __typename?: 'UsersPermissionsUser' } & {
              avatar?: Maybe<
                { __typename?: 'AvatarEntityResponse' } & {
                  data?: Maybe<
                    { __typename?: 'AvatarEntity' } & Pick<
                      AvatarEntity,
                      'id'
                    > & {
                        attributes?: Maybe<
                          { __typename?: 'Avatar' } & {
                            media?: Maybe<
                              { __typename?: 'UploadFileEntityResponse' } & {
                                data?: Maybe<
                                  { __typename?: 'UploadFileEntity' } & {
                                    attributes?: Maybe<
                                      { __typename?: 'UploadFile' } & Pick<
                                        UploadFile,
                                        'url'
                                      >
                                    >;
                                  }
                                >;
                              }
                            >;
                          }
                        >;
                      }
                  >;
                }
              >;
            }
          >;
        }
    >;
  };
};

export type UpdateUserAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
}>;

export type UpdateUserAccountMutation = { __typename?: 'Mutation' } & {
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
  } & {
    data?: Maybe<
      { __typename?: 'UsersPermissionsUserEntity' } & {
        attributes?: Maybe<
          { __typename?: 'UsersPermissionsUser' } & AccountFragment
        >;
      }
    >;
  };
};

export type UpdateUserOngMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UsersPermissionsUserInput;
}>;

export type UpdateUserOngMutation = { __typename?: 'Mutation' } & {
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
  } & {
    data?: Maybe<
      { __typename?: 'UsersPermissionsUserEntity' } & Pick<
        UsersPermissionsUserEntity,
        'id'
      > & {
          attributes?: Maybe<
            { __typename?: 'UsersPermissionsUser' } & Pick<
              UsersPermissionsUser,
              'firstname' | 'ong'
            >
          >;
        }
    >;
  };
};

export type QueryAcademiesQueryVariables = Exact<{ [key: string]: never }>;

export type QueryAcademiesQuery = { __typename?: 'Query' } & {
  academies?: Maybe<
    { __typename?: 'AcademieEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'AcademieEntity' } & Pick<AcademieEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Academie' } & Pick<Academie, 'name'>
            >;
          }
      >;
    }
  >;
};

export type AllAvatarsQueryVariables = Exact<{ [key: string]: never }>;

export type AllAvatarsQuery = { __typename?: 'Query' } & {
  avatars?: Maybe<
    { __typename?: 'AvatarEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'AvatarEntity' } & Pick<AvatarEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Avatar' } & Pick<Avatar, 'name'> & {
                  media?: Maybe<
                    { __typename?: 'UploadFileEntityResponse' } & {
                      data?: Maybe<
                        { __typename?: 'UploadFileEntity' } & Pick<
                          UploadFileEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'UploadFile' } & Pick<
                                UploadFile,
                                'url'
                              >
                            >;
                          }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type GetNiveauAndFilliereQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetNiveauAndFilliereQuery = { __typename?: 'Query' } & {
  niveaux?: Maybe<
    { __typename?: 'NiveauEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'NiveauEntity' } & Pick<NiveauEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Niveau' } & Pick<Niveau, 'name'>
            >;
          }
      >;
    }
  >;
  fillieres?: Maybe<
    { __typename?: 'FilliereEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'FilliereEntity' } & Pick<FilliereEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Filliere' } & Pick<Filliere, 'name'>
            >;
          }
      >;
    }
  >;
};

export type GetCurrentClasseInfoQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentClasseInfoQuery = { __typename?: 'Query' } & {
  getCurrentClasseInfos?: Maybe<
    { __typename?: 'CurrentClasseInfosType' } & Pick<
      CurrentClasseInfosType,
      | 'name'
      | 'filiere'
      | 'niveau'
      | 'lycee'
      | 'nbProfs'
      | 'nbEleves'
      | 'debut'
      | 'fin'
    > & {
        noteclasse?: Maybe<
          { __typename?: 'ClassNote' } & Pick<ClassNote, 'qteca'>
        >;
        objectif?: Maybe<
          { __typename?: 'TypeObjective' } & Pick<TypeObjective, 'name' | 'ca'>
        >;
      }
  >;
};

export type GetClasseWithNoteAndStudentsOrdersQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type GetClasseWithNoteAndStudentsOrdersQuery = {
  __typename?: 'Query';
} & {
  getClasseWithNoteAndEleves?: Maybe<
    { __typename?: 'ClasseWithNoteAndStudentsOrders' } & Pick<
      ClasseWithNoteAndStudentsOrders,
      'ong' | 'percentDedicatedToOng'
    > & {
        users?: Maybe<
          Array<
            Maybe<
              { __typename?: 'UserWithNoteAndOrders' } & {
                commandes?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'OrdersWithStatusAndContribution' } & Pick<
                        OrdersWithStatusAndContribution,
                        'status' | 'customerContributedToTheOng'
                      >
                    >
                  >
                >;
                note?: Maybe<
                  { __typename?: 'NotesWithQteca' } & Pick<
                    NotesWithQteca,
                    'qteca'
                  >
                >;
              }
            >
          >
        >;
        noteclasse?: Maybe<
          { __typename?: 'NotesWithQteca' } & Pick<NotesWithQteca, 'qteca'>
        >;
      }
  >;
  getMyOrdersInClasse?: Maybe<
    { __typename?: 'GetMyOrdersInClasse' } & {
      commandes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'CommandeEntity' } & {
              attributes?: Maybe<
                { __typename?: 'Commande' } & Pick<
                  Commande,
                  'status' | 'customerContributedToTheOng'
                >
              >;
            }
          >
        >
      >;
    }
  >;
  getMyNoteInClasse?: Maybe<
    { __typename?: 'GetMyNoteInClasse' } & {
      note?: Maybe<
        { __typename?: 'NoteEntity' } & {
          attributes?: Maybe<{ __typename?: 'Note' } & Pick<Note, 'qteca'>>;
        }
      >;
    }
  >;
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & Pick<
          UsersPermissionsUserEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsUser' } & Pick<
                UsersPermissionsUser,
                'ong'
              >
            >;
          }
      >;
    }
  >;
};

export type GetOrdersByEleveInClasseQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrdersByEleveInClasseQuery = { __typename?: 'Query' } & {
  findElevesWithOrders?: Maybe<
    { __typename?: 'ClasseWithEleves' } & {
      users?: Maybe<
        Array<
          Maybe<
            { __typename?: 'ElevesWithOrder' } & Pick<
              ElevesWithOrder,
              'firstname' | 'lastname'
            > & {
                commandes?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'EleveCommandes' } & Pick<
                        EleveCommandes,
                        | 'numerocommande'
                        | 'totalttc'
                        | 'methodepaiement'
                        | 'payment'
                        | 'fraislivraison'
                        | 'status'
                        | 'id'
                        | 'customerContributedToTheOng'
                        | 'controlled'
                        | 'prixTotal'
                      > & {
                          client?: Maybe<
                            { __typename?: 'OrderClient' } & Pick<
                              OrderClient,
                              'prenom' | 'nom'
                            >
                          >;
                        }
                    >
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type GetElevesWithQuizToNotesAndQuizQueryVariables = Exact<{
  id: Scalars['ID'];
  quizId: Scalars['ID'];
}>;

export type GetElevesWithQuizToNotesAndQuizQuery = { __typename?: 'Query' } & {
  classe?: Maybe<
    { __typename?: 'ClasseEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'ClasseEntity' } & {
          attributes?: Maybe<
            { __typename?: 'Classe' } & {
              users?: Maybe<
                {
                  __typename?: 'UsersPermissionsUserRelationResponseCollection';
                } & {
                  data: Array<
                    { __typename?: 'UsersPermissionsUserEntity' } & {
                      attributes?: Maybe<
                        { __typename?: 'UsersPermissionsUser' } & Pick<
                          UsersPermissionsUser,
                          'username' | 'firstname' | 'lastname'
                        > & {
                            quiztonotes?: Maybe<
                              {
                                __typename?: 'QuiztonoteRelationResponseCollection';
                              } & {
                                data: Array<
                                  { __typename?: 'QuiztonoteEntity' } & {
                                    attributes?: Maybe<
                                      { __typename?: 'Quiztonote' } & Pick<
                                        Quiztonote,
                                        'note' | 'responses'
                                      > & {
                                          quiz?: Maybe<
                                            {
                                              __typename?: 'QuizEntityResponse';
                                            } & {
                                              data?: Maybe<
                                                {
                                                  __typename?: 'QuizEntity';
                                                } & Pick<QuizEntity, 'id'>
                                              >;
                                            }
                                          >;
                                        }
                                    >;
                                  }
                                >;
                              }
                            >;
                          }
                      >;
                    }
                  >;
                }
              >;
            }
          >;
        }
      >;
    }
  >;
  quiz?: Maybe<
    { __typename?: 'QuizEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'QuizEntity' } & Pick<QuizEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Quiz' } & Pick<Quiz, 'name' | 'desc'> & {
                  competences?: Maybe<
                    { __typename?: 'CompetenceRelationResponseCollection' } & {
                      data: Array<
                        { __typename?: 'CompetenceEntity' } & {
                          attributes?: Maybe<
                            { __typename?: 'Competence' } & Pick<
                              Competence,
                              'name'
                            >
                          >;
                        }
                      >;
                    }
                  >;
                  questions?: Maybe<
                    { __typename?: 'QuestionRelationResponseCollection' } & {
                      data: Array<
                        { __typename?: 'QuestionEntity' } & Pick<
                          QuestionEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'Question' } & Pick<
                                Question,
                                'name'
                              >
                            >;
                          }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type CommandeDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CommandeDetailsQuery = { __typename?: 'Query' } & {
  commande?: Maybe<
    { __typename?: 'CommandeEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'CommandeEntity' } & Pick<CommandeEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Commande' } & DetailsCommandeFragment
            >;
          }
      >;
    }
  >;
};

export type GetElevesCommandesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetElevesCommandesQuery = { __typename?: 'Query' } & {
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & Pick<
          UsersPermissionsUserEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsUser' } & {
                classes?: Maybe<
                  { __typename?: 'ClasseRelationResponseCollection' } & {
                    data: Array<
                      { __typename?: 'ClasseEntity' } & Pick<
                        ClasseEntity,
                        'id'
                      > & {
                          attributes?: Maybe<
                            { __typename?: 'Classe' } & {
                              users?: Maybe<
                                {
                                  __typename?: 'UsersPermissionsUserRelationResponseCollection';
                                } & {
                                  data: Array<
                                    {
                                      __typename?: 'UsersPermissionsUserEntity';
                                    } & Pick<
                                      UsersPermissionsUserEntity,
                                      'id'
                                    > & {
                                        attributes?: Maybe<
                                          {
                                            __typename?: 'UsersPermissionsUser';
                                          } & Pick<
                                            UsersPermissionsUser,
                                            'firstname' | 'lastname'
                                          > & {
                                              commandes?: Maybe<
                                                {
                                                  __typename?: 'CommandeRelationResponseCollection';
                                                } & {
                                                  data: Array<
                                                    {
                                                      __typename?: 'CommandeEntity';
                                                    } & Pick<
                                                      CommandeEntity,
                                                      'id'
                                                    > & {
                                                        attributes?: Maybe<
                                                          {
                                                            __typename?: 'Commande';
                                                          } & Pick<
                                                            Commande,
                                                            | 'totalttc'
                                                            | 'createdAt'
                                                            | 'numerocommande'
                                                          >
                                                        >;
                                                      }
                                                  >;
                                                }
                                              >;
                                            }
                                        >;
                                      }
                                  >;
                                }
                              >;
                            }
                          >;
                        }
                    >;
                  }
                >;
              }
            >;
          }
      >;
    }
  >;
};

export type GetLastEleveCommandeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetLastEleveCommandeQuery = { __typename?: 'Query' } & {
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & {
          attributes?: Maybe<
            { __typename?: 'UsersPermissionsUser' } & {
              commandes?: Maybe<
                { __typename?: 'CommandeRelationResponseCollection' } & {
                  data: Array<
                    { __typename?: 'CommandeEntity' } & {
                      attributes?: Maybe<
                        { __typename?: 'Commande' } & {
                          user?: Maybe<
                            {
                              __typename?: 'UsersPermissionsUserEntityResponse';
                            } & {
                              data?: Maybe<
                                {
                                  __typename?: 'UsersPermissionsUserEntity';
                                } & {
                                  attributes?: Maybe<
                                    {
                                      __typename?: 'UsersPermissionsUser';
                                    } & Pick<
                                      UsersPermissionsUser,
                                      'lastname' | 'firstname' | 'email'
                                    > & {
                                        classes?: Maybe<
                                          {
                                            __typename?: 'ClasseRelationResponseCollection';
                                          } & {
                                            data: Array<
                                              {
                                                __typename?: 'ClasseEntity';
                                              } & {
                                                attributes?: Maybe<
                                                  {
                                                    __typename?: 'Classe';
                                                  } & ClasseInfoFragment
                                                >;
                                              }
                                            >;
                                          }
                                        >;
                                      }
                                  >;
                                }
                              >;
                            }
                          >;
                        } & DetailsCommandeFragment
                      >;
                    }
                  >;
                }
              >;
            }
          >;
        }
      >;
    }
  >;
};

export type QueryGetMyOrderInClasseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QueryGetMyOrderInClasseQuery = { __typename?: 'Query' } & {
  getMyOrdersInClasse?: Maybe<
    { __typename?: 'GetMyOrdersInClasse' } & Pick<
      GetMyOrdersInClasse,
      'firstname' | 'lastname'
    > & {
        commandes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'CommandeEntity' } & Pick<CommandeEntity, 'id'> & {
                  attributes?: Maybe<
                    { __typename?: 'Commande' } & DetailsCommandeFragment
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type GetProfDashboardQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfDashboardQuery = { __typename?: 'Query' } & {
  getProfDashboard?: Maybe<
    { __typename?: 'getProfDashboard' } & {
      classe?: Maybe<
        { __typename?: 'ProfDashboardClasse' } & Pick<
          ProfDashboardClasse,
          'id' | 'name' | 'operationid' | 'fin' | 'debut'
        > & {
            filiere?: Maybe<
              { __typename?: 'ClasseFiliere' } & Pick<
                ClasseFiliere,
                'id' | 'name'
              >
            >;
            niveau?: Maybe<
              { __typename?: 'ClasseNiveau' } & Pick<
                ClasseNiveau,
                'id' | 'name'
              >
            >;
            lycee?: Maybe<
              { __typename?: 'ClasseLycee' } & Pick<ClasseLycee, 'id' | 'name'>
            >;
            users?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'ProfDashboardUser' } & Pick<
                    ProfDashboardUser,
                    | 'id'
                    | 'username'
                    | 'firstname'
                    | 'lastname'
                    | 'email'
                    | 'ville'
                    | 'mdp'
                    | 'shop'
                  > & {
                      avatar?: Maybe<
                        { __typename?: 'userAvatar' } & Pick<
                          UserAvatar,
                          'name' | 'id'
                        > & {
                            media?: Maybe<
                              { __typename?: 'avatarMediaUrl' } & Pick<
                                AvatarMediaUrl,
                                'url'
                              >
                            >;
                          }
                      >;
                      role?: Maybe<
                        { __typename?: 'UserRole' } & Pick<
                          UserRole,
                          'name' | 'id'
                        >
                      >;
                      note?: Maybe<
                        { __typename?: 'UserNote' } & Pick<
                          UserNote,
                          | 'qteca'
                          | 'qtevente'
                          | 'qtepro'
                          | 'qtequiz'
                          | 'qterebond'
                          | 'moyennegenerale'
                          | 'quiz'
                          | 'pro'
                          | 'cavente'
                          | 'nbvente'
                          | 'venterebond'
                        >
                      >;
                      quiztonotes?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'UserQuizToNote' } & Pick<
                              UserQuizToNote,
                              'note' | 'createdAt'
                            > & {
                                quiz?: Maybe<
                                  { __typename?: 'UserQuizToNoteQuiz' } & Pick<
                                    UserQuizToNoteQuiz,
                                    'name' | 'id'
                                  >
                                >;
                              }
                          >
                        >
                      >;
                      commandes?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'Commande' } & Pick<
                              Commande,
                              | 'status'
                              | 'methodepaiement'
                              | 'paymentreminder'
                              | 'createdAt'
                            >
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    }
  >;
  getUnpayedCoByEleve?: Maybe<
    Array<
      Maybe<
        { __typename?: 'UnPayedCaEleve' } & Pick<
          UnPayedCaEleve,
          'id' | 'unpayedCA'
        >
      >
    >
  >;
};

export type HomeDefisQueryVariables = Exact<{ [key: string]: never }>;

export type HomeDefisQuery = { __typename?: 'Query' } & {
  getHomeDefis?: Maybe<
    { __typename?: 'HomeDefis' } & {
      defisList?: Maybe<
        Array<
          Maybe<
            { __typename?: 'DefisList' } & Pick<
              DefisList,
              'id' | 'name' | 'debut' | 'fin'
            >
          >
        >
      >;
      lastDefi?: Maybe<
        { __typename?: 'LastDefi' } & Pick<LastDefi, 'id' | 'name'> & {
            recompenses?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'AwardsList' } & Pick<
                    AwardsList,
                    'category' | 'lots'
                  > & {
                      recompenses_winners?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'WinnersUser' } & Pick<
                              WinnersUser,
                              'id' | 'username'
                            > & {
                                avatar?: Maybe<
                                  { __typename?: 'AvatarWinnersUser' } & {
                                    media?: Maybe<
                                      {
                                        __typename?: 'AvatarMediaWinnersUser';
                                      } & Pick<AvatarMediaWinnersUser, 'url'>
                                    >;
                                  }
                                >;
                                classes?: Maybe<
                                  Array<
                                    Maybe<
                                      { __typename?: 'ClassesWinnersUser' } & {
                                        lycee?: Maybe<
                                          {
                                            __typename?: 'ClassesLyceeWinnersUser';
                                          } & Pick<
                                            ClassesLyceeWinnersUser,
                                            'name'
                                          >
                                        >;
                                      }
                                    >
                                  >
                                >;
                              }
                          >
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    }
  >;
};

export type SingleDefiQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SingleDefiQuery = { __typename?: 'Query' } & {
  getDefiById?: Maybe<
    { __typename?: 'Defi' } & Pick<Defi, 'name' | 'debut' | 'fin'> & {
        reglement?: Maybe<
          Array<
            Maybe<
              | ({ __typename?: 'ComponentDefiReglement' } & Pick<
                  ComponentDefiReglement,
                  'title' | 'text'
                >)
              | { __typename?: 'Error' }
            >
          >
        >;
        ressources?: Maybe<
          Array<
            Maybe<
              | ({ __typename?: 'ComponentDefiDefiLiens' } & Pick<
                  ComponentDefiDefiLiens,
                  'name' | 'url'
                >)
              | ({ __typename?: 'ComponentDefiDefiMedia' } & Pick<
                  ComponentDefiDefiMedia,
                  'name'
                > & {
                    media?: Maybe<
                      {
                        __typename?: 'UploadFileRelationResponseCollection';
                      } & {
                        data: Array<
                          { __typename?: 'UploadFileEntity' } & {
                            attributes?: Maybe<
                              { __typename?: 'UploadFile' } & Pick<
                                UploadFile,
                                'alternativeText' | 'url'
                              >
                            >;
                          }
                        >;
                      }
                    >;
                  })
              | { __typename?: 'Error' }
            >
          >
        >;
        recompenses?: Maybe<
          Array<
            Maybe<
              { __typename?: 'ComponentDefiDefiWinners' } & Pick<
                ComponentDefiDefiWinners,
                'category' | 'lots'
              > & {
                  recompenses_winners?: Maybe<
                    {
                      __typename?: 'UsersPermissionsUserRelationResponseCollection';
                    } & {
                      data: Array<
                        { __typename?: 'UsersPermissionsUserEntity' } & Pick<
                          UsersPermissionsUserEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'UsersPermissionsUser' } & Pick<
                                UsersPermissionsUser,
                                'username'
                              > & {
                                  classes?: Maybe<
                                    {
                                      __typename?: 'ClasseRelationResponseCollection';
                                    } & {
                                      data: Array<
                                        { __typename?: 'ClasseEntity' } & {
                                          attributes?: Maybe<
                                            { __typename?: 'Classe' } & {
                                              lycee?: Maybe<
                                                {
                                                  __typename?: 'LyceeEntityResponse';
                                                } & {
                                                  data?: Maybe<
                                                    {
                                                      __typename?: 'LyceeEntity';
                                                    } & {
                                                      attributes?: Maybe<
                                                        {
                                                          __typename?: 'Lycee';
                                                        } & Pick<Lycee, 'name'>
                                                      >;
                                                    }
                                                  >;
                                                }
                                              >;
                                            }
                                          >;
                                        }
                                      >;
                                    }
                                  >;
                                  avatar?: Maybe<
                                    { __typename?: 'AvatarEntityResponse' } & {
                                      data?: Maybe<
                                        { __typename?: 'AvatarEntity' } & {
                                          attributes?: Maybe<
                                            { __typename?: 'Avatar' } & {
                                              media?: Maybe<
                                                {
                                                  __typename?: 'UploadFileEntityResponse';
                                                } & {
                                                  data?: Maybe<
                                                    {
                                                      __typename?: 'UploadFileEntity';
                                                    } & {
                                                      attributes?: Maybe<
                                                        {
                                                          __typename?: 'UploadFile';
                                                        } & Pick<
                                                          UploadFile,
                                                          'url'
                                                        >
                                                      >;
                                                    }
                                                  >;
                                                }
                                              >;
                                            }
                                          >;
                                        }
                                      >;
                                    }
                                  >;
                                }
                            >;
                          }
                      >;
                    }
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type GetFaqsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFaqsQuery = { __typename?: 'Query' } & {
  faqs?: Maybe<
    { __typename?: 'FaqEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'FaqEntity' } & Pick<FaqEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Faq' } & Pick<Faq, 'name' | 'desc'> & {
                  medias?: Maybe<
                    { __typename?: 'UploadFileRelationResponseCollection' } & {
                      data: Array<
                        { __typename?: 'UploadFileEntity' } & {
                          attributes?: Maybe<
                            { __typename?: 'UploadFile' } & Pick<
                              UploadFile,
                              'name' | 'url'
                            >
                          >;
                        }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type GetInstallAppTutoQueryVariables = Exact<{ [key: string]: never }>;

export type GetInstallAppTutoQuery = { __typename?: 'Query' } & {
  faqs?: Maybe<
    { __typename?: 'FaqEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'FaqEntity' } & Pick<FaqEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Faq' } & Pick<Faq, 'name' | 'desc'> & {
                  medias?: Maybe<
                    { __typename?: 'UploadFileRelationResponseCollection' } & {
                      data: Array<
                        { __typename?: 'UploadFileEntity' } & {
                          attributes?: Maybe<
                            { __typename?: 'UploadFile' } & Pick<
                              UploadFile,
                              'url' | 'name'
                            >
                          >;
                        }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type AllFormationsAndTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllFormationsAndTypesQuery = { __typename?: 'Query' } & {
  formations?: Maybe<
    { __typename?: 'FormationEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'FormationEntity' } & Pick<FormationEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Formation' } & Pick<
                Formation,
                'name' | 'subtitle' | 'info' | 'desc' | 'reservedToProf'
              > & {
                  formation_type?: Maybe<
                    { __typename?: 'FormationTypeEntityResponse' } & {
                      data?: Maybe<
                        { __typename?: 'FormationTypeEntity' } & Pick<
                          FormationTypeEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'FormationType' } & Pick<
                                FormationType,
                                'name'
                              >
                            >;
                          }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
  findFormationTypeWithRelatedFormations?: Maybe<
    Array<
      Maybe<
        { __typename?: 'FormationTypeWithRelatedFormations' } & Pick<
          FormationTypeWithRelatedFormations,
          'id' | 'name'
        > & {
            formations?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'FormationRessources' } & Pick<
                    FormationRessources,
                    'name'
                  >
                >
              >
            >;
          }
      >
    >
  >;
};

export type FindFormationByTypeIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FindFormationByTypeIdQuery = { __typename?: 'Query' } & {
  findFormationByTypeId?: Maybe<
    Array<
      Maybe<
        { __typename?: 'FormationRessource' } & Pick<
          FormationRessource,
          'name' | 'desc' | 'subtitle' | 'info' | 'order'
        > & {
            ressources?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'FormationLink' } & Pick<
                    FormationLink,
                    'titre' | 'lien'
                  > & {
                      media?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'FormationMedia' } & Pick<
                              FormationMedia,
                              'url'
                            >
                          >
                        >
                      >;
                      type?: Maybe<
                        { __typename?: 'FormationRessourceType' } & Pick<
                          FormationRessourceType,
                          'nom'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >
    >
  >;
};

export type GetLeadersNatQueryVariables = Exact<{
  tableau?: Maybe<Scalars['String']>;
}>;

export type GetLeadersNatQuery = { __typename?: 'Query' } & {
  getClassement?: Maybe<Array<Maybe<{ __typename?: 'Rank' } & RankFragment>>>;
};

export type GetPositionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPositionsQuery = { __typename?: 'Query' } & {
  myPositions?: Maybe<
    { __typename?: 'userRank' } & Pick<
      UserRank,
      'niveauRank' | 'classeRank' | 'academieRank' | 'nationalRank'
    >
  >;
};

export type GetMyNoteInClasseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetMyNoteInClasseQuery = { __typename?: 'Query' } & {
  getMyNoteInClasse?: Maybe<
    { __typename?: 'GetMyNoteInClasse' } & {
      note?: Maybe<
        { __typename?: 'NoteEntity' } & Pick<NoteEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Note' } & Pick<Note, 'updatedAt'> &
                QuantiteFragment &
                ChallengeNoteFragment
            >;
          }
      >;
      quizToNotes?: Maybe<
        Array<
          Maybe<
            { __typename?: 'QuiztonoteEntity' } & Pick<
              QuiztonoteEntity,
              'id'
            > & {
                attributes?: Maybe<
                  { __typename?: 'Quiztonote' } & NoteDesQuizFragment
                >;
              }
          >
        >
      >;
    }
  >;
};

export type QuerySoftSkillsQueryVariables = Exact<{ [key: string]: never }>;

export type QuerySoftSkillsQuery = { __typename?: 'Query' } & {
  getUserSoftSkills?: Maybe<
    { __typename?: 'getUserSoftSkills' } & Pick<
      GetUserSoftSkills,
      'unpayedOrders' | 'commandes'
    > & {
        note?: Maybe<
          { __typename?: 'UserNote' } & Pick<
            UserNote,
            'qteca' | 'qtepro' | 'qtequiz' | 'qterebond' | 'qtevente'
          >
        >;
        classe?: Maybe<
          { __typename?: 'UserClasseWithAllInfos' } & Pick<
            UserClasseWithAllInfos,
            'commandes' | 'unpayedOrders'
          > & {
              users?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'UserClasseUsers' } & {
                      role?: Maybe<
                        { __typename?: 'UserRole' } & Pick<
                          UserRole,
                          'id' | 'name'
                        >
                      >;
                      commandes?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'UserCommandeStatus' } & Pick<
                              UserCommandeStatus,
                              'status'
                            >
                          >
                        >
                      >;
                    }
                  >
                >
              >;
              noteclasse?: Maybe<
                { __typename?: 'UserClasseNoteclasse' } & Pick<
                  UserClasseNoteclasse,
                  | 'cavente'
                  | 'qteca'
                  | 'qtepro'
                  | 'qterebond'
                  | 'venterebond'
                  | 'moyennegenerale'
                  | 'pro'
                  | 'quiz'
                  | 'qtequiz'
                  | 'nbvente'
                  | 'qtevente'
                >
              >;
            }
        >;
      }
  >;
  getClassePosition?: Maybe<
    { __typename?: 'ClasseRank' } & Pick<ClasseRank, 'rank' | 'totalClasses'>
  >;
  getUnpayedCo?: Maybe<
    { __typename?: 'UnpayedCa' } & Pick<UnpayedCa, 'classe' | 'eleve'>
  >;
};

export type QueryNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type QueryNotificationsQuery = { __typename?: 'Query' } & {
  notifications?: Maybe<
    { __typename?: 'NotificationEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'NotificationEntity' } & Pick<
          NotificationEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'Notification' } & Pick<
                Notification,
                'title' | 'description' | 'hidden'
              > & {
                  link?: Maybe<
                    { __typename?: 'ComponentNotifLinkLink' } & Pick<
                      ComponentNotifLinkLink,
                      'name' | 'url' | 'button'
                    >
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type CurrentPageQueryVariables = Exact<{
  type?: Maybe<Scalars['String']>;
}>;

export type CurrentPageQuery = { __typename?: 'Query' } & {
  pages?: Maybe<
    { __typename?: 'PageEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'PageEntity' } & Pick<PageEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Page' } & Pick<
                Page,
                'name' | 'desc' | 'action' | 'annonce'
              >
            >;
          }
      >;
    }
  >;
};

export type AllPedagogiesAndTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllPedagogiesAndTypesQuery = { __typename?: 'Query' } & {
  pedagogies?: Maybe<
    { __typename?: 'PedagogieEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'PedagogieEntity' } & Pick<PedagogieEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Pedagogie' } & Pick<
                Pedagogie,
                | 'name'
                | 'subtitle'
                | 'info'
                | 'desc'
                | 'order'
                | 'revervedToProf'
              > & {
                  pedagogie_type?: Maybe<
                    { __typename?: 'PedagogieTypeEntityResponse' } & {
                      data?: Maybe<
                        { __typename?: 'PedagogieTypeEntity' } & Pick<
                          PedagogieTypeEntity,
                          'id'
                        > & {
                            attributes?: Maybe<
                              { __typename?: 'PedagogieType' } & Pick<
                                PedagogieType,
                                'name'
                              >
                            >;
                          }
                      >;
                    }
                  >;
                }
            >;
          }
      >;
    }
  >;
  findPedagogieTypeWithRelatedPedagogies?: Maybe<
    Array<
      Maybe<
        { __typename?: 'PedagogieTypeWithRelatedPedagogies' } & Pick<
          PedagogieTypeWithRelatedPedagogies,
          'id' | 'name'
        > & {
            pedagogies?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'PedagogieRessources' } & Pick<
                    PedagogieRessources,
                    'name'
                  >
                >
              >
            >;
          }
      >
    >
  >;
};

export type FindPedagogieByTypeIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FindPedagogieByTypeIdQuery = { __typename?: 'Query' } & {
  findPedagogieByTypeId?: Maybe<
    Array<
      Maybe<
        { __typename?: 'PedagogieRessource' } & Pick<
          PedagogieRessource,
          'name' | 'desc' | 'subtitle' | 'info' | 'order'
        > & {
            ressources?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'PedagogieLink' } & Pick<
                    PedagogieLink,
                    'titre' | 'lien'
                  > & {
                      media?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'PedagogieMedia' } & Pick<
                              PedagogieMedia,
                              'url'
                            >
                          >
                        >
                      >;
                      type?: Maybe<
                        { __typename?: 'PedagogieRessourceType' } & Pick<
                          PedagogieRessourceType,
                          'nom'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >
    >
  >;
};

export type GetCategoriesWithNameQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCategoriesWithNameQuery = { __typename?: 'Query' } & {
  categorieproduits?: Maybe<
    { __typename?: 'CategorieproduitEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'CategorieproduitEntity' } & Pick<
          CategorieproduitEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'Categorieproduit' } & Pick<
                Categorieproduit,
                'name'
              >
            >;
          }
      >;
    }
  >;
};

export type GetSingleProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetSingleProductQuery = { __typename?: 'Query' } & {
  produit?: Maybe<
    { __typename?: 'ProduitEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'ProduitEntity' } & Pick<ProduitEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Produit' } & {
                ingredients?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'ComponentIngredientsIngredients' } & Pick<
                        ComponentIngredientsIngredients,
                        'name' | 'id' | 'percent'
                      >
                    >
                  >
                >;
                allergens?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: 'ComponentAllergensAllergens' } & Pick<
                        ComponentAllergensAllergens,
                        'id' | 'name'
                      >
                    >
                  >
                >;
                shoppingMobile?: Maybe<
                  Array<
                    Maybe<
                      {
                        __typename?: 'ComponentShoppingMobileShoppingMobile';
                      } & Pick<
                        ComponentShoppingMobileShoppingMobile,
                        'id' | 'description' | 'mobile'
                      >
                    >
                  >
                >;
              } & MainProductsFragment
            >;
          }
      >;
    }
  >;
};

export type GetProductsRebondsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;

export type GetProductsRebondsQuery = { __typename?: 'Query' } & {
  produits?: Maybe<
    { __typename?: 'ProduitEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'ProduitEntity' } & Pick<ProduitEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Produit' } & MainProductsFragment
            >;
          }
      >;
    }
  >;
};

export type GetProductsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProductsQuery = { __typename?: 'Query' } & {
  produits?: Maybe<
    { __typename?: 'ProduitEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'ProduitEntity' } & Pick<ProduitEntity, 'id'> & {
            attributes?: Maybe<
              { __typename?: 'Produit' } & MainProductsFragment
            >;
          }
      >;
    }
  >;
};

export type AllAvailableQuizzQueryVariables = Exact<{ [key: string]: never }>;

export type AllAvailableQuizzQuery = { __typename?: 'Query' } & {
  availableQuiz?: Maybe<
    Array<
      Maybe<
        { __typename?: 'AvailableQuiz' } & Pick<
          AvailableQuiz,
          | 'id'
          | 'name'
          | 'debut'
          | 'fin'
          | 'quizlet'
          | 'desc'
          | 'isAnsweredByUser'
        >
      >
    >
  >;
};

export type AllQuizzQueryVariables = Exact<{ [key: string]: never }>;

export type AllQuizzQuery = { __typename?: 'Query' } & {
  availableQuiz?: Maybe<
    Array<
      Maybe<
        { __typename?: 'AvailableQuiz' } & Pick<
          AvailableQuiz,
          'id' | 'name' | 'debut' | 'fin'
        >
      >
    >
  >;
};

export type SingleQuizQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SingleQuizQuery = { __typename?: 'Query' } & {
  findOneAvailableQuiz?: Maybe<
    { __typename?: 'Quiz' } & Pick<Quiz, 'name' | 'desc'> & {
        questions?: Maybe<
          { __typename?: 'QuestionRelationResponseCollection' } & {
            data: Array<
              { __typename?: 'QuestionEntity' } & Pick<QuestionEntity, 'id'> & {
                  attributes?: Maybe<
                    { __typename?: 'Question' } & Pick<
                      Question,
                      'name' | 'reponse1' | 'reponse2' | 'reponse3'
                    >
                  >;
                }
            >;
          }
        >;
      }
  >;
};

export type PointRelaisQueryVariables = Exact<{
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
}>;

export type PointRelaisQuery = { __typename?: 'Query' } & {
  pointRelais?: Maybe<
    Array<Maybe<{ __typename?: 'Relais' } & RelaisMainInfoFragment>>
  >;
};

export type RessourcesAllByTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RessourcesAllByTypesQuery = { __typename?: 'Query' } & {
  challengeRessources?: Maybe<
    { __typename?: 'ChallengeRessourceEntityResponseCollection' } & {
      data: Array<
        { __typename?: 'ChallengeRessourceEntity' } & {
          attributes?: Maybe<
            { __typename?: 'ChallengeRessource' } & Pick<
              ChallengeRessource,
              'name' | 'subtitle' | 'info' | 'desc' | 'order'
            > & {
                ressource_type?: Maybe<
                  { __typename?: 'ChallengeRessourceTypeEntityResponse' } & {
                    data?: Maybe<
                      { __typename?: 'ChallengeRessourceTypeEntity' } & Pick<
                        ChallengeRessourceTypeEntity,
                        'id'
                      > & {
                          attributes?: Maybe<
                            { __typename?: 'ChallengeRessourceType' } & Pick<
                              ChallengeRessourceType,
                              'name'
                            >
                          >;
                        }
                    >;
                  }
                >;
              }
          >;
        }
      >;
    }
  >;
};

export type GetRessourcesTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRessourcesTypesQuery = { __typename?: 'Query' } & {
  findChallengeRessourceTypeWithRelatedChallengeRessources?: Maybe<
    Array<
      Maybe<
        {
          __typename?: 'ChallengeRessourceTypeWithRelatedChallengeRessources';
        } & Pick<
          ChallengeRessourceTypeWithRelatedChallengeRessources,
          'id' | 'name'
        > & {
            challenge_ressources?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'ChallengeRessources' } & Pick<
                    ChallengeRessources,
                    'name'
                  >
                >
              >
            >;
          }
      >
    >
  >;
};

export type FindRessourceByTypeIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FindRessourceByTypeIdQuery = { __typename?: 'Query' } & {
  findRessourceByTypeId?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Ressource' } & Pick<
          Ressource,
          'name' | 'desc' | 'subtitle' | 'info' | 'order'
        > & {
            ressources?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'RessourceLink' } & Pick<
                    RessourceLink,
                    'titre' | 'lien'
                  > & {
                      media?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'RessourceMedia' } & Pick<
                              RessourceMedia,
                              'url'
                            >
                          >
                        >
                      >;
                      type?: Maybe<
                        { __typename?: 'RessourceType' } & Pick<
                          RessourceType,
                          'nom'
                        >
                      >;
                    }
                >
              >
            >;
          }
      >
    >
  >;
};

export type FindMyCommandeQueryVariables = Exact<{
  id: Scalars['ID'];
  numerocommande: Scalars['String'];
  classeId: Scalars['ID'];
}>;

export type FindMyCommandeQuery = { __typename?: 'Query' } & {
  findMyCommande?: Maybe<
    { __typename?: 'AddedCommande' } & {
      commande: { __typename?: 'CommandeResult' } & Pick<
        CommandeResult,
        | 'id'
        | 'createdAt'
        | 'numerocommande'
        | 'totalttc'
        | 'fraislivraison'
        | 'prixTotal'
        | 'customerContributedToTheOng'
        | 'methodepaiement'
        | 'payment'
        | 'transactionreference'
        | 'statuspayment'
        | 'status'
      > & {
          client: { __typename?: 'ClientResult' } & ClientResultFragment;
          commandelines: Array<
            Maybe<
              { __typename?: 'CommandeLineResult' } & Pick<
                CommandeLineResult,
                'id' | 'quantite'
              > & {
                  produit: { __typename?: 'ProduitResult' } & Pick<
                    ProduitResult,
                    'id' | 'name' | 'ttcPrice' | 'ref' | 'venterebond'
                  > & {
                      media?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: 'MediaUrl' } & Pick<MediaUrl, 'url'>
                          >
                        >
                      >;
                    };
                }
            >
          >;
          user: { __typename?: 'User' } & Pick<
            User,
            'firstname' | 'lastname' | 'email'
          > & {
              classe?: Maybe<
                { __typename?: 'UserClasse' } & Pick<
                  UserClasse,
                  'debut' | 'fin' | 'operationid'
                > & {
                    filliere: { __typename?: 'FilliereResult' } & Pick<
                      FilliereResult,
                      'name'
                    >;
                    lycee: { __typename?: 'LyceeResult' } & Pick<
                      LyceeResult,
                      'name'
                    > & {
                        academie: { __typename?: 'AcademieName' } & Pick<
                          AcademieName,
                          'name'
                        >;
                      };
                    niveau: { __typename?: 'NiveauResult' } & Pick<
                      NiveauResult,
                      'name'
                    >;
                  }
              >;
            };
        };
      sherlock?: Maybe<
        { __typename?: 'Sherlock' } & Pick<
          Sherlock,
          'data' | 'interfaceVersion' | 'redirectionUrl' | 'seal'
        >
      >;
    }
  >;
};

export type GetShopEleveQueryVariables = Exact<{
  id: Scalars['ID'];
  classeId: Scalars['ID'];
}>;

export type GetShopEleveQuery = { __typename?: 'Query' } & {
  eleve?: Maybe<
    { __typename?: 'Eleve' } & Pick<
      Eleve,
      'ong' | 'email' | 'firstname' | 'lastname' | 'role'
    > & {
        avatar?: Maybe<
          { __typename?: 'AvatarMedia' } & {
            media?: Maybe<{ __typename?: 'Url' } & Pick<Url, 'url'>>;
          }
        >;
        note?: Maybe<{ __typename?: 'Note' } & Pick<Note, 'updatedAt'>>;
        classe?: Maybe<
          { __typename?: 'ClasseWithLycee' } & Pick<
            ClasseWithLycee,
            'debut' | 'fin' | 'operationid'
          > & {
              lycee?: Maybe<
                { __typename?: 'LyceeName' } & Pick<LyceeName, 'name' | 'ville'>
              >;
            }
        >;
      }
  >;
};

export type GetPublicShopQueryVariables = Exact<{
  id: Scalars['ID'];
  classeId: Scalars['ID'];
}>;

export type GetPublicShopQuery = { __typename?: 'Query' } & {
  shop?: Maybe<
    { __typename?: 'Shop' } & {
      produits?: Maybe<
        Array<
          Maybe<
            { __typename?: 'ProduitEntity' } & Pick<ProduitEntity, 'id'> & {
                attributes?: Maybe<
                  { __typename?: 'Produit' } & MainProductsFragment
                >;
              }
          >
        >
      >;
    }
  >;
};

export type UpdateNoteQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UpdateNoteQueryQuery = { __typename?: 'Query' } & {
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & Pick<
          UsersPermissionsUserEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsUser' } & {
                notes?: Maybe<
                  { __typename?: 'NoteRelationResponseCollection' } & {
                    data: Array<
                      { __typename?: 'NoteEntity' } & {
                        attributes?: Maybe<
                          { __typename?: 'Note' } & Pick<
                            Note,
                            'updatedAt' | 'createdAt'
                          >
                        >;
                      }
                    >;
                  }
                >;
              }
            >;
          }
      >;
    }
  >;
};

export type QueryUserAllInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QueryUserAllInfoQuery = { __typename?: 'Query' } & {
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & Pick<
          UsersPermissionsUserEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsUser' } & {
                classes?: Maybe<
                  { __typename?: 'ClasseRelationResponseCollection' } & {
                    data: Array<
                      { __typename?: 'ClasseEntity' } & {
                        attributes?: Maybe<
                          { __typename?: 'Classe' } & ClasseFragment
                        >;
                      }
                    >;
                  }
                >;
              } & AccountFragment &
                AvatarFragment
            >;
          }
      >;
    }
  >;
};

export type QueryCacheInfoAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QueryCacheInfoAccountQuery = { __typename?: 'Query' } & {
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & {
          attributes?: Maybe<
            { __typename?: 'UsersPermissionsUser' } & AccountFragment
          >;
        }
      >;
    }
  >;
};

export type QueryUserAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type QueryUserAccountQuery = { __typename?: 'Query' } & {
  getUserAccount?: Maybe<
    { __typename?: 'GetUserAccount' } & Pick<
      GetUserAccount,
      | 'id'
      | 'ville'
      | 'firstname'
      | 'username'
      | 'lastname'
      | 'confirmed'
      | 'tel'
      | 'email'
      | 'shop'
      | 'mdp'
    > & {
        avatar?: Maybe<
          { __typename?: 'userAvatar' } & Pick<UserAvatar, 'name' | 'id'> & {
              media?: Maybe<
                { __typename?: 'avatarMediaUrl' } & Pick<AvatarMediaUrl, 'url'>
              >;
            }
        >;
        note?: Maybe<
          { __typename?: 'UserNote' } & Pick<
            UserNote,
            | 'qteca'
            | 'qtepro'
            | 'qterebond'
            | 'quiz'
            | 'qtequiz'
            | 'qtevente'
            | 'nbvente'
            | 'cavente'
            | 'venterebond'
            | 'moyennegenerale'
            | 'pro'
          >
        >;
        classe?: Maybe<
          { __typename?: 'UserAccountClasse' } & Pick<
            UserAccountClasse,
            'id' | 'name' | 'operationid' | 'debut' | 'fin'
          > & {
              niveau?: Maybe<
                { __typename?: 'ClasseNiveau' } & Pick<
                  ClasseNiveau,
                  'id' | 'name'
                >
              >;
              filiere?: Maybe<
                { __typename?: 'ClasseFiliere' } & Pick<
                  ClasseFiliere,
                  'id' | 'name'
                >
              >;
              lycee?: Maybe<
                { __typename?: 'ClasseLycee' } & Pick<
                  ClasseLycee,
                  'id' | 'name'
                >
              >;
            }
        >;
      }
  >;
};

export type QueryUserClasseQueryVariables = Exact<{ [key: string]: never }>;

export type QueryUserClasseQuery = { __typename?: 'Query' } & {
  getUserClasse?: Maybe<
    { __typename?: 'userClasseType' } & Pick<
      UserClasseType,
      'name' | 'debut' | 'fin' | 'lycee' | 'operationid' | 'id'
    >
  >;
};

export type GetUserClasseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetUserClasseQuery = { __typename?: 'Query' } & {
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & {
          attributes?: Maybe<
            { __typename?: 'UsersPermissionsUser' } & {
              classes?: Maybe<
                { __typename?: 'ClasseRelationResponseCollection' } & {
                  data: Array<
                    { __typename?: 'ClasseEntity' } & Pick<
                      ClasseEntity,
                      'id'
                    > & {
                        attributes?: Maybe<
                          { __typename?: 'Classe' } & Pick<
                            Classe,
                            'name' | 'operationid'
                          > & {
                              filliere?: Maybe<
                                { __typename?: 'FilliereEntityResponse' } & {
                                  data?: Maybe<
                                    { __typename?: 'FilliereEntity' } & {
                                      attributes?: Maybe<
                                        { __typename?: 'Filliere' } & Pick<
                                          Filliere,
                                          'name'
                                        >
                                      >;
                                    }
                                  >;
                                }
                              >;
                              lycee?: Maybe<
                                { __typename?: 'LyceeEntityResponse' } & {
                                  data?: Maybe<
                                    { __typename?: 'LyceeEntity' } & {
                                      attributes?: Maybe<
                                        { __typename?: 'Lycee' } & Pick<
                                          Lycee,
                                          'name'
                                        >
                                      >;
                                    }
                                  >;
                                }
                              >;
                            }
                        >;
                      }
                  >;
                }
              >;
            }
          >;
        }
      >;
    }
  >;
};

export type GetUserOnHomeQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserOnHomeQuery = { __typename?: 'Query' } & {
  getUserOnHome?: Maybe<
    { __typename?: 'getUserOnHome' } & Pick<
      GetUserOnHome,
      | 'id'
      | 'firstname'
      | 'lastname'
      | 'email'
      | 'role'
      | 'tel'
      | 'username'
      | 'isPairTeacher'
      | 'ong'
    > & {
        options?: Maybe<
          { __typename?: 'options' } & Pick<Options, 'notifications'>
        >;
        avatar?: Maybe<
          { __typename?: 'userAvatar' } & Pick<UserAvatar, 'id' | 'name'> & {
              media?: Maybe<
                { __typename?: 'avatarMediaUrl' } & Pick<AvatarMediaUrl, 'url'>
              >;
            }
        >;
        classe?: Maybe<
          { __typename?: 'userClasseType' } & Pick<
            UserClasseType,
            'id' | 'debut' | 'fin' | 'lycee' | 'name' | 'operationid'
          >
        >;
      }
  >;
};

export type GetUserOngQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type GetUserOngQuery = { __typename?: 'Query' } & {
  usersPermissionsUser?: Maybe<
    { __typename?: 'UsersPermissionsUserEntityResponse' } & {
      data?: Maybe<
        { __typename?: 'UsersPermissionsUserEntity' } & Pick<
          UsersPermissionsUserEntity,
          'id'
        > & {
            attributes?: Maybe<
              { __typename?: 'UsersPermissionsUser' } & Pick<
                UsersPermissionsUser,
                'ong'
              >
            >;
          }
      >;
    }
  >;
};

export const AcademieInfoFragmentDoc = gql`
  fragment AcademieInfo on AcademieEntity {
    attributes {
      name
    }
  }
`;
export const ClasseInfoFragmentDoc = gql`
  fragment ClasseInfo on Classe {
    debut
    fin
    name
    operationid
    filliere {
      data {
        id
        attributes {
          name
        }
      }
    }
    lycee {
      data {
        id
        attributes {
          name
        }
      }
    }
    niveau {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;
export const QuantiteClasseFragmentDoc = gql`
  fragment QuantiteClasse on Noteclasse {
    qtevente
    qtepro
    qtequiz
    qterebond
    qteca
  }
`;
export const ClientResultFragmentDoc = gql`
  fragment ClientResult on ClientResult {
    id
    civilite
    nom
    prenom
    adressefacturation
    cpfacturation
    villefacturation
    tel
    mail
    livraisonhorslycee
    civilitelivraison
    prenomlivraison
    nomlivraison
    adresselivraison
    cplivraison
    villelivraison
    mobilelivraison
    clientpro
    nomsociete
    policy
    affilie
    nompointrelais
  }
`;
export const MainCommandeFragmentDoc = gql`
  fragment MainCommande on Commande {
    createdAt
    fraislivraison
    methodepaiement
    numerocommande
    payment
    totalttc
    status
    prixTotal
    customerContributedToTheOng
  }
`;
export const FilliereInfoFragmentDoc = gql`
  fragment FilliereInfo on Filliere {
    name
  }
`;
export const NiveauInfoFragmentDoc = gql`
  fragment NiveauInfo on Niveau {
    name
  }
`;
export const QuantiteFragmentDoc = gql`
  fragment Quantite on Note {
    qtevente
    qtepro
    qtequiz
    qterebond
    qteca
  }
`;
export const MoyenneFragmentDoc = gql`
  fragment Moyenne on Note {
    cavente
    nbvente
    venterebond
    pro
    moyennegenerale
    quiz
  }
`;
export const UserLeaderBoardFragmentDoc = gql`
  fragment UserLeaderBoard on Note {
    user {
      data {
        id
        attributes {
          firstname
          lastname
          ville
          avatar {
            data {
              id
              attributes {
                media {
                  data {
                    id
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
          notes {
            data {
              id
              attributes {
                moyennegenerale
              }
            }
          }
        }
      }
    }
  }
`;
export const EleveDashBoardProfFragmentDoc = gql`
  fragment EleveDashBoardProf on UsersPermissionsUser {
    username
    email
    firstname
    lastname
    ville
    mdp
    shop
    role {
      data {
        attributes {
          name
        }
      }
    }
    quiztonotes {
      data {
        attributes {
          note
          createdAt
          quiz {
            data {
              id
            }
          }
        }
      }
    }
    avatar {
      data {
        id
        attributes {
          media {
            data {
              id
              attributes {
                url
              }
            }
          }
        }
      }
    }
    notes {
      data {
        id
        attributes {
          createdAt
          updatedAt
          nbvente
        }
      }
    }
  }
`;
export const RankFragmentDoc = gql`
  fragment Rank on Rank {
    rank
    moyennegenerale
    username
    firstname
    lastname
    ville
    avatar {
      media {
        url
      }
    }
    elId
  }
`;
export const ChallengeNoteFragmentDoc = gql`
  fragment ChallengeNote on Note {
    cavente
    quiz
    nbvente
    venterebond
    pro
    moyennegenerale
  }
`;
export const NoteDesQuizFragmentDoc = gql`
  fragment NoteDesQuiz on Quiztonote {
    note
    quiz {
      data {
        id
        attributes {
          name
          debut
          fin
        }
      }
    }
  }
`;
export const GetPedagogieByChallengeTypeFragmentDoc = gql`
  fragment GetPedagogieByChallengeType on Challenge {
    challengetypes {
      data {
        id
        attributes {
          pedagogies(sort: "order:desc") {
            data {
              id
              attributes {
                name
                subtitle
                info
                desc
                order
                pedagogie_type {
                  data {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const MainProductsFragmentDoc = gql`
  fragment MainProducts on Produit {
    name
    netWeight
    ttcPrice
    description
    catchPhrase
    venterebond
    ref
    isOut
    categorieproduits {
      data {
        id
        attributes {
          name
        }
      }
    }
    ingredients {
      id
      name
      percent
    }
    allergens {
      id
      name
    }
    shoppingMobile {
      id
      mobile
      description
    }
    characteristics {
      id
      characteristic
      value
    }
    media {
      data {
        id
        attributes {
          url
          name
        }
      }
    }
  }
`;
export const RelaisMainInfoFragmentDoc = gql`
  fragment RelaisMainInfo on Relais {
    adresse1
    adresse2
    adresse3
    codePostal
    localite
    identifiant
    nom
    coordGeolocalisationLatitude
    coordGeolocalisationLongitude
  }
`;
export const AccountFragmentDoc = gql`
  fragment Account on UsersPermissionsUser {
    username
    firstname
    lastname
    email
    tel
    mdp
    shop
    confirmed
    options
    notes {
      data {
        id
        attributes {
          createdAt
          updatedAt
          nbvente
        }
      }
    }
  }
`;
export const AvatarFragmentDoc = gql`
  fragment Avatar on UsersPermissionsUser {
    avatar {
      data {
        id
        attributes {
          name
          media {
            data {
              id
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;
export const ClasseFragmentDoc = gql`
  fragment Classe on Classe {
    debut
    fin
    name
    operationid
    filliere {
      data {
        id
        attributes {
          name
        }
      }
    }
    lycee {
      data {
        id
        attributes {
          name
          academie {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
    niveau {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;
export const MainFragmentDoc = gql`
  fragment Main on Client {
    civilite
    nom
    prenom
    adressefacturation
    cpfacturation
    villefacturation
    tel
    mail
    livraisonhorslycee
    civilitelivraison
    prenomlivraison
    nomlivraison
    adresselivraison
    cplivraison
    villelivraison
    mobilelivraison
    clientpro
    nomsociete
    policy
    affilie
    nompointrelais
  }
`;
export const MainCommandelineFragmentDoc = gql`
  fragment MainCommandeline on Commandeline {
    quantite
    produit {
      data {
        id
        attributes {
          name
          ttcPrice
          ref
          venterebond
          media {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;
export const DetailsCommandeFragmentDoc = gql`
  fragment DetailsCommande on Commande {
    createdAt
    fraislivraison
    methodepaiement
    numerocommande
    customerContributedToTheOng
    payment
    totalttc
    status
    controlled
    livraison
    paymentreminder
    prixTotal
    customerContributedToTheOng
    user {
      data {
        attributes {
          firstname
          lastname
        }
      }
    }
    client {
      data {
        id
        attributes {
          ...Main
        }
      }
    }
    commandelines {
      data {
        id
        attributes {
          ...MainCommandeline
        }
      }
    }
  }
  ${MainFragmentDoc}
  ${MainCommandelineFragmentDoc}
`;
export const CommandesFragmentDoc = gql`
  fragment Commandes on UsersPermissionsUser {
    commandes(sort: "createdAt:desc") {
      data {
        attributes {
          ...DetailsCommande
        }
      }
    }
  }
  ${DetailsCommandeFragmentDoc}
`;
export const PublicInfoFragmentDoc = gql`
  fragment PublicInfo on UsersPermissionsUser {
    firstname
    lastname
    email
  }
`;
export const UpdateClasseObjectiveDocument = gql`
  mutation UpdateClasseObjective($name: String!, $ca: Int!) {
    updateClassObjective(name: $name, ca: $ca) {
      objectif {
        name
        ca
      }
    }
  }
`;
export type UpdateClasseObjectiveMutationFn = Apollo.MutationFunction<
  UpdateClasseObjectiveMutation,
  UpdateClasseObjectiveMutationVariables
>;

/**
 * __useUpdateClasseObjectiveMutation__
 *
 * To run a mutation, you first call `useUpdateClasseObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClasseObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClasseObjectiveMutation, { data, loading, error }] = useUpdateClasseObjectiveMutation({
 *   variables: {
 *      name: // value for 'name'
 *      ca: // value for 'ca'
 *   },
 * });
 */
export function useUpdateClasseObjectiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClasseObjectiveMutation,
    UpdateClasseObjectiveMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateClasseObjectiveMutation,
    UpdateClasseObjectiveMutationVariables
  >(UpdateClasseObjectiveDocument, baseOptions);
}
export type UpdateClasseObjectiveMutationHookResult = ReturnType<
  typeof useUpdateClasseObjectiveMutation
>;
export type UpdateClasseObjectiveMutationResult = Apollo.MutationResult<
  UpdateClasseObjectiveMutation
>;
export type UpdateClasseObjectiveMutationOptions = Apollo.BaseMutationOptions<
  UpdateClasseObjectiveMutation,
  UpdateClasseObjectiveMutationVariables
>;
export const UpdateClasseOngDocument = gql`
  mutation UpdateClasseOng($id: ID!, $data: ClasseInput!) {
    updateClasse(id: $id, data: $data) {
      data {
        id
        attributes {
          ong
          percentDedicatedToOng
        }
      }
    }
  }
`;
export type UpdateClasseOngMutationFn = Apollo.MutationFunction<
  UpdateClasseOngMutation,
  UpdateClasseOngMutationVariables
>;

/**
 * __useUpdateClasseOngMutation__
 *
 * To run a mutation, you first call `useUpdateClasseOngMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClasseOngMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClasseOngMutation, { data, loading, error }] = useUpdateClasseOngMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClasseOngMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClasseOngMutation,
    UpdateClasseOngMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateClasseOngMutation,
    UpdateClasseOngMutationVariables
  >(UpdateClasseOngDocument, baseOptions);
}
export type UpdateClasseOngMutationHookResult = ReturnType<
  typeof useUpdateClasseOngMutation
>;
export type UpdateClasseOngMutationResult = Apollo.MutationResult<
  UpdateClasseOngMutation
>;
export type UpdateClasseOngMutationOptions = Apollo.BaseMutationOptions<
  UpdateClasseOngMutation,
  UpdateClasseOngMutationVariables
>;
export const AddCommandesAndNoteDocument = gql`
  mutation AddCommandesAndNote($order: Order) {
    addCommandesAndNote(order: $order) {
      ...MainCommande
      user {
        data {
          attributes {
            ...PublicInfo
            classes {
              data {
                id
                attributes {
                  ...Classe
                }
              }
            }
          }
        }
      }
      commandelines {
        data {
          attributes {
            ...MainCommandeline
          }
        }
      }
      client {
        data {
          attributes {
            ...Main
          }
        }
      }
    }
  }
  ${MainCommandeFragmentDoc}
  ${PublicInfoFragmentDoc}
  ${ClasseFragmentDoc}
  ${MainCommandelineFragmentDoc}
  ${MainFragmentDoc}
`;
export type AddCommandesAndNoteMutationFn = Apollo.MutationFunction<
  AddCommandesAndNoteMutation,
  AddCommandesAndNoteMutationVariables
>;

/**
 * __useAddCommandesAndNoteMutation__
 *
 * To run a mutation, you first call `useAddCommandesAndNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommandesAndNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommandesAndNoteMutation, { data, loading, error }] = useAddCommandesAndNoteMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddCommandesAndNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCommandesAndNoteMutation,
    AddCommandesAndNoteMutationVariables
  >
) {
  return Apollo.useMutation<
    AddCommandesAndNoteMutation,
    AddCommandesAndNoteMutationVariables
  >(AddCommandesAndNoteDocument, baseOptions);
}
export type AddCommandesAndNoteMutationHookResult = ReturnType<
  typeof useAddCommandesAndNoteMutation
>;
export type AddCommandesAndNoteMutationResult = Apollo.MutationResult<
  AddCommandesAndNoteMutation
>;
export type AddCommandesAndNoteMutationOptions = Apollo.BaseMutationOptions<
  AddCommandesAndNoteMutation,
  AddCommandesAndNoteMutationVariables
>;
export const UpdateToControlledDocument = gql`
  mutation updateToControlled($id: Int, $controlled: Boolean) {
    updateControlStatus(id: $id, controlled: $controlled) {
      controlled
    }
  }
`;
export type UpdateToControlledMutationFn = Apollo.MutationFunction<
  UpdateToControlledMutation,
  UpdateToControlledMutationVariables
>;

/**
 * __useUpdateToControlledMutation__
 *
 * To run a mutation, you first call `useUpdateToControlledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateToControlledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateToControlledMutation, { data, loading, error }] = useUpdateToControlledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      controlled: // value for 'controlled'
 *   },
 * });
 */
export function useUpdateToControlledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateToControlledMutation,
    UpdateToControlledMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateToControlledMutation,
    UpdateToControlledMutationVariables
  >(UpdateToControlledDocument, baseOptions);
}
export type UpdateToControlledMutationHookResult = ReturnType<
  typeof useUpdateToControlledMutation
>;
export type UpdateToControlledMutationResult = Apollo.MutationResult<
  UpdateToControlledMutation
>;
export type UpdateToControlledMutationOptions = Apollo.BaseMutationOptions<
  UpdateToControlledMutation,
  UpdateToControlledMutationVariables
>;
export const UpdatePaymentReminderDocument = gql`
  mutation updatePaymentReminder($id: Int, $paymentreminder: Boolean) {
    updatePaymentReminder(id: $id, paymentreminder: $paymentreminder) {
      paymentreminder
    }
  }
`;
export type UpdatePaymentReminderMutationFn = Apollo.MutationFunction<
  UpdatePaymentReminderMutation,
  UpdatePaymentReminderMutationVariables
>;

/**
 * __useUpdatePaymentReminderMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentReminderMutation, { data, loading, error }] = useUpdatePaymentReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentreminder: // value for 'paymentreminder'
 *   },
 * });
 */
export function useUpdatePaymentReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePaymentReminderMutation,
    UpdatePaymentReminderMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdatePaymentReminderMutation,
    UpdatePaymentReminderMutationVariables
  >(UpdatePaymentReminderDocument, baseOptions);
}
export type UpdatePaymentReminderMutationHookResult = ReturnType<
  typeof useUpdatePaymentReminderMutation
>;
export type UpdatePaymentReminderMutationResult = Apollo.MutationResult<
  UpdatePaymentReminderMutation
>;
export type UpdatePaymentReminderMutationOptions = Apollo.BaseMutationOptions<
  UpdatePaymentReminderMutation,
  UpdatePaymentReminderMutationVariables
>;
export const UpdateStatusDocument = gql`
  mutation updateStatus($id: ID!, $status: ENUM_COMMANDE_STATUS) {
    updateCommande(id: $id, data: { status: $status }) {
      data {
        attributes {
          status
        }
      }
    }
  }
`;
export type UpdateStatusMutationFn = Apollo.MutationFunction<
  UpdateStatusMutation,
  UpdateStatusMutationVariables
>;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStatusMutation,
    UpdateStatusMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateStatusMutation,
    UpdateStatusMutationVariables
  >(UpdateStatusDocument, baseOptions);
}
export type UpdateStatusMutationHookResult = ReturnType<
  typeof useUpdateStatusMutation
>;
export type UpdateStatusMutationResult = Apollo.MutationResult<
  UpdateStatusMutation
>;
export type UpdateStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateStatusMutation,
  UpdateStatusMutationVariables
>;
export const UpdateAllNoteDocument = gql`
  mutation UpdateAllNote {
    updateAllNote {
      ...Quantite
      ...Moyenne
      user {
        data {
          id
          attributes {
            firstname
            lastname
          }
        }
      }
    }
  }
  ${QuantiteFragmentDoc}
  ${MoyenneFragmentDoc}
`;
export type UpdateAllNoteMutationFn = Apollo.MutationFunction<
  UpdateAllNoteMutation,
  UpdateAllNoteMutationVariables
>;

/**
 * __useUpdateAllNoteMutation__
 *
 * To run a mutation, you first call `useUpdateAllNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllNoteMutation, { data, loading, error }] = useUpdateAllNoteMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateAllNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAllNoteMutation,
    UpdateAllNoteMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateAllNoteMutation,
    UpdateAllNoteMutationVariables
  >(UpdateAllNoteDocument, baseOptions);
}
export type UpdateAllNoteMutationHookResult = ReturnType<
  typeof useUpdateAllNoteMutation
>;
export type UpdateAllNoteMutationResult = Apollo.MutationResult<
  UpdateAllNoteMutation
>;
export type UpdateAllNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdateAllNoteMutation,
  UpdateAllNoteMutationVariables
>;
export const UpdateNoteClasseDocument = gql`
  mutation UpdateNoteClasse {
    updateNoteClasse
  }
`;
export type UpdateNoteClasseMutationFn = Apollo.MutationFunction<
  UpdateNoteClasseMutation,
  UpdateNoteClasseMutationVariables
>;

/**
 * __useUpdateNoteClasseMutation__
 *
 * To run a mutation, you first call `useUpdateNoteClasseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteClasseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteClasseMutation, { data, loading, error }] = useUpdateNoteClasseMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateNoteClasseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNoteClasseMutation,
    UpdateNoteClasseMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateNoteClasseMutation,
    UpdateNoteClasseMutationVariables
  >(UpdateNoteClasseDocument, baseOptions);
}
export type UpdateNoteClasseMutationHookResult = ReturnType<
  typeof useUpdateNoteClasseMutation
>;
export type UpdateNoteClasseMutationResult = Apollo.MutationResult<
  UpdateNoteClasseMutation
>;
export type UpdateNoteClasseMutationOptions = Apollo.BaseMutationOptions<
  UpdateNoteClasseMutation,
  UpdateNoteClasseMutationVariables
>;
export const UpdateMyNoteDocument = gql`
  mutation UpdateMyNote {
    updateMyNote {
      user {
        data {
          attributes {
            notes {
              data {
                attributes {
                  cavente
                  nbvente
                  venterebond
                  moyennegenerale
                  qtevente
                  qteca
                  qtepro
                  qterebond
                  qtequiz
                }
              }
            }
          }
        }
      }
    }
  }
`;
export type UpdateMyNoteMutationFn = Apollo.MutationFunction<
  UpdateMyNoteMutation,
  UpdateMyNoteMutationVariables
>;

/**
 * __useUpdateMyNoteMutation__
 *
 * To run a mutation, you first call `useUpdateMyNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyNoteMutation, { data, loading, error }] = useUpdateMyNoteMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateMyNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMyNoteMutation,
    UpdateMyNoteMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateMyNoteMutation,
    UpdateMyNoteMutationVariables
  >(UpdateMyNoteDocument, baseOptions);
}
export type UpdateMyNoteMutationHookResult = ReturnType<
  typeof useUpdateMyNoteMutation
>;
export type UpdateMyNoteMutationResult = Apollo.MutationResult<
  UpdateMyNoteMutation
>;
export type UpdateMyNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdateMyNoteMutation,
  UpdateMyNoteMutationVariables
>;
export const UpdateUserOptionsDocument = gql`
  mutation updateUserOptions($key: String, $data: String) {
    updateOptions(key: $key, data: $data) {
      firstname
      lastname
      options
    }
  }
`;
export type UpdateUserOptionsMutationFn = Apollo.MutationFunction<
  UpdateUserOptionsMutation,
  UpdateUserOptionsMutationVariables
>;

/**
 * __useUpdateUserOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateUserOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOptionsMutation, { data, loading, error }] = useUpdateUserOptionsMutation({
 *   variables: {
 *      key: // value for 'key'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserOptionsMutation,
    UpdateUserOptionsMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateUserOptionsMutation,
    UpdateUserOptionsMutationVariables
  >(UpdateUserOptionsDocument, baseOptions);
}
export type UpdateUserOptionsMutationHookResult = ReturnType<
  typeof useUpdateUserOptionsMutation
>;
export type UpdateUserOptionsMutationResult = Apollo.MutationResult<
  UpdateUserOptionsMutation
>;
export type UpdateUserOptionsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserOptionsMutation,
  UpdateUserOptionsMutationVariables
>;
export const AddPublicOrderDocument = gql`
  mutation AddPublicOrder($shopId: String!, $order: Order!, $classeId: ID!) {
    createOrder(order: $order, shopId: $shopId, classeId: $classeId) {
      commande {
        id
        createdAt
        fraislivraison
        methodepaiement
        numerocommande
        payment
        totalttc
        prixTotal
        customerContributedToTheOng
        status
        user {
          classe {
            debut
            fin
            operationid
            filliere {
              name
            }
            lycee {
              name
              academie {
                name
              }
            }
            niveau {
              name
            }
          }
          firstname
          lastname
          email
        }
        commandelines {
          id
          quantite
          produit {
            id
            name
            ttcPrice
            ref
            venterebond
            media {
              url
            }
          }
        }
        client {
          ...ClientResult
        }
      }
      sherlock {
        interfaceVersion
        data
        redirectionUrl
        seal
        automaticResponseUrl
      }
    }
  }
  ${ClientResultFragmentDoc}
`;
export type AddPublicOrderMutationFn = Apollo.MutationFunction<
  AddPublicOrderMutation,
  AddPublicOrderMutationVariables
>;

/**
 * __useAddPublicOrderMutation__
 *
 * To run a mutation, you first call `useAddPublicOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPublicOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPublicOrderMutation, { data, loading, error }] = useAddPublicOrderMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      order: // value for 'order'
 *      classeId: // value for 'classeId'
 *   },
 * });
 */
export function useAddPublicOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPublicOrderMutation,
    AddPublicOrderMutationVariables
  >
) {
  return Apollo.useMutation<
    AddPublicOrderMutation,
    AddPublicOrderMutationVariables
  >(AddPublicOrderDocument, baseOptions);
}
export type AddPublicOrderMutationHookResult = ReturnType<
  typeof useAddPublicOrderMutation
>;
export type AddPublicOrderMutationResult = Apollo.MutationResult<
  AddPublicOrderMutation
>;
export type AddPublicOrderMutationOptions = Apollo.BaseMutationOptions<
  AddPublicOrderMutation,
  AddPublicOrderMutationVariables
>;
export const SendQuizNoteDocument = gql`
  mutation sendQuizNote($quizId: ID!, $quizRep: [QuizRep!]!) {
    createQuizNote(quiz: $quizId, reponses: $quizRep) {
      note
      quiz {
        data {
          attributes {
            name
          }
        }
      }
    }
  }
`;
export type SendQuizNoteMutationFn = Apollo.MutationFunction<
  SendQuizNoteMutation,
  SendQuizNoteMutationVariables
>;

/**
 * __useSendQuizNoteMutation__
 *
 * To run a mutation, you first call `useSendQuizNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuizNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuizNoteMutation, { data, loading, error }] = useSendQuizNoteMutation({
 *   variables: {
 *      quizId: // value for 'quizId'
 *      quizRep: // value for 'quizRep'
 *   },
 * });
 */
export function useSendQuizNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendQuizNoteMutation,
    SendQuizNoteMutationVariables
  >
) {
  return Apollo.useMutation<
    SendQuizNoteMutation,
    SendQuizNoteMutationVariables
  >(SendQuizNoteDocument, baseOptions);
}
export type SendQuizNoteMutationHookResult = ReturnType<
  typeof useSendQuizNoteMutation
>;
export type SendQuizNoteMutationResult = Apollo.MutationResult<
  SendQuizNoteMutation
>;
export type SendQuizNoteMutationOptions = Apollo.BaseMutationOptions<
  SendQuizNoteMutation,
  SendQuizNoteMutationVariables
>;
export const OnLoginDocument = gql`
  mutation OnLogin($identifier: String!, $password: String!) {
    login(input: { identifier: $identifier, password: $password }) {
      jwt
      user {
        id
        username
      }
    }
  }
`;
export type OnLoginMutationFn = Apollo.MutationFunction<
  OnLoginMutation,
  OnLoginMutationVariables
>;

/**
 * __useOnLoginMutation__
 *
 * To run a mutation, you first call `useOnLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onLoginMutation, { data, loading, error }] = useOnLoginMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useOnLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OnLoginMutation,
    OnLoginMutationVariables
  >
) {
  return Apollo.useMutation<OnLoginMutation, OnLoginMutationVariables>(
    OnLoginDocument,
    baseOptions
  );
}
export type OnLoginMutationHookResult = ReturnType<typeof useOnLoginMutation>;
export type OnLoginMutationResult = Apollo.MutationResult<OnLoginMutation>;
export type OnLoginMutationOptions = Apollo.BaseMutationOptions<
  OnLoginMutation,
  OnLoginMutationVariables
>;
export const ChangePasswordDocument = gql`
  mutation ChangePassword($pass: String, $id: ID!) {
    updateUsersPermissionsUser(id: $id, data: { mdp: $pass }) {
      data {
        id
      }
    }
  }
`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      pass: // value for 'pass'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >
) {
  return Apollo.useMutation<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >(ChangePasswordDocument, baseOptions);
}
export type ChangePasswordMutationHookResult = ReturnType<
  typeof useChangePasswordMutation
>;
export type ChangePasswordMutationResult = Apollo.MutationResult<
  ChangePasswordMutation
>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation DeleteUser($userId: ID!) {
    deleteUser(userId: $userId) {
      name
      deleted
      reason
    }
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >
) {
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    baseOptions
  );
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>;
export type DeleteUserMutationResult = Apollo.MutationResult<
  DeleteUserMutation
>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const AddUserDocument = gql`
  mutation addUser(
    $lastname: String!
    $firstname: String
    $email: String
    $username: String
    $password: String
    $classes: [ID]
    $role: ID
  ) {
    createUsersPermissionsUser(
      data: {
        lastname: $lastname
        firstname: $firstname
        email: $email
        username: $username
        password: $password
        classes: $classes
        role: $role
      }
    ) {
      data {
        attributes {
          firstname
          lastname
          username
          mdp
          email
          classes {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;
export type AddUserMutationFn = Apollo.MutationFunction<
  AddUserMutation,
  AddUserMutationVariables
>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      lastname: // value for 'lastname'
 *      firstname: // value for 'firstname'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      classes: // value for 'classes'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddUserMutation,
    AddUserMutationVariables
  >
) {
  return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(
    AddUserDocument,
    baseOptions
  );
}
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<
  AddUserMutation,
  AddUserMutationVariables
>;
export const AddProfDocument = gql`
  mutation addProf(
    $username: String!
    $lastname: String!
    $firstname: String
    $tel: String
    $email: String!
    $password: String
    $classes: [ID]
    $role: ID
    $isPairTeacher: Boolean
    $blocked: Boolean
  ) {
    createUsersPermissionsUser(
      data: {
        username: $username
        lastname: $lastname
        firstname: $firstname
        tel: $tel
        email: $email
        password: $password
        classes: $classes
        role: $role
        isPairTeacher: $isPairTeacher
        blocked: $blocked
      }
    ) {
      data {
        id
        attributes {
          email
          firstname
          lastname
          mdp
          username
        }
      }
    }
  }
`;
export type AddProfMutationFn = Apollo.MutationFunction<
  AddProfMutation,
  AddProfMutationVariables
>;

/**
 * __useAddProfMutation__
 *
 * To run a mutation, you first call `useAddProfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProfMutation, { data, loading, error }] = useAddProfMutation({
 *   variables: {
 *      username: // value for 'username'
 *      lastname: // value for 'lastname'
 *      firstname: // value for 'firstname'
 *      tel: // value for 'tel'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      classes: // value for 'classes'
 *      role: // value for 'role'
 *      isPairTeacher: // value for 'isPairTeacher'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useAddProfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddProfMutation,
    AddProfMutationVariables
  >
) {
  return Apollo.useMutation<AddProfMutation, AddProfMutationVariables>(
    AddProfDocument,
    baseOptions
  );
}
export type AddProfMutationHookResult = ReturnType<typeof useAddProfMutation>;
export type AddProfMutationResult = Apollo.MutationResult<AddProfMutation>;
export type AddProfMutationOptions = Apollo.BaseMutationOptions<
  AddProfMutation,
  AddProfMutationVariables
>;
export const OnUserAvatarDocument = gql`
  mutation onUserAvatar($avatar: ID!, $user: ID!) {
    updateUsersPermissionsUser(id: $user, data: { avatar: $avatar }) {
      data {
        id
        attributes {
          avatar {
            data {
              id
              attributes {
                media {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export type OnUserAvatarMutationFn = Apollo.MutationFunction<
  OnUserAvatarMutation,
  OnUserAvatarMutationVariables
>;

/**
 * __useOnUserAvatarMutation__
 *
 * To run a mutation, you first call `useOnUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onUserAvatarMutation, { data, loading, error }] = useOnUserAvatarMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useOnUserAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OnUserAvatarMutation,
    OnUserAvatarMutationVariables
  >
) {
  return Apollo.useMutation<
    OnUserAvatarMutation,
    OnUserAvatarMutationVariables
  >(OnUserAvatarDocument, baseOptions);
}
export type OnUserAvatarMutationHookResult = ReturnType<
  typeof useOnUserAvatarMutation
>;
export type OnUserAvatarMutationResult = Apollo.MutationResult<
  OnUserAvatarMutation
>;
export type OnUserAvatarMutationOptions = Apollo.BaseMutationOptions<
  OnUserAvatarMutation,
  OnUserAvatarMutationVariables
>;
export const UpdateUserAccountDocument = gql`
  mutation updateUserAccount(
    $id: ID!
    $firstname: String
    $lastname: String
    $email: String
    $tel: String
  ) {
    updateUsersPermissionsUser(
      id: $id
      data: {
        firstname: $firstname
        lastname: $lastname
        email: $email
        tel: $tel
      }
    ) {
      data {
        attributes {
          ...Account
        }
      }
    }
  }
  ${AccountFragmentDoc}
`;
export type UpdateUserAccountMutationFn = Apollo.MutationFunction<
  UpdateUserAccountMutation,
  UpdateUserAccountMutationVariables
>;

/**
 * __useUpdateUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountMutation, { data, loading, error }] = useUpdateUserAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      email: // value for 'email'
 *      tel: // value for 'tel'
 *   },
 * });
 */
export function useUpdateUserAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserAccountMutation,
    UpdateUserAccountMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateUserAccountMutation,
    UpdateUserAccountMutationVariables
  >(UpdateUserAccountDocument, baseOptions);
}
export type UpdateUserAccountMutationHookResult = ReturnType<
  typeof useUpdateUserAccountMutation
>;
export type UpdateUserAccountMutationResult = Apollo.MutationResult<
  UpdateUserAccountMutation
>;
export type UpdateUserAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserAccountMutation,
  UpdateUserAccountMutationVariables
>;
export const UpdateUserOngDocument = gql`
  mutation UpdateUserOng($id: ID!, $data: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $data) {
      data {
        id
        attributes {
          firstname
          ong
        }
      }
    }
  }
`;
export type UpdateUserOngMutationFn = Apollo.MutationFunction<
  UpdateUserOngMutation,
  UpdateUserOngMutationVariables
>;

/**
 * __useUpdateUserOngMutation__
 *
 * To run a mutation, you first call `useUpdateUserOngMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOngMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOngMutation, { data, loading, error }] = useUpdateUserOngMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserOngMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserOngMutation,
    UpdateUserOngMutationVariables
  >
) {
  return Apollo.useMutation<
    UpdateUserOngMutation,
    UpdateUserOngMutationVariables
  >(UpdateUserOngDocument, baseOptions);
}
export type UpdateUserOngMutationHookResult = ReturnType<
  typeof useUpdateUserOngMutation
>;
export type UpdateUserOngMutationResult = Apollo.MutationResult<
  UpdateUserOngMutation
>;
export type UpdateUserOngMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserOngMutation,
  UpdateUserOngMutationVariables
>;
export const QueryAcademiesDocument = gql`
  query QueryAcademies {
    academies {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;

/**
 * __useQueryAcademiesQuery__
 *
 * To run a query within a React component, call `useQueryAcademiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAcademiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAcademiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useQueryAcademiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QueryAcademiesQuery,
    QueryAcademiesQueryVariables
  >
) {
  return Apollo.useQuery<QueryAcademiesQuery, QueryAcademiesQueryVariables>(
    QueryAcademiesDocument,
    baseOptions
  );
}
export function useQueryAcademiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryAcademiesQuery,
    QueryAcademiesQueryVariables
  >
) {
  return Apollo.useLazyQuery<QueryAcademiesQuery, QueryAcademiesQueryVariables>(
    QueryAcademiesDocument,
    baseOptions
  );
}
export type QueryAcademiesQueryHookResult = ReturnType<
  typeof useQueryAcademiesQuery
>;
export type QueryAcademiesLazyQueryHookResult = ReturnType<
  typeof useQueryAcademiesLazyQuery
>;
export type QueryAcademiesQueryResult = Apollo.QueryResult<
  QueryAcademiesQuery,
  QueryAcademiesQueryVariables
>;
export const AllAvatarsDocument = gql`
  query AllAvatars {
    avatars(pagination: { limit: 200 }) {
      data {
        id
        attributes {
          name
          media {
            data {
              id
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useAllAvatarsQuery__
 *
 * To run a query within a React component, call `useAllAvatarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAvatarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAvatarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAvatarsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllAvatarsQuery,
    AllAvatarsQueryVariables
  >
) {
  return Apollo.useQuery<AllAvatarsQuery, AllAvatarsQueryVariables>(
    AllAvatarsDocument,
    baseOptions
  );
}
export function useAllAvatarsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllAvatarsQuery,
    AllAvatarsQueryVariables
  >
) {
  return Apollo.useLazyQuery<AllAvatarsQuery, AllAvatarsQueryVariables>(
    AllAvatarsDocument,
    baseOptions
  );
}
export type AllAvatarsQueryHookResult = ReturnType<typeof useAllAvatarsQuery>;
export type AllAvatarsLazyQueryHookResult = ReturnType<
  typeof useAllAvatarsLazyQuery
>;
export type AllAvatarsQueryResult = Apollo.QueryResult<
  AllAvatarsQuery,
  AllAvatarsQueryVariables
>;
export const GetNiveauAndFilliereDocument = gql`
  query getNiveauAndFilliere {
    niveaux {
      data {
        id
        attributes {
          name
        }
      }
    }
    fillieres {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;

/**
 * __useGetNiveauAndFilliereQuery__
 *
 * To run a query within a React component, call `useGetNiveauAndFilliereQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNiveauAndFilliereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNiveauAndFilliereQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNiveauAndFilliereQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNiveauAndFilliereQuery,
    GetNiveauAndFilliereQueryVariables
  >
) {
  return Apollo.useQuery<
    GetNiveauAndFilliereQuery,
    GetNiveauAndFilliereQueryVariables
  >(GetNiveauAndFilliereDocument, baseOptions);
}
export function useGetNiveauAndFilliereLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNiveauAndFilliereQuery,
    GetNiveauAndFilliereQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetNiveauAndFilliereQuery,
    GetNiveauAndFilliereQueryVariables
  >(GetNiveauAndFilliereDocument, baseOptions);
}
export type GetNiveauAndFilliereQueryHookResult = ReturnType<
  typeof useGetNiveauAndFilliereQuery
>;
export type GetNiveauAndFilliereLazyQueryHookResult = ReturnType<
  typeof useGetNiveauAndFilliereLazyQuery
>;
export type GetNiveauAndFilliereQueryResult = Apollo.QueryResult<
  GetNiveauAndFilliereQuery,
  GetNiveauAndFilliereQueryVariables
>;
export const GetCurrentClasseInfoDocument = gql`
  query GetCurrentClasseInfo {
    getCurrentClasseInfos {
      name
      filiere
      niveau
      lycee
      nbProfs
      nbEleves
      debut
      fin
      noteclasse {
        qteca
      }
      objectif {
        name
        ca
      }
    }
  }
`;

/**
 * __useGetCurrentClasseInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentClasseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentClasseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentClasseInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentClasseInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentClasseInfoQuery,
    GetCurrentClasseInfoQueryVariables
  >
) {
  return Apollo.useQuery<
    GetCurrentClasseInfoQuery,
    GetCurrentClasseInfoQueryVariables
  >(GetCurrentClasseInfoDocument, baseOptions);
}
export function useGetCurrentClasseInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentClasseInfoQuery,
    GetCurrentClasseInfoQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetCurrentClasseInfoQuery,
    GetCurrentClasseInfoQueryVariables
  >(GetCurrentClasseInfoDocument, baseOptions);
}
export type GetCurrentClasseInfoQueryHookResult = ReturnType<
  typeof useGetCurrentClasseInfoQuery
>;
export type GetCurrentClasseInfoLazyQueryHookResult = ReturnType<
  typeof useGetCurrentClasseInfoLazyQuery
>;
export type GetCurrentClasseInfoQueryResult = Apollo.QueryResult<
  GetCurrentClasseInfoQuery,
  GetCurrentClasseInfoQueryVariables
>;
export const GetClasseWithNoteAndStudentsOrdersDocument = gql`
  query getClasseWithNoteAndStudentsOrders($userId: ID!) {
    getClasseWithNoteAndEleves {
      ong
      percentDedicatedToOng
      users {
        commandes {
          status
          customerContributedToTheOng
        }
        note {
          qteca
        }
      }
      noteclasse {
        qteca
      }
    }
    getMyOrdersInClasse(userId: $userId) {
      commandes {
        attributes {
          status
          customerContributedToTheOng
        }
      }
    }
    getMyNoteInClasse(userId: $userId) {
      note {
        attributes {
          qteca
        }
      }
    }
    usersPermissionsUser(id: $userId) {
      data {
        id
        attributes {
          ong
        }
      }
    }
  }
`;

/**
 * __useGetClasseWithNoteAndStudentsOrdersQuery__
 *
 * To run a query within a React component, call `useGetClasseWithNoteAndStudentsOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClasseWithNoteAndStudentsOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClasseWithNoteAndStudentsOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClasseWithNoteAndStudentsOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClasseWithNoteAndStudentsOrdersQuery,
    GetClasseWithNoteAndStudentsOrdersQueryVariables
  >
) {
  return Apollo.useQuery<
    GetClasseWithNoteAndStudentsOrdersQuery,
    GetClasseWithNoteAndStudentsOrdersQueryVariables
  >(GetClasseWithNoteAndStudentsOrdersDocument, baseOptions);
}
export function useGetClasseWithNoteAndStudentsOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClasseWithNoteAndStudentsOrdersQuery,
    GetClasseWithNoteAndStudentsOrdersQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetClasseWithNoteAndStudentsOrdersQuery,
    GetClasseWithNoteAndStudentsOrdersQueryVariables
  >(GetClasseWithNoteAndStudentsOrdersDocument, baseOptions);
}
export type GetClasseWithNoteAndStudentsOrdersQueryHookResult = ReturnType<
  typeof useGetClasseWithNoteAndStudentsOrdersQuery
>;
export type GetClasseWithNoteAndStudentsOrdersLazyQueryHookResult = ReturnType<
  typeof useGetClasseWithNoteAndStudentsOrdersLazyQuery
>;
export type GetClasseWithNoteAndStudentsOrdersQueryResult = Apollo.QueryResult<
  GetClasseWithNoteAndStudentsOrdersQuery,
  GetClasseWithNoteAndStudentsOrdersQueryVariables
>;
export const GetOrdersByEleveInClasseDocument = gql`
  query getOrdersByEleveInClasse {
    findElevesWithOrders {
      users {
        firstname
        lastname
        commandes {
          numerocommande
          totalttc
          methodepaiement
          payment
          fraislivraison
          status
          id
          customerContributedToTheOng
          controlled
          prixTotal
          client {
            prenom
            nom
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrdersByEleveInClasseQuery__
 *
 * To run a query within a React component, call `useGetOrdersByEleveInClasseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersByEleveInClasseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersByEleveInClasseQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrdersByEleveInClasseQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrdersByEleveInClasseQuery,
    GetOrdersByEleveInClasseQueryVariables
  >
) {
  return Apollo.useQuery<
    GetOrdersByEleveInClasseQuery,
    GetOrdersByEleveInClasseQueryVariables
  >(GetOrdersByEleveInClasseDocument, baseOptions);
}
export function useGetOrdersByEleveInClasseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrdersByEleveInClasseQuery,
    GetOrdersByEleveInClasseQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetOrdersByEleveInClasseQuery,
    GetOrdersByEleveInClasseQueryVariables
  >(GetOrdersByEleveInClasseDocument, baseOptions);
}
export type GetOrdersByEleveInClasseQueryHookResult = ReturnType<
  typeof useGetOrdersByEleveInClasseQuery
>;
export type GetOrdersByEleveInClasseLazyQueryHookResult = ReturnType<
  typeof useGetOrdersByEleveInClasseLazyQuery
>;
export type GetOrdersByEleveInClasseQueryResult = Apollo.QueryResult<
  GetOrdersByEleveInClasseQuery,
  GetOrdersByEleveInClasseQueryVariables
>;
export const GetElevesWithQuizToNotesAndQuizDocument = gql`
  query getElevesWithQuizToNotesAndQuiz($id: ID!, $quizId: ID!) {
    classe(id: $id) {
      data {
        attributes {
          users(sort: "lastname:asc") {
            data {
              attributes {
                username
                firstname
                lastname
                quiztonotes {
                  data {
                    attributes {
                      quiz {
                        data {
                          id
                        }
                      }
                      note
                      responses
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    quiz(id: $quizId) {
      data {
        id
        attributes {
          name
          desc
          competences {
            data {
              attributes {
                name
              }
            }
          }
          questions {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetElevesWithQuizToNotesAndQuizQuery__
 *
 * To run a query within a React component, call `useGetElevesWithQuizToNotesAndQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetElevesWithQuizToNotesAndQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetElevesWithQuizToNotesAndQuizQuery({
 *   variables: {
 *      id: // value for 'id'
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useGetElevesWithQuizToNotesAndQuizQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetElevesWithQuizToNotesAndQuizQuery,
    GetElevesWithQuizToNotesAndQuizQueryVariables
  >
) {
  return Apollo.useQuery<
    GetElevesWithQuizToNotesAndQuizQuery,
    GetElevesWithQuizToNotesAndQuizQueryVariables
  >(GetElevesWithQuizToNotesAndQuizDocument, baseOptions);
}
export function useGetElevesWithQuizToNotesAndQuizLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetElevesWithQuizToNotesAndQuizQuery,
    GetElevesWithQuizToNotesAndQuizQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetElevesWithQuizToNotesAndQuizQuery,
    GetElevesWithQuizToNotesAndQuizQueryVariables
  >(GetElevesWithQuizToNotesAndQuizDocument, baseOptions);
}
export type GetElevesWithQuizToNotesAndQuizQueryHookResult = ReturnType<
  typeof useGetElevesWithQuizToNotesAndQuizQuery
>;
export type GetElevesWithQuizToNotesAndQuizLazyQueryHookResult = ReturnType<
  typeof useGetElevesWithQuizToNotesAndQuizLazyQuery
>;
export type GetElevesWithQuizToNotesAndQuizQueryResult = Apollo.QueryResult<
  GetElevesWithQuizToNotesAndQuizQuery,
  GetElevesWithQuizToNotesAndQuizQueryVariables
>;
export const CommandeDetailsDocument = gql`
  query CommandeDetails($id: ID!) {
    commande(id: $id) {
      data {
        id
        attributes {
          ...DetailsCommande
        }
      }
    }
  }
  ${DetailsCommandeFragmentDoc}
`;

/**
 * __useCommandeDetailsQuery__
 *
 * To run a query within a React component, call `useCommandeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommandeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommandeDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommandeDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CommandeDetailsQuery,
    CommandeDetailsQueryVariables
  >
) {
  return Apollo.useQuery<CommandeDetailsQuery, CommandeDetailsQueryVariables>(
    CommandeDetailsDocument,
    baseOptions
  );
}
export function useCommandeDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CommandeDetailsQuery,
    CommandeDetailsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    CommandeDetailsQuery,
    CommandeDetailsQueryVariables
  >(CommandeDetailsDocument, baseOptions);
}
export type CommandeDetailsQueryHookResult = ReturnType<
  typeof useCommandeDetailsQuery
>;
export type CommandeDetailsLazyQueryHookResult = ReturnType<
  typeof useCommandeDetailsLazyQuery
>;
export type CommandeDetailsQueryResult = Apollo.QueryResult<
  CommandeDetailsQuery,
  CommandeDetailsQueryVariables
>;
export const GetElevesCommandesDocument = gql`
  query getElevesCommandes($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        id
        attributes {
          classes {
            data {
              id
              attributes {
                users(sort: "lastname:asc") {
                  data {
                    id
                    attributes {
                      firstname
                      lastname
                      commandes {
                        data {
                          id
                          attributes {
                            totalttc
                            createdAt
                            numerocommande
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetElevesCommandesQuery__
 *
 * To run a query within a React component, call `useGetElevesCommandesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetElevesCommandesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetElevesCommandesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetElevesCommandesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetElevesCommandesQuery,
    GetElevesCommandesQueryVariables
  >
) {
  return Apollo.useQuery<
    GetElevesCommandesQuery,
    GetElevesCommandesQueryVariables
  >(GetElevesCommandesDocument, baseOptions);
}
export function useGetElevesCommandesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetElevesCommandesQuery,
    GetElevesCommandesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetElevesCommandesQuery,
    GetElevesCommandesQueryVariables
  >(GetElevesCommandesDocument, baseOptions);
}
export type GetElevesCommandesQueryHookResult = ReturnType<
  typeof useGetElevesCommandesQuery
>;
export type GetElevesCommandesLazyQueryHookResult = ReturnType<
  typeof useGetElevesCommandesLazyQuery
>;
export type GetElevesCommandesQueryResult = Apollo.QueryResult<
  GetElevesCommandesQuery,
  GetElevesCommandesQueryVariables
>;
export const GetLastEleveCommandeDocument = gql`
  query getLastEleveCommande($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        attributes {
          commandes(sort: "createdAt:desc", pagination: { limit: 1 }) {
            data {
              attributes {
                ...DetailsCommande
                user {
                  data {
                    attributes {
                      lastname
                      firstname
                      email
                      classes {
                        data {
                          attributes {
                            ...ClasseInfo
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${DetailsCommandeFragmentDoc}
  ${ClasseInfoFragmentDoc}
`;

/**
 * __useGetLastEleveCommandeQuery__
 *
 * To run a query within a React component, call `useGetLastEleveCommandeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastEleveCommandeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastEleveCommandeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLastEleveCommandeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLastEleveCommandeQuery,
    GetLastEleveCommandeQueryVariables
  >
) {
  return Apollo.useQuery<
    GetLastEleveCommandeQuery,
    GetLastEleveCommandeQueryVariables
  >(GetLastEleveCommandeDocument, baseOptions);
}
export function useGetLastEleveCommandeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLastEleveCommandeQuery,
    GetLastEleveCommandeQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetLastEleveCommandeQuery,
    GetLastEleveCommandeQueryVariables
  >(GetLastEleveCommandeDocument, baseOptions);
}
export type GetLastEleveCommandeQueryHookResult = ReturnType<
  typeof useGetLastEleveCommandeQuery
>;
export type GetLastEleveCommandeLazyQueryHookResult = ReturnType<
  typeof useGetLastEleveCommandeLazyQuery
>;
export type GetLastEleveCommandeQueryResult = Apollo.QueryResult<
  GetLastEleveCommandeQuery,
  GetLastEleveCommandeQueryVariables
>;
export const QueryGetMyOrderInClasseDocument = gql`
  query QueryGetMyOrderInClasse($id: ID!) {
    getMyOrdersInClasse(userId: $id) {
      firstname
      lastname
      commandes {
        id
        attributes {
          ...DetailsCommande
        }
      }
    }
  }
  ${DetailsCommandeFragmentDoc}
`;

/**
 * __useQueryGetMyOrderInClasseQuery__
 *
 * To run a query within a React component, call `useQueryGetMyOrderInClasseQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryGetMyOrderInClasseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryGetMyOrderInClasseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQueryGetMyOrderInClasseQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryGetMyOrderInClasseQuery,
    QueryGetMyOrderInClasseQueryVariables
  >
) {
  return Apollo.useQuery<
    QueryGetMyOrderInClasseQuery,
    QueryGetMyOrderInClasseQueryVariables
  >(QueryGetMyOrderInClasseDocument, baseOptions);
}
export function useQueryGetMyOrderInClasseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryGetMyOrderInClasseQuery,
    QueryGetMyOrderInClasseQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    QueryGetMyOrderInClasseQuery,
    QueryGetMyOrderInClasseQueryVariables
  >(QueryGetMyOrderInClasseDocument, baseOptions);
}
export type QueryGetMyOrderInClasseQueryHookResult = ReturnType<
  typeof useQueryGetMyOrderInClasseQuery
>;
export type QueryGetMyOrderInClasseLazyQueryHookResult = ReturnType<
  typeof useQueryGetMyOrderInClasseLazyQuery
>;
export type QueryGetMyOrderInClasseQueryResult = Apollo.QueryResult<
  QueryGetMyOrderInClasseQuery,
  QueryGetMyOrderInClasseQueryVariables
>;
export const GetProfDashboardDocument = gql`
  query GetProfDashboard {
    getProfDashboard {
      classe {
        id
        name
        operationid
        fin
        debut
        filiere {
          id
          name
        }
        niveau {
          id
          name
        }
        lycee {
          id
          name
        }
        users {
          id
          username
          firstname
          lastname
          email
          ville
          mdp
          shop
          avatar {
            name
            id
            media {
              url
            }
          }
          role {
            name
            id
          }
          note {
            qteca
            qtevente
            qtepro
            qtequiz
            qterebond
            moyennegenerale
            quiz
            pro
            cavente
            nbvente
            venterebond
          }
          quiztonotes {
            note
            createdAt
            quiz {
              name
              id
            }
          }
          commandes {
            status
            methodepaiement
            paymentreminder
            createdAt
          }
        }
      }
    }
    getUnpayedCoByEleve {
      id
      unpayedCA
    }
  }
`;

/**
 * __useGetProfDashboardQuery__
 *
 * To run a query within a React component, call `useGetProfDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfDashboardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProfDashboardQuery,
    GetProfDashboardQueryVariables
  >
) {
  return Apollo.useQuery<GetProfDashboardQuery, GetProfDashboardQueryVariables>(
    GetProfDashboardDocument,
    baseOptions
  );
}
export function useGetProfDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfDashboardQuery,
    GetProfDashboardQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetProfDashboardQuery,
    GetProfDashboardQueryVariables
  >(GetProfDashboardDocument, baseOptions);
}
export type GetProfDashboardQueryHookResult = ReturnType<
  typeof useGetProfDashboardQuery
>;
export type GetProfDashboardLazyQueryHookResult = ReturnType<
  typeof useGetProfDashboardLazyQuery
>;
export type GetProfDashboardQueryResult = Apollo.QueryResult<
  GetProfDashboardQuery,
  GetProfDashboardQueryVariables
>;
export const HomeDefisDocument = gql`
  query HomeDefis {
    getHomeDefis {
      defisList {
        id
        name
        debut
        fin
      }
      lastDefi {
        id
        name
        recompenses {
          category
          lots
          recompenses_winners {
            id
            username
            avatar {
              media {
                url
              }
            }
            classes {
              lycee {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useHomeDefisQuery__
 *
 * To run a query within a React component, call `useHomeDefisQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeDefisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeDefisQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeDefisQuery(
  baseOptions?: Apollo.QueryHookOptions<HomeDefisQuery, HomeDefisQueryVariables>
) {
  return Apollo.useQuery<HomeDefisQuery, HomeDefisQueryVariables>(
    HomeDefisDocument,
    baseOptions
  );
}
export function useHomeDefisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeDefisQuery,
    HomeDefisQueryVariables
  >
) {
  return Apollo.useLazyQuery<HomeDefisQuery, HomeDefisQueryVariables>(
    HomeDefisDocument,
    baseOptions
  );
}
export type HomeDefisQueryHookResult = ReturnType<typeof useHomeDefisQuery>;
export type HomeDefisLazyQueryHookResult = ReturnType<
  typeof useHomeDefisLazyQuery
>;
export type HomeDefisQueryResult = Apollo.QueryResult<
  HomeDefisQuery,
  HomeDefisQueryVariables
>;
export const SingleDefiDocument = gql`
  query SingleDefi($id: ID!) {
    getDefiById(id: $id) {
      name
      debut
      fin
      reglement {
        ... on ComponentDefiReglement {
          title
          text
        }
      }
      ressources {
        ... on ComponentDefiDefiLiens {
          name
          url
        }
        ... on ComponentDefiDefiMedia {
          name
          media {
            data {
              attributes {
                alternativeText
                url
              }
            }
          }
        }
      }
      recompenses {
        category
        lots
        recompenses_winners {
          data {
            id
            attributes {
              username
              classes {
                data {
                  attributes {
                    lycee {
                      data {
                        attributes {
                          name
                        }
                      }
                    }
                  }
                }
              }
              avatar {
                data {
                  attributes {
                    media {
                      data {
                        attributes {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSingleDefiQuery__
 *
 * To run a query within a React component, call `useSingleDefiQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDefiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDefiQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleDefiQuery(
  baseOptions: Apollo.QueryHookOptions<
    SingleDefiQuery,
    SingleDefiQueryVariables
  >
) {
  return Apollo.useQuery<SingleDefiQuery, SingleDefiQueryVariables>(
    SingleDefiDocument,
    baseOptions
  );
}
export function useSingleDefiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SingleDefiQuery,
    SingleDefiQueryVariables
  >
) {
  return Apollo.useLazyQuery<SingleDefiQuery, SingleDefiQueryVariables>(
    SingleDefiDocument,
    baseOptions
  );
}
export type SingleDefiQueryHookResult = ReturnType<typeof useSingleDefiQuery>;
export type SingleDefiLazyQueryHookResult = ReturnType<
  typeof useSingleDefiLazyQuery
>;
export type SingleDefiQueryResult = Apollo.QueryResult<
  SingleDefiQuery,
  SingleDefiQueryVariables
>;
export const GetFaqsDocument = gql`
  query GetFaqs {
    faqs {
      data {
        id
        attributes {
          name
          desc
          medias {
            data {
              attributes {
                name
                url
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFaqsQuery__
 *
 * To run a query within a React component, call `useGetFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFaqsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFaqsQuery, GetFaqsQueryVariables>
) {
  return Apollo.useQuery<GetFaqsQuery, GetFaqsQueryVariables>(
    GetFaqsDocument,
    baseOptions
  );
}
export function useGetFaqsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFaqsQuery, GetFaqsQueryVariables>
) {
  return Apollo.useLazyQuery<GetFaqsQuery, GetFaqsQueryVariables>(
    GetFaqsDocument,
    baseOptions
  );
}
export type GetFaqsQueryHookResult = ReturnType<typeof useGetFaqsQuery>;
export type GetFaqsLazyQueryHookResult = ReturnType<typeof useGetFaqsLazyQuery>;
export type GetFaqsQueryResult = Apollo.QueryResult<
  GetFaqsQuery,
  GetFaqsQueryVariables
>;
export const GetInstallAppTutoDocument = gql`
  query getInstallAppTuto {
    faqs(filters: { tag: { in: ["iphone", "android"] } }) {
      data {
        id
        attributes {
          name
          desc
          medias {
            data {
              attributes {
                url
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetInstallAppTutoQuery__
 *
 * To run a query within a React component, call `useGetInstallAppTutoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallAppTutoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallAppTutoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstallAppTutoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInstallAppTutoQuery,
    GetInstallAppTutoQueryVariables
  >
) {
  return Apollo.useQuery<
    GetInstallAppTutoQuery,
    GetInstallAppTutoQueryVariables
  >(GetInstallAppTutoDocument, baseOptions);
}
export function useGetInstallAppTutoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstallAppTutoQuery,
    GetInstallAppTutoQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetInstallAppTutoQuery,
    GetInstallAppTutoQueryVariables
  >(GetInstallAppTutoDocument, baseOptions);
}
export type GetInstallAppTutoQueryHookResult = ReturnType<
  typeof useGetInstallAppTutoQuery
>;
export type GetInstallAppTutoLazyQueryHookResult = ReturnType<
  typeof useGetInstallAppTutoLazyQuery
>;
export type GetInstallAppTutoQueryResult = Apollo.QueryResult<
  GetInstallAppTutoQuery,
  GetInstallAppTutoQueryVariables
>;
export const AllFormationsAndTypesDocument = gql`
  query AllFormationsAndTypes {
    formations(sort: "order:asc") {
      data {
        id
        attributes {
          name
          subtitle
          info
          desc
          reservedToProf
          formation_type {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
    findFormationTypeWithRelatedFormations {
      id
      name
      formations {
        name
      }
    }
  }
`;

/**
 * __useAllFormationsAndTypesQuery__
 *
 * To run a query within a React component, call `useAllFormationsAndTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFormationsAndTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFormationsAndTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFormationsAndTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllFormationsAndTypesQuery,
    AllFormationsAndTypesQueryVariables
  >
) {
  return Apollo.useQuery<
    AllFormationsAndTypesQuery,
    AllFormationsAndTypesQueryVariables
  >(AllFormationsAndTypesDocument, baseOptions);
}
export function useAllFormationsAndTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllFormationsAndTypesQuery,
    AllFormationsAndTypesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    AllFormationsAndTypesQuery,
    AllFormationsAndTypesQueryVariables
  >(AllFormationsAndTypesDocument, baseOptions);
}
export type AllFormationsAndTypesQueryHookResult = ReturnType<
  typeof useAllFormationsAndTypesQuery
>;
export type AllFormationsAndTypesLazyQueryHookResult = ReturnType<
  typeof useAllFormationsAndTypesLazyQuery
>;
export type AllFormationsAndTypesQueryResult = Apollo.QueryResult<
  AllFormationsAndTypesQuery,
  AllFormationsAndTypesQueryVariables
>;
export const FindFormationByTypeIdDocument = gql`
  query findFormationByTypeId($id: ID!) {
    findFormationByTypeId(id: $id) {
      name
      desc
      subtitle
      info
      order
      ressources {
        titre
        lien
        media {
          url
        }
        type {
          nom
        }
      }
    }
  }
`;

/**
 * __useFindFormationByTypeIdQuery__
 *
 * To run a query within a React component, call `useFindFormationByTypeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFormationByTypeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFormationByTypeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindFormationByTypeIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindFormationByTypeIdQuery,
    FindFormationByTypeIdQueryVariables
  >
) {
  return Apollo.useQuery<
    FindFormationByTypeIdQuery,
    FindFormationByTypeIdQueryVariables
  >(FindFormationByTypeIdDocument, baseOptions);
}
export function useFindFormationByTypeIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindFormationByTypeIdQuery,
    FindFormationByTypeIdQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FindFormationByTypeIdQuery,
    FindFormationByTypeIdQueryVariables
  >(FindFormationByTypeIdDocument, baseOptions);
}
export type FindFormationByTypeIdQueryHookResult = ReturnType<
  typeof useFindFormationByTypeIdQuery
>;
export type FindFormationByTypeIdLazyQueryHookResult = ReturnType<
  typeof useFindFormationByTypeIdLazyQuery
>;
export type FindFormationByTypeIdQueryResult = Apollo.QueryResult<
  FindFormationByTypeIdQuery,
  FindFormationByTypeIdQueryVariables
>;
export const GetLeadersNatDocument = gql`
  query getLeadersNat($tableau: String) {
    getClassement(tableau: $tableau) {
      ...Rank
    }
  }
  ${RankFragmentDoc}
`;

/**
 * __useGetLeadersNatQuery__
 *
 * To run a query within a React component, call `useGetLeadersNatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadersNatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadersNatQuery({
 *   variables: {
 *      tableau: // value for 'tableau'
 *   },
 * });
 */
export function useGetLeadersNatQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLeadersNatQuery,
    GetLeadersNatQueryVariables
  >
) {
  return Apollo.useQuery<GetLeadersNatQuery, GetLeadersNatQueryVariables>(
    GetLeadersNatDocument,
    baseOptions
  );
}
export function useGetLeadersNatLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLeadersNatQuery,
    GetLeadersNatQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetLeadersNatQuery, GetLeadersNatQueryVariables>(
    GetLeadersNatDocument,
    baseOptions
  );
}
export type GetLeadersNatQueryHookResult = ReturnType<
  typeof useGetLeadersNatQuery
>;
export type GetLeadersNatLazyQueryHookResult = ReturnType<
  typeof useGetLeadersNatLazyQuery
>;
export type GetLeadersNatQueryResult = Apollo.QueryResult<
  GetLeadersNatQuery,
  GetLeadersNatQueryVariables
>;
export const GetPositionsDocument = gql`
  query getPositions {
    myPositions: getMyPositions {
      niveauRank
      classeRank
      academieRank
      nationalRank
    }
  }
`;

/**
 * __useGetPositionsQuery__
 *
 * To run a query within a React component, call `useGetPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPositionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPositionsQuery,
    GetPositionsQueryVariables
  >
) {
  return Apollo.useQuery<GetPositionsQuery, GetPositionsQueryVariables>(
    GetPositionsDocument,
    baseOptions
  );
}
export function useGetPositionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPositionsQuery,
    GetPositionsQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetPositionsQuery, GetPositionsQueryVariables>(
    GetPositionsDocument,
    baseOptions
  );
}
export type GetPositionsQueryHookResult = ReturnType<
  typeof useGetPositionsQuery
>;
export type GetPositionsLazyQueryHookResult = ReturnType<
  typeof useGetPositionsLazyQuery
>;
export type GetPositionsQueryResult = Apollo.QueryResult<
  GetPositionsQuery,
  GetPositionsQueryVariables
>;
export const GetMyNoteInClasseDocument = gql`
  query GetMyNoteInClasse($id: ID!) {
    getMyNoteInClasse(userId: $id) {
      note {
        id
        attributes {
          ...Quantite
          ...ChallengeNote
          updatedAt
        }
      }
      quizToNotes {
        id
        attributes {
          ...NoteDesQuiz
        }
      }
    }
  }
  ${QuantiteFragmentDoc}
  ${ChallengeNoteFragmentDoc}
  ${NoteDesQuizFragmentDoc}
`;

/**
 * __useGetMyNoteInClasseQuery__
 *
 * To run a query within a React component, call `useGetMyNoteInClasseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNoteInClasseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNoteInClasseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyNoteInClasseQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMyNoteInClasseQuery,
    GetMyNoteInClasseQueryVariables
  >
) {
  return Apollo.useQuery<
    GetMyNoteInClasseQuery,
    GetMyNoteInClasseQueryVariables
  >(GetMyNoteInClasseDocument, baseOptions);
}
export function useGetMyNoteInClasseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyNoteInClasseQuery,
    GetMyNoteInClasseQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetMyNoteInClasseQuery,
    GetMyNoteInClasseQueryVariables
  >(GetMyNoteInClasseDocument, baseOptions);
}
export type GetMyNoteInClasseQueryHookResult = ReturnType<
  typeof useGetMyNoteInClasseQuery
>;
export type GetMyNoteInClasseLazyQueryHookResult = ReturnType<
  typeof useGetMyNoteInClasseLazyQuery
>;
export type GetMyNoteInClasseQueryResult = Apollo.QueryResult<
  GetMyNoteInClasseQuery,
  GetMyNoteInClasseQueryVariables
>;
export const QuerySoftSkillsDocument = gql`
  query QuerySoftSkills {
    getUserSoftSkills {
      note {
        qteca
        qtepro
        qtepro
        qtequiz
        qterebond
        qtevente
      }
      unpayedOrders
      commandes
      classe {
        commandes
        unpayedOrders
        users {
          role {
            id
            name
          }
          commandes {
            status
          }
        }
        noteclasse {
          cavente
          qteca
          qtepro
          qterebond
          venterebond
          moyennegenerale
          pro
          quiz
          qtequiz
          nbvente
          qtevente
        }
      }
    }
    getClassePosition {
      rank
      totalClasses
    }
    getUnpayedCo {
      classe
      eleve
    }
  }
`;

/**
 * __useQuerySoftSkillsQuery__
 *
 * To run a query within a React component, call `useQuerySoftSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySoftSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySoftSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuerySoftSkillsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QuerySoftSkillsQuery,
    QuerySoftSkillsQueryVariables
  >
) {
  return Apollo.useQuery<QuerySoftSkillsQuery, QuerySoftSkillsQueryVariables>(
    QuerySoftSkillsDocument,
    baseOptions
  );
}
export function useQuerySoftSkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QuerySoftSkillsQuery,
    QuerySoftSkillsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    QuerySoftSkillsQuery,
    QuerySoftSkillsQueryVariables
  >(QuerySoftSkillsDocument, baseOptions);
}
export type QuerySoftSkillsQueryHookResult = ReturnType<
  typeof useQuerySoftSkillsQuery
>;
export type QuerySoftSkillsLazyQueryHookResult = ReturnType<
  typeof useQuerySoftSkillsLazyQuery
>;
export type QuerySoftSkillsQueryResult = Apollo.QueryResult<
  QuerySoftSkillsQuery,
  QuerySoftSkillsQueryVariables
>;
export const QueryNotificationsDocument = gql`
  query QueryNotifications {
    notifications(sort: "createdAt:desc") {
      data {
        id
        attributes {
          title
          description
          hidden
          link {
            name
            url
            button
          }
        }
      }
    }
  }
`;

/**
 * __useQueryNotificationsQuery__
 *
 * To run a query within a React component, call `useQueryNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useQueryNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QueryNotificationsQuery,
    QueryNotificationsQueryVariables
  >
) {
  return Apollo.useQuery<
    QueryNotificationsQuery,
    QueryNotificationsQueryVariables
  >(QueryNotificationsDocument, baseOptions);
}
export function useQueryNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryNotificationsQuery,
    QueryNotificationsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    QueryNotificationsQuery,
    QueryNotificationsQueryVariables
  >(QueryNotificationsDocument, baseOptions);
}
export type QueryNotificationsQueryHookResult = ReturnType<
  typeof useQueryNotificationsQuery
>;
export type QueryNotificationsLazyQueryHookResult = ReturnType<
  typeof useQueryNotificationsLazyQuery
>;
export type QueryNotificationsQueryResult = Apollo.QueryResult<
  QueryNotificationsQuery,
  QueryNotificationsQueryVariables
>;
export const CurrentPageDocument = gql`
  query currentPage($type: String) {
    pages(filters: { action: { eq: $type } }) {
      data {
        id
        attributes {
          name
          desc
          action
          annonce
        }
      }
    }
  }
`;

/**
 * __useCurrentPageQuery__
 *
 * To run a query within a React component, call `useCurrentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPageQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCurrentPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurrentPageQuery,
    CurrentPageQueryVariables
  >
) {
  return Apollo.useQuery<CurrentPageQuery, CurrentPageQueryVariables>(
    CurrentPageDocument,
    baseOptions
  );
}
export function useCurrentPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentPageQuery,
    CurrentPageQueryVariables
  >
) {
  return Apollo.useLazyQuery<CurrentPageQuery, CurrentPageQueryVariables>(
    CurrentPageDocument,
    baseOptions
  );
}
export type CurrentPageQueryHookResult = ReturnType<typeof useCurrentPageQuery>;
export type CurrentPageLazyQueryHookResult = ReturnType<
  typeof useCurrentPageLazyQuery
>;
export type CurrentPageQueryResult = Apollo.QueryResult<
  CurrentPageQuery,
  CurrentPageQueryVariables
>;
export const AllPedagogiesAndTypesDocument = gql`
  query AllPedagogiesAndTypes {
    pedagogies(sort: "order:asc") {
      data {
        id
        attributes {
          name
          subtitle
          info
          desc
          order
          revervedToProf
          pedagogie_type {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
    findPedagogieTypeWithRelatedPedagogies {
      id
      name
      pedagogies {
        name
      }
    }
  }
`;

/**
 * __useAllPedagogiesAndTypesQuery__
 *
 * To run a query within a React component, call `useAllPedagogiesAndTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPedagogiesAndTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPedagogiesAndTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPedagogiesAndTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllPedagogiesAndTypesQuery,
    AllPedagogiesAndTypesQueryVariables
  >
) {
  return Apollo.useQuery<
    AllPedagogiesAndTypesQuery,
    AllPedagogiesAndTypesQueryVariables
  >(AllPedagogiesAndTypesDocument, baseOptions);
}
export function useAllPedagogiesAndTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllPedagogiesAndTypesQuery,
    AllPedagogiesAndTypesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    AllPedagogiesAndTypesQuery,
    AllPedagogiesAndTypesQueryVariables
  >(AllPedagogiesAndTypesDocument, baseOptions);
}
export type AllPedagogiesAndTypesQueryHookResult = ReturnType<
  typeof useAllPedagogiesAndTypesQuery
>;
export type AllPedagogiesAndTypesLazyQueryHookResult = ReturnType<
  typeof useAllPedagogiesAndTypesLazyQuery
>;
export type AllPedagogiesAndTypesQueryResult = Apollo.QueryResult<
  AllPedagogiesAndTypesQuery,
  AllPedagogiesAndTypesQueryVariables
>;
export const FindPedagogieByTypeIdDocument = gql`
  query findPedagogieByTypeId($id: ID!) {
    findPedagogieByTypeId(id: $id) {
      name
      desc
      subtitle
      info
      order
      ressources {
        titre
        lien
        media {
          url
        }
        type {
          nom
        }
      }
    }
  }
`;

/**
 * __useFindPedagogieByTypeIdQuery__
 *
 * To run a query within a React component, call `useFindPedagogieByTypeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPedagogieByTypeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPedagogieByTypeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindPedagogieByTypeIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindPedagogieByTypeIdQuery,
    FindPedagogieByTypeIdQueryVariables
  >
) {
  return Apollo.useQuery<
    FindPedagogieByTypeIdQuery,
    FindPedagogieByTypeIdQueryVariables
  >(FindPedagogieByTypeIdDocument, baseOptions);
}
export function useFindPedagogieByTypeIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindPedagogieByTypeIdQuery,
    FindPedagogieByTypeIdQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FindPedagogieByTypeIdQuery,
    FindPedagogieByTypeIdQueryVariables
  >(FindPedagogieByTypeIdDocument, baseOptions);
}
export type FindPedagogieByTypeIdQueryHookResult = ReturnType<
  typeof useFindPedagogieByTypeIdQuery
>;
export type FindPedagogieByTypeIdLazyQueryHookResult = ReturnType<
  typeof useFindPedagogieByTypeIdLazyQuery
>;
export type FindPedagogieByTypeIdQueryResult = Apollo.QueryResult<
  FindPedagogieByTypeIdQuery,
  FindPedagogieByTypeIdQueryVariables
>;
export const GetCategoriesWithNameDocument = gql`
  query GetCategoriesWithName {
    categorieproduits {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;

/**
 * __useGetCategoriesWithNameQuery__
 *
 * To run a query within a React component, call `useGetCategoriesWithNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesWithNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesWithNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesWithNameQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCategoriesWithNameQuery,
    GetCategoriesWithNameQueryVariables
  >
) {
  return Apollo.useQuery<
    GetCategoriesWithNameQuery,
    GetCategoriesWithNameQueryVariables
  >(GetCategoriesWithNameDocument, baseOptions);
}
export function useGetCategoriesWithNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCategoriesWithNameQuery,
    GetCategoriesWithNameQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetCategoriesWithNameQuery,
    GetCategoriesWithNameQueryVariables
  >(GetCategoriesWithNameDocument, baseOptions);
}
export type GetCategoriesWithNameQueryHookResult = ReturnType<
  typeof useGetCategoriesWithNameQuery
>;
export type GetCategoriesWithNameLazyQueryHookResult = ReturnType<
  typeof useGetCategoriesWithNameLazyQuery
>;
export type GetCategoriesWithNameQueryResult = Apollo.QueryResult<
  GetCategoriesWithNameQuery,
  GetCategoriesWithNameQueryVariables
>;
export const GetSingleProductDocument = gql`
  query GetSingleProduct($id: ID!) {
    produit(id: $id) {
      data {
        id
        attributes {
          ...MainProducts
          ingredients {
            name
            id
            percent
          }
          allergens {
            id
            name
          }
          shoppingMobile {
            id
            description
            mobile
          }
        }
      }
    }
  }
  ${MainProductsFragmentDoc}
`;

/**
 * __useGetSingleProductQuery__
 *
 * To run a query within a React component, call `useGetSingleProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleProductQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSingleProductQuery,
    GetSingleProductQueryVariables
  >
) {
  return Apollo.useQuery<GetSingleProductQuery, GetSingleProductQueryVariables>(
    GetSingleProductDocument,
    baseOptions
  );
}
export function useGetSingleProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSingleProductQuery,
    GetSingleProductQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetSingleProductQuery,
    GetSingleProductQueryVariables
  >(GetSingleProductDocument, baseOptions);
}
export type GetSingleProductQueryHookResult = ReturnType<
  typeof useGetSingleProductQuery
>;
export type GetSingleProductLazyQueryHookResult = ReturnType<
  typeof useGetSingleProductLazyQuery
>;
export type GetSingleProductQueryResult = Apollo.QueryResult<
  GetSingleProductQuery,
  GetSingleProductQueryVariables
>;
export const GetProductsRebondsDocument = gql`
  query getProductsRebonds($limit: Int) {
    produits(
      pagination: { limit: $limit }
      filters: { venterebond: { eq: true } }
    ) {
      data {
        id
        attributes {
          ...MainProducts
        }
      }
    }
  }
  ${MainProductsFragmentDoc}
`;

/**
 * __useGetProductsRebondsQuery__
 *
 * To run a query within a React component, call `useGetProductsRebondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsRebondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsRebondsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProductsRebondsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProductsRebondsQuery,
    GetProductsRebondsQueryVariables
  >
) {
  return Apollo.useQuery<
    GetProductsRebondsQuery,
    GetProductsRebondsQueryVariables
  >(GetProductsRebondsDocument, baseOptions);
}
export function useGetProductsRebondsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductsRebondsQuery,
    GetProductsRebondsQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetProductsRebondsQuery,
    GetProductsRebondsQueryVariables
  >(GetProductsRebondsDocument, baseOptions);
}
export type GetProductsRebondsQueryHookResult = ReturnType<
  typeof useGetProductsRebondsQuery
>;
export type GetProductsRebondsLazyQueryHookResult = ReturnType<
  typeof useGetProductsRebondsLazyQuery
>;
export type GetProductsRebondsQueryResult = Apollo.QueryResult<
  GetProductsRebondsQuery,
  GetProductsRebondsQueryVariables
>;
export const GetProductsDocument = gql`
  query getProducts {
    produits(sort: "ref:ASC") {
      data {
        id
        attributes {
          ...MainProducts
        }
      }
    }
  }
  ${MainProductsFragmentDoc}
`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProductsQuery,
    GetProductsQueryVariables
  >
) {
  return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(
    GetProductsDocument,
    baseOptions
  );
}
export function useGetProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductsQuery,
    GetProductsQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(
    GetProductsDocument,
    baseOptions
  );
}
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<
  typeof useGetProductsLazyQuery
>;
export type GetProductsQueryResult = Apollo.QueryResult<
  GetProductsQuery,
  GetProductsQueryVariables
>;
export const AllAvailableQuizzDocument = gql`
  query AllAvailableQuizz {
    availableQuiz {
      id
      name
      debut
      fin
      quizlet
      desc
      isAnsweredByUser
    }
  }
`;

/**
 * __useAllAvailableQuizzQuery__
 *
 * To run a query within a React component, call `useAllAvailableQuizzQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAvailableQuizzQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAvailableQuizzQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAvailableQuizzQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllAvailableQuizzQuery,
    AllAvailableQuizzQueryVariables
  >
) {
  return Apollo.useQuery<
    AllAvailableQuizzQuery,
    AllAvailableQuizzQueryVariables
  >(AllAvailableQuizzDocument, baseOptions);
}
export function useAllAvailableQuizzLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllAvailableQuizzQuery,
    AllAvailableQuizzQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    AllAvailableQuizzQuery,
    AllAvailableQuizzQueryVariables
  >(AllAvailableQuizzDocument, baseOptions);
}
export type AllAvailableQuizzQueryHookResult = ReturnType<
  typeof useAllAvailableQuizzQuery
>;
export type AllAvailableQuizzLazyQueryHookResult = ReturnType<
  typeof useAllAvailableQuizzLazyQuery
>;
export type AllAvailableQuizzQueryResult = Apollo.QueryResult<
  AllAvailableQuizzQuery,
  AllAvailableQuizzQueryVariables
>;
export const AllQuizzDocument = gql`
  query AllQuizz {
    availableQuiz(all: true) {
      id
      name
      debut
      fin
    }
  }
`;

/**
 * __useAllQuizzQuery__
 *
 * To run a query within a React component, call `useAllQuizzQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllQuizzQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllQuizzQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllQuizzQuery(
  baseOptions?: Apollo.QueryHookOptions<AllQuizzQuery, AllQuizzQueryVariables>
) {
  return Apollo.useQuery<AllQuizzQuery, AllQuizzQueryVariables>(
    AllQuizzDocument,
    baseOptions
  );
}
export function useAllQuizzLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllQuizzQuery,
    AllQuizzQueryVariables
  >
) {
  return Apollo.useLazyQuery<AllQuizzQuery, AllQuizzQueryVariables>(
    AllQuizzDocument,
    baseOptions
  );
}
export type AllQuizzQueryHookResult = ReturnType<typeof useAllQuizzQuery>;
export type AllQuizzLazyQueryHookResult = ReturnType<
  typeof useAllQuizzLazyQuery
>;
export type AllQuizzQueryResult = Apollo.QueryResult<
  AllQuizzQuery,
  AllQuizzQueryVariables
>;
export const SingleQuizDocument = gql`
  query SingleQuiz($id: ID!) {
    findOneAvailableQuiz(id: $id) {
      name
      desc
      questions {
        data {
          id
          attributes {
            name
            reponse1
            reponse2
            reponse3
          }
        }
      }
    }
  }
`;

/**
 * __useSingleQuizQuery__
 *
 * To run a query within a React component, call `useSingleQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleQuizQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleQuizQuery(
  baseOptions: Apollo.QueryHookOptions<
    SingleQuizQuery,
    SingleQuizQueryVariables
  >
) {
  return Apollo.useQuery<SingleQuizQuery, SingleQuizQueryVariables>(
    SingleQuizDocument,
    baseOptions
  );
}
export function useSingleQuizLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SingleQuizQuery,
    SingleQuizQueryVariables
  >
) {
  return Apollo.useLazyQuery<SingleQuizQuery, SingleQuizQueryVariables>(
    SingleQuizDocument,
    baseOptions
  );
}
export type SingleQuizQueryHookResult = ReturnType<typeof useSingleQuizQuery>;
export type SingleQuizLazyQueryHookResult = ReturnType<
  typeof useSingleQuizLazyQuery
>;
export type SingleQuizQueryResult = Apollo.QueryResult<
  SingleQuizQuery,
  SingleQuizQueryVariables
>;
export const PointRelaisDocument = gql`
  query PointRelais($address: String, $city: String, $zipCode: String!) {
    pointRelais(address: $address, city: $city, zipCode: $zipCode) {
      ...RelaisMainInfo
    }
  }
  ${RelaisMainInfoFragmentDoc}
`;

/**
 * __usePointRelaisQuery__
 *
 * To run a query within a React component, call `usePointRelaisQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointRelaisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointRelaisQuery({
 *   variables: {
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function usePointRelaisQuery(
  baseOptions: Apollo.QueryHookOptions<
    PointRelaisQuery,
    PointRelaisQueryVariables
  >
) {
  return Apollo.useQuery<PointRelaisQuery, PointRelaisQueryVariables>(
    PointRelaisDocument,
    baseOptions
  );
}
export function usePointRelaisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PointRelaisQuery,
    PointRelaisQueryVariables
  >
) {
  return Apollo.useLazyQuery<PointRelaisQuery, PointRelaisQueryVariables>(
    PointRelaisDocument,
    baseOptions
  );
}
export type PointRelaisQueryHookResult = ReturnType<typeof usePointRelaisQuery>;
export type PointRelaisLazyQueryHookResult = ReturnType<
  typeof usePointRelaisLazyQuery
>;
export type PointRelaisQueryResult = Apollo.QueryResult<
  PointRelaisQuery,
  PointRelaisQueryVariables
>;
export const RessourcesAllByTypesDocument = gql`
  query RessourcesAllByTypes {
    challengeRessources(sort: "order:asc") {
      data {
        attributes {
          name
          subtitle
          info
          desc
          order
          ressource_type {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useRessourcesAllByTypesQuery__
 *
 * To run a query within a React component, call `useRessourcesAllByTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRessourcesAllByTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRessourcesAllByTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRessourcesAllByTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RessourcesAllByTypesQuery,
    RessourcesAllByTypesQueryVariables
  >
) {
  return Apollo.useQuery<
    RessourcesAllByTypesQuery,
    RessourcesAllByTypesQueryVariables
  >(RessourcesAllByTypesDocument, baseOptions);
}
export function useRessourcesAllByTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RessourcesAllByTypesQuery,
    RessourcesAllByTypesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    RessourcesAllByTypesQuery,
    RessourcesAllByTypesQueryVariables
  >(RessourcesAllByTypesDocument, baseOptions);
}
export type RessourcesAllByTypesQueryHookResult = ReturnType<
  typeof useRessourcesAllByTypesQuery
>;
export type RessourcesAllByTypesLazyQueryHookResult = ReturnType<
  typeof useRessourcesAllByTypesLazyQuery
>;
export type RessourcesAllByTypesQueryResult = Apollo.QueryResult<
  RessourcesAllByTypesQuery,
  RessourcesAllByTypesQueryVariables
>;
export const GetRessourcesTypesDocument = gql`
  query GetRessourcesTypes {
    findChallengeRessourceTypeWithRelatedChallengeRessources {
      id
      name
      challenge_ressources {
        name
      }
    }
  }
`;

/**
 * __useGetRessourcesTypesQuery__
 *
 * To run a query within a React component, call `useGetRessourcesTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRessourcesTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRessourcesTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRessourcesTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRessourcesTypesQuery,
    GetRessourcesTypesQueryVariables
  >
) {
  return Apollo.useQuery<
    GetRessourcesTypesQuery,
    GetRessourcesTypesQueryVariables
  >(GetRessourcesTypesDocument, baseOptions);
}
export function useGetRessourcesTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRessourcesTypesQuery,
    GetRessourcesTypesQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    GetRessourcesTypesQuery,
    GetRessourcesTypesQueryVariables
  >(GetRessourcesTypesDocument, baseOptions);
}
export type GetRessourcesTypesQueryHookResult = ReturnType<
  typeof useGetRessourcesTypesQuery
>;
export type GetRessourcesTypesLazyQueryHookResult = ReturnType<
  typeof useGetRessourcesTypesLazyQuery
>;
export type GetRessourcesTypesQueryResult = Apollo.QueryResult<
  GetRessourcesTypesQuery,
  GetRessourcesTypesQueryVariables
>;
export const FindRessourceByTypeIdDocument = gql`
  query findRessourceByTypeId($id: ID!) {
    findRessourceByTypeId(id: $id) {
      name
      desc
      subtitle
      info
      order
      ressources {
        titre
        lien
        media {
          url
        }
        type {
          nom
        }
      }
    }
  }
`;

/**
 * __useFindRessourceByTypeIdQuery__
 *
 * To run a query within a React component, call `useFindRessourceByTypeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRessourceByTypeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRessourceByTypeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindRessourceByTypeIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindRessourceByTypeIdQuery,
    FindRessourceByTypeIdQueryVariables
  >
) {
  return Apollo.useQuery<
    FindRessourceByTypeIdQuery,
    FindRessourceByTypeIdQueryVariables
  >(FindRessourceByTypeIdDocument, baseOptions);
}
export function useFindRessourceByTypeIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindRessourceByTypeIdQuery,
    FindRessourceByTypeIdQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    FindRessourceByTypeIdQuery,
    FindRessourceByTypeIdQueryVariables
  >(FindRessourceByTypeIdDocument, baseOptions);
}
export type FindRessourceByTypeIdQueryHookResult = ReturnType<
  typeof useFindRessourceByTypeIdQuery
>;
export type FindRessourceByTypeIdLazyQueryHookResult = ReturnType<
  typeof useFindRessourceByTypeIdLazyQuery
>;
export type FindRessourceByTypeIdQueryResult = Apollo.QueryResult<
  FindRessourceByTypeIdQuery,
  FindRessourceByTypeIdQueryVariables
>;
export const FindMyCommandeDocument = gql`
  query FindMyCommande($id: ID!, $numerocommande: String!, $classeId: ID!) {
    findMyCommande(
      id: $id
      numerocommande: $numerocommande
      classeId: $classeId
    ) {
      commande {
        id
        createdAt
        numerocommande
        totalttc
        fraislivraison
        prixTotal
        customerContributedToTheOng
        methodepaiement
        payment
        transactionreference
        statuspayment
        status
        client {
          ...ClientResult
        }
        commandelines {
          id
          quantite
          produit {
            id
            name
            ttcPrice
            ref
            venterebond
            media {
              url
            }
          }
        }
        user {
          firstname
          lastname
          email
          classe {
            debut
            fin
            operationid
            filliere {
              name
            }
            lycee {
              name
              academie {
                name
              }
            }
            niveau {
              name
            }
          }
        }
      }
      sherlock {
        data
        interfaceVersion
        redirectionUrl
        seal
      }
    }
  }
  ${ClientResultFragmentDoc}
`;

/**
 * __useFindMyCommandeQuery__
 *
 * To run a query within a React component, call `useFindMyCommandeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyCommandeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyCommandeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      numerocommande: // value for 'numerocommande'
 *      classeId: // value for 'classeId'
 *   },
 * });
 */
export function useFindMyCommandeQuery(
  baseOptions: Apollo.QueryHookOptions<
    FindMyCommandeQuery,
    FindMyCommandeQueryVariables
  >
) {
  return Apollo.useQuery<FindMyCommandeQuery, FindMyCommandeQueryVariables>(
    FindMyCommandeDocument,
    baseOptions
  );
}
export function useFindMyCommandeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FindMyCommandeQuery,
    FindMyCommandeQueryVariables
  >
) {
  return Apollo.useLazyQuery<FindMyCommandeQuery, FindMyCommandeQueryVariables>(
    FindMyCommandeDocument,
    baseOptions
  );
}
export type FindMyCommandeQueryHookResult = ReturnType<
  typeof useFindMyCommandeQuery
>;
export type FindMyCommandeLazyQueryHookResult = ReturnType<
  typeof useFindMyCommandeLazyQuery
>;
export type FindMyCommandeQueryResult = Apollo.QueryResult<
  FindMyCommandeQuery,
  FindMyCommandeQueryVariables
>;
export const GetShopEleveDocument = gql`
  query GetShopEleve($id: ID!, $classeId: ID!) {
    eleve(id: $id, classeId: $classeId) {
      avatar {
        media {
          url
        }
      }
      ong
      email
      firstname
      lastname
      role
      note {
        updatedAt
      }
      classe {
        debut
        fin
        operationid
        lycee {
          name
          ville
        }
      }
    }
  }
`;

/**
 * __useGetShopEleveQuery__
 *
 * To run a query within a React component, call `useGetShopEleveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopEleveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopEleveQuery({
 *   variables: {
 *      id: // value for 'id'
 *      classeId: // value for 'classeId'
 *   },
 * });
 */
export function useGetShopEleveQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShopEleveQuery,
    GetShopEleveQueryVariables
  >
) {
  return Apollo.useQuery<GetShopEleveQuery, GetShopEleveQueryVariables>(
    GetShopEleveDocument,
    baseOptions
  );
}
export function useGetShopEleveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShopEleveQuery,
    GetShopEleveQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetShopEleveQuery, GetShopEleveQueryVariables>(
    GetShopEleveDocument,
    baseOptions
  );
}
export type GetShopEleveQueryHookResult = ReturnType<
  typeof useGetShopEleveQuery
>;
export type GetShopEleveLazyQueryHookResult = ReturnType<
  typeof useGetShopEleveLazyQuery
>;
export type GetShopEleveQueryResult = Apollo.QueryResult<
  GetShopEleveQuery,
  GetShopEleveQueryVariables
>;
export const GetPublicShopDocument = gql`
  query GetPublicShop($id: ID!, $classeId: ID!) {
    shop(id: $id, classeId: $classeId, sort: "name:asc") {
      produits {
        id
        attributes {
          ...MainProducts
        }
      }
    }
  }
  ${MainProductsFragmentDoc}
`;

/**
 * __useGetPublicShopQuery__
 *
 * To run a query within a React component, call `useGetPublicShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicShopQuery({
 *   variables: {
 *      id: // value for 'id'
 *      classeId: // value for 'classeId'
 *   },
 * });
 */
export function useGetPublicShopQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicShopQuery,
    GetPublicShopQueryVariables
  >
) {
  return Apollo.useQuery<GetPublicShopQuery, GetPublicShopQueryVariables>(
    GetPublicShopDocument,
    baseOptions
  );
}
export function useGetPublicShopLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicShopQuery,
    GetPublicShopQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetPublicShopQuery, GetPublicShopQueryVariables>(
    GetPublicShopDocument,
    baseOptions
  );
}
export type GetPublicShopQueryHookResult = ReturnType<
  typeof useGetPublicShopQuery
>;
export type GetPublicShopLazyQueryHookResult = ReturnType<
  typeof useGetPublicShopLazyQuery
>;
export type GetPublicShopQueryResult = Apollo.QueryResult<
  GetPublicShopQuery,
  GetPublicShopQueryVariables
>;
export const UpdateNoteQueryDocument = gql`
  query UpdateNoteQuery($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        id
        attributes {
          notes {
            data {
              attributes {
                updatedAt
                createdAt
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateNoteQueryQuery__
 *
 * To run a query within a React component, call `useUpdateNoteQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateNoteQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateNoteQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    UpdateNoteQueryQuery,
    UpdateNoteQueryQueryVariables
  >
) {
  return Apollo.useQuery<UpdateNoteQueryQuery, UpdateNoteQueryQueryVariables>(
    UpdateNoteQueryDocument,
    baseOptions
  );
}
export function useUpdateNoteQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpdateNoteQueryQuery,
    UpdateNoteQueryQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    UpdateNoteQueryQuery,
    UpdateNoteQueryQueryVariables
  >(UpdateNoteQueryDocument, baseOptions);
}
export type UpdateNoteQueryQueryHookResult = ReturnType<
  typeof useUpdateNoteQueryQuery
>;
export type UpdateNoteQueryLazyQueryHookResult = ReturnType<
  typeof useUpdateNoteQueryLazyQuery
>;
export type UpdateNoteQueryQueryResult = Apollo.QueryResult<
  UpdateNoteQueryQuery,
  UpdateNoteQueryQueryVariables
>;
export const QueryUserAllInfoDocument = gql`
  query QueryUserAllInfo($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        id
        attributes {
          ...Account
          ...Avatar
          classes {
            data {
              attributes {
                ...Classe
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragmentDoc}
  ${AvatarFragmentDoc}
  ${ClasseFragmentDoc}
`;

/**
 * __useQueryUserAllInfoQuery__
 *
 * To run a query within a React component, call `useQueryUserAllInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryUserAllInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryUserAllInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQueryUserAllInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryUserAllInfoQuery,
    QueryUserAllInfoQueryVariables
  >
) {
  return Apollo.useQuery<QueryUserAllInfoQuery, QueryUserAllInfoQueryVariables>(
    QueryUserAllInfoDocument,
    baseOptions
  );
}
export function useQueryUserAllInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryUserAllInfoQuery,
    QueryUserAllInfoQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    QueryUserAllInfoQuery,
    QueryUserAllInfoQueryVariables
  >(QueryUserAllInfoDocument, baseOptions);
}
export type QueryUserAllInfoQueryHookResult = ReturnType<
  typeof useQueryUserAllInfoQuery
>;
export type QueryUserAllInfoLazyQueryHookResult = ReturnType<
  typeof useQueryUserAllInfoLazyQuery
>;
export type QueryUserAllInfoQueryResult = Apollo.QueryResult<
  QueryUserAllInfoQuery,
  QueryUserAllInfoQueryVariables
>;
export const QueryCacheInfoAccountDocument = gql`
  query QueryCacheInfoAccount($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        attributes {
          ...Account
        }
      }
    }
  }
  ${AccountFragmentDoc}
`;

/**
 * __useQueryCacheInfoAccountQuery__
 *
 * To run a query within a React component, call `useQueryCacheInfoAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCacheInfoAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCacheInfoAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQueryCacheInfoAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryCacheInfoAccountQuery,
    QueryCacheInfoAccountQueryVariables
  >
) {
  return Apollo.useQuery<
    QueryCacheInfoAccountQuery,
    QueryCacheInfoAccountQueryVariables
  >(QueryCacheInfoAccountDocument, baseOptions);
}
export function useQueryCacheInfoAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryCacheInfoAccountQuery,
    QueryCacheInfoAccountQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    QueryCacheInfoAccountQuery,
    QueryCacheInfoAccountQueryVariables
  >(QueryCacheInfoAccountDocument, baseOptions);
}
export type QueryCacheInfoAccountQueryHookResult = ReturnType<
  typeof useQueryCacheInfoAccountQuery
>;
export type QueryCacheInfoAccountLazyQueryHookResult = ReturnType<
  typeof useQueryCacheInfoAccountLazyQuery
>;
export type QueryCacheInfoAccountQueryResult = Apollo.QueryResult<
  QueryCacheInfoAccountQuery,
  QueryCacheInfoAccountQueryVariables
>;
export const QueryUserAccountDocument = gql`
  query QueryUserAccount($id: ID!) {
    getUserAccount(userId: $id) {
      id
      ville
      firstname
      username
      lastname
      confirmed
      tel
      email
      shop
      mdp
      avatar {
        name
        id
        media {
          url
        }
      }
      note {
        qteca
        qtepro
        qterebond
        quiz
        qtequiz
        qtevente
        nbvente
        cavente
        venterebond
        moyennegenerale
        pro
      }
      classe {
        id
        name
        operationid
        debut
        fin
        niveau {
          id
          name
        }
        filiere {
          id
          name
        }
        lycee {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useQueryUserAccountQuery__
 *
 * To run a query within a React component, call `useQueryUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryUserAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQueryUserAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryUserAccountQuery,
    QueryUserAccountQueryVariables
  >
) {
  return Apollo.useQuery<QueryUserAccountQuery, QueryUserAccountQueryVariables>(
    QueryUserAccountDocument,
    baseOptions
  );
}
export function useQueryUserAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryUserAccountQuery,
    QueryUserAccountQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    QueryUserAccountQuery,
    QueryUserAccountQueryVariables
  >(QueryUserAccountDocument, baseOptions);
}
export type QueryUserAccountQueryHookResult = ReturnType<
  typeof useQueryUserAccountQuery
>;
export type QueryUserAccountLazyQueryHookResult = ReturnType<
  typeof useQueryUserAccountLazyQuery
>;
export type QueryUserAccountQueryResult = Apollo.QueryResult<
  QueryUserAccountQuery,
  QueryUserAccountQueryVariables
>;
export const QueryUserClasseDocument = gql`
  query QueryUserClasse {
    getUserClasse {
      name
      debut
      fin
      lycee
      operationid
      id
    }
  }
`;

/**
 * __useQueryUserClasseQuery__
 *
 * To run a query within a React component, call `useQueryUserClasseQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryUserClasseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryUserClasseQuery({
 *   variables: {
 *   },
 * });
 */
export function useQueryUserClasseQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QueryUserClasseQuery,
    QueryUserClasseQueryVariables
  >
) {
  return Apollo.useQuery<QueryUserClasseQuery, QueryUserClasseQueryVariables>(
    QueryUserClasseDocument,
    baseOptions
  );
}
export function useQueryUserClasseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryUserClasseQuery,
    QueryUserClasseQueryVariables
  >
) {
  return Apollo.useLazyQuery<
    QueryUserClasseQuery,
    QueryUserClasseQueryVariables
  >(QueryUserClasseDocument, baseOptions);
}
export type QueryUserClasseQueryHookResult = ReturnType<
  typeof useQueryUserClasseQuery
>;
export type QueryUserClasseLazyQueryHookResult = ReturnType<
  typeof useQueryUserClasseLazyQuery
>;
export type QueryUserClasseQueryResult = Apollo.QueryResult<
  QueryUserClasseQuery,
  QueryUserClasseQueryVariables
>;
export const GetUserClasseDocument = gql`
  query getUserClasse($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        attributes {
          classes {
            data {
              id
              attributes {
                name
                operationid
                filliere {
                  data {
                    attributes {
                      name
                    }
                  }
                }
                lycee {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetUserClasseQuery__
 *
 * To run a query within a React component, call `useGetUserClasseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserClasseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserClasseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserClasseQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserClasseQuery,
    GetUserClasseQueryVariables
  >
) {
  return Apollo.useQuery<GetUserClasseQuery, GetUserClasseQueryVariables>(
    GetUserClasseDocument,
    baseOptions
  );
}
export function useGetUserClasseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserClasseQuery,
    GetUserClasseQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetUserClasseQuery, GetUserClasseQueryVariables>(
    GetUserClasseDocument,
    baseOptions
  );
}
export type GetUserClasseQueryHookResult = ReturnType<
  typeof useGetUserClasseQuery
>;
export type GetUserClasseLazyQueryHookResult = ReturnType<
  typeof useGetUserClasseLazyQuery
>;
export type GetUserClasseQueryResult = Apollo.QueryResult<
  GetUserClasseQuery,
  GetUserClasseQueryVariables
>;
export const GetUserOnHomeDocument = gql`
  query GetUserOnHome {
    getUserOnHome {
      id
      firstname
      lastname
      email
      role
      tel
      username
      isPairTeacher
      ong
      options {
        notifications
      }
      avatar {
        id
        name
        media {
          url
        }
      }
      classe {
        id
        debut
        fin
        lycee
        name
        operationid
      }
    }
  }
`;

/**
 * __useGetUserOnHomeQuery__
 *
 * To run a query within a React component, call `useGetUserOnHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOnHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOnHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserOnHomeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserOnHomeQuery,
    GetUserOnHomeQueryVariables
  >
) {
  return Apollo.useQuery<GetUserOnHomeQuery, GetUserOnHomeQueryVariables>(
    GetUserOnHomeDocument,
    baseOptions
  );
}
export function useGetUserOnHomeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserOnHomeQuery,
    GetUserOnHomeQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetUserOnHomeQuery, GetUserOnHomeQueryVariables>(
    GetUserOnHomeDocument,
    baseOptions
  );
}
export type GetUserOnHomeQueryHookResult = ReturnType<
  typeof useGetUserOnHomeQuery
>;
export type GetUserOnHomeLazyQueryHookResult = ReturnType<
  typeof useGetUserOnHomeLazyQuery
>;
export type GetUserOnHomeQueryResult = Apollo.QueryResult<
  GetUserOnHomeQuery,
  GetUserOnHomeQueryVariables
>;
export const GetUserOngDocument = gql`
  query GetUserOng($userId: ID!) {
    usersPermissionsUser(id: $userId) {
      data {
        id
        attributes {
          ong
        }
      }
    }
  }
`;

/**
 * __useGetUserOngQuery__
 *
 * To run a query within a React component, call `useGetUserOngQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOngQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOngQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserOngQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserOngQuery,
    GetUserOngQueryVariables
  >
) {
  return Apollo.useQuery<GetUserOngQuery, GetUserOngQueryVariables>(
    GetUserOngDocument,
    baseOptions
  );
}
export function useGetUserOngLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserOngQuery,
    GetUserOngQueryVariables
  >
) {
  return Apollo.useLazyQuery<GetUserOngQuery, GetUserOngQueryVariables>(
    GetUserOngDocument,
    baseOptions
  );
}
export type GetUserOngQueryHookResult = ReturnType<typeof useGetUserOngQuery>;
export type GetUserOngLazyQueryHookResult = ReturnType<
  typeof useGetUserOngLazyQuery
>;
export type GetUserOngQueryResult = Apollo.QueryResult<
  GetUserOngQuery,
  GetUserOngQueryVariables
>;
